// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.4 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-gray-600: oklch(44.6% 0.03 256.802);
    --color-gray-700: oklch(37.3% 0.034 259.733);
    --color-gray-800: oklch(27.8% 0.033 256.848);
    --color-gray-900: oklch(21% 0.034 264.665);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-xs: 20rem;
    --container-sm: 24rem;
    --container-md: 28rem;
    --container-lg: 32rem;
    --container-xl: 36rem;
    --container-2xl: 42rem;
    --container-3xl: 48rem;
    --container-5xl: 64rem;
    --container-6xl: 72rem;
    --container-7xl: 80rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-normal: 0em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --leading-tight: 1.25;
    --leading-snug: 1.375;
    --leading-normal: 1.5;
    --radius-xs: 0.125rem;
    --radius-sm: 4px;
    --radius-md: 8px;
    --radius-lg: 12px;
    --radius-xl: 16px;
    --radius-2xl: 24px;
    --radius-3xl: 1.5rem;
    --ease-out: cubic-bezier(0, 0, 0.2, 1);
    --animate-spin: spin 1s linear infinite;
    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --blur-md: 12px;
    --aspect-video: 16 / 9;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --color-primary-50: #e6f4ff;
    --color-primary-100: #bae0ff;
    --color-primary-300: #69b1ff;
    --color-primary-400: #4096ff;
    --color-primary-500: #1677ff;
    --color-success: #52c41a;
    --color-warning: #faad14;
    --color-error: #ff4d4f;
    --color-merchant-action: #056dff;
    --color-merchant-primary: #2b6cff;
    --color-merchant-text-primary: #171717;
    --color-merchant-text-secondary: #525866;
    --color-merchant-text-placeholder: #9ca3af;
    --color-merchant-text-tertiary: #707785;
    --color-merchant-bg-subtle: #f7f7f8;
    --color-merchant-bg-hover: #eceef2;
    --color-merchant-bg-unread: #f3f4f6;
    --color-merchant-border: #e8e9ec;
    --color-merchant-border-strong: #d8dae0;
    --color-merchant-success: #16a34a;
    --color-merchant-notification-badge: #ff3b30;
    --breakpoint-desktop: 1550px;
    --animate-fade-in: fade-in 0.3s ease-in-out;
    --animate-slide-up: slide-up 0.3s ease-out;
    --animate-slide-in-right: slide-in-right 0.35s ease-out;
    --animate-nudge-ai-thumb-spin: nudge-ai-thumb-spin 1.2s linear infinite;
    --animate-nudge-ai-upload-spin: nudge-ai-upload-spin 0.95s linear infinite;
    --animate-nudge-ai-upload-pulse: nudge-ai-upload-pulse 2.2s ease-in-out infinite;
    --animate-nudge-ai-upload-in: nudge-ai-upload-in 0.4s ease-out;
    --animate-nudge-ai-creating-twinkle: nudge-ai-creating-twinkle 3.8s linear infinite;
    --animate-nudge-ai-creating-blink: nudge-ai-creating-blink 1.6s ease-in-out infinite;
    --animate-feed-like-pop: feed-like-pop 0.5s cubic-bezier(0.22, 1, 0.36, 1);
    --animate-feed-like-burst: feed-like-burst 0.55s ease-out forwards;
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring:where(:not(iframe)) {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .\\@container-size {
    container-type: size;
  }
  .pointer-events-auto {
    pointer-events: auto;
  }
  .pointer-events-none {
    pointer-events: none;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: 0px;
  }
  .inset-\\[-35\\%\\] {
    inset: -35%;
  }
  .inset-x-0 {
    inset-inline: 0px;
  }
  .inset-x-2 {
    inset-inline: calc(var(--spacing) * 2);
  }
  .inset-y-0 {
    inset-block: 0px;
  }
  .-top-0\\.5 {
    top: calc(var(--spacing) * -0.5);
  }
  .-top-2 {
    top: calc(var(--spacing) * -2);
  }
  .-top-3 {
    top: calc(var(--spacing) * -3);
  }
  .top-\\(--header-height\\) {
    top: var(--header-height);
  }
  .top-0 {
    top: 0px;
  }
  .top-0\\.5 {
    top: calc(var(--spacing) * 0.5);
  }
  .top-1 {
    top: var(--spacing);
  }
  .top-1\\.5 {
    top: calc(var(--spacing) * 1.5);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .top-3 {
    top: calc(var(--spacing) * 3);
  }
  .top-6 {
    top: calc(var(--spacing) * 6);
  }
  .top-8 {
    top: calc(var(--spacing) * 8);
  }
  .top-9 {
    top: calc(var(--spacing) * 9);
  }
  .top-\\[-3px\\] {
    top: -3px;
  }
  .top-\\[-14px\\] {
    top: -14px;
  }
  .top-\\[-356px\\] {
    top: -356px;
  }
  .top-\\[2px\\] {
    top: 2px;
  }
  .top-\\[calc\\(100\\%\\+4px\\)\\] {
    top: calc(100% + 4px);
  }
  .top-\\[calc\\(100\\%\\+8px\\)\\] {
    top: calc(100% + 8px);
  }
  .top-\\[var\\(--header-height\\)\\] {
    top: var(--header-height);
  }
  .top-full {
    top: 100%;
  }
  .-right-0\\.5 {
    right: calc(var(--spacing) * -0.5);
  }
  .-right-2 {
    right: calc(var(--spacing) * -2);
  }
  .-right-3 {
    right: calc(var(--spacing) * -3);
  }
  .right-0 {
    right: 0px;
  }
  .right-1 {
    right: var(--spacing);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .right-3 {
    right: calc(var(--spacing) * 3);
  }
  .right-4 {
    right: calc(var(--spacing) * 4);
  }
  .right-14 {
    right: calc(var(--spacing) * 14);
  }
  .-bottom-0\\.5 {
    bottom: calc(var(--spacing) * -0.5);
  }
  .bottom-0 {
    bottom: 0px;
  }
  .bottom-2 {
    bottom: calc(var(--spacing) * 2);
  }
  .bottom-3 {
    bottom: calc(var(--spacing) * 3);
  }
  .bottom-20 {
    bottom: calc(var(--spacing) * 20);
  }
  .bottom-\\[-1px\\] {
    bottom: -1px;
  }
  .bottom-\\[14px\\] {
    bottom: 14px;
  }
  .bottom-\\[72px\\] {
    bottom: 72px;
  }
  .bottom-full {
    bottom: 100%;
  }
  .left-0 {
    left: 0px;
  }
  .left-0\\.5 {
    left: calc(var(--spacing) * 0.5);
  }
  .left-0\\.25 {
    left: calc(var(--spacing) * 0.25);
  }
  .left-1\\/2 {
    left: calc(1 / 2 * 100%);
  }
  .left-2 {
    left: calc(var(--spacing) * 2);
  }
  .left-3 {
    left: calc(var(--spacing) * 3);
  }
  .left-4 {
    left: calc(var(--spacing) * 4);
  }
  .left-5 {
    left: calc(var(--spacing) * 5);
  }
  .left-\\[-6px\\] {
    left: -6px;
  }
  .left-\\[1px\\] {
    left: 1px;
  }
  .left-\\[18px\\] {
    left: 18px;
  }
  .left-\\[24px\\] {
    left: 24px;
  }
  .left-full {
    left: 100%;
  }
  .isolate {
    isolation: isolate;
  }
  .z-0 {
    z-index: 0;
  }
  .z-1 {
    z-index: 1;
  }
  .z-2 {
    z-index: 2;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .z-60 {
    z-index: 60;
  }
  .z-70 {
    z-index: 70;
  }
  .z-80 {
    z-index: 80;
  }
  .z-90 {
    z-index: 90;
  }
  .z-\\[1\\] {
    z-index: 1;
  }
  .z-\\[2\\] {
    z-index: 2;
  }
  .z-\\[3\\] {
    z-index: 3;
  }
  .z-\\[4\\] {
    z-index: 4;
  }
  .z-\\[5\\] {
    z-index: 5;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-3 {
    grid-column: span 3 / span 3;
  }
  .col-span-full {
    grid-column: 1 / -1;
  }
  .container {
    width: 100%;
    @media (width >= 640px) {
      max-width: 640px;
    }
    @media (width >= 768px) {
      max-width: 768px;
    }
    @media (width >= 1024px) {
      max-width: 1024px;
    }
    @media (width >= 1280px) {
      max-width: 1280px;
    }
    @media (width >= 1536px) {
      max-width: 1536px;
    }
    @media (width >= 1550px) {
      max-width: 1550px;
    }
  }
  .m-0 {
    margin: 0px;
  }
  .-mx-4 {
    margin-inline: calc(var(--spacing) * -4);
  }
  .mx-3 {
    margin-inline: calc(var(--spacing) * 3);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-auto {
    margin-block: auto;
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: var(--spacing);
  }
  .mt-1\\.5 {
    margin-top: calc(var(--spacing) * 1.5);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-4\\.5 {
    margin-top: calc(var(--spacing) * 4.5);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mt-auto {
    margin-top: auto;
  }
  .-mr-\\[10px\\] {
    margin-right: calc(10px * -1);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .\\!mb-1 {
    margin-bottom: var(--spacing) !important;
  }
  .-mb-px {
    margin-bottom: -1px;
  }
  .mb-1 {
    margin-bottom: var(--spacing);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .-ml-3\\.5 {
    margin-left: calc(var(--spacing) * -3.5);
  }
  .ml-1 {
    margin-left: var(--spacing);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-auto {
    margin-left: auto;
  }
  .box-border {
    box-sizing: border-box;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .line-clamp-3 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .aspect-\\[3\\/4\\] {
    aspect-ratio: 3/4;
  }
  .aspect-\\[4\\/5\\] {
    aspect-ratio: 4/5;
  }
  .aspect-\\[199\\/211\\] {
    aspect-ratio: 199/211;
  }
  .aspect-\\[255\\/226\\] {
    aspect-ratio: 255/226;
  }
  .aspect-\\[271\\/268\\] {
    aspect-ratio: 271/268;
  }
  .aspect-square {
    aspect-ratio: 1 / 1;
  }
  .aspect-video {
    aspect-ratio: var(--aspect-video);
  }
  .size-0 {
    width: 0px;
    height: 0px;
  }
  .size-1 {
    width: var(--spacing);
    height: var(--spacing);
  }
  .size-1\\.5 {
    width: calc(var(--spacing) * 1.5);
    height: calc(var(--spacing) * 1.5);
  }
  .size-2 {
    width: calc(var(--spacing) * 2);
    height: calc(var(--spacing) * 2);
  }
  .size-2\\.5 {
    width: calc(var(--spacing) * 2.5);
    height: calc(var(--spacing) * 2.5);
  }
  .size-3 {
    width: calc(var(--spacing) * 3);
    height: calc(var(--spacing) * 3);
  }
  .size-3\\.5 {
    width: calc(var(--spacing) * 3.5);
    height: calc(var(--spacing) * 3.5);
  }
  .size-4 {
    width: calc(var(--spacing) * 4);
    height: calc(var(--spacing) * 4);
  }
  .size-4\\.5 {
    width: calc(var(--spacing) * 4.5);
    height: calc(var(--spacing) * 4.5);
  }
  .size-5 {
    width: calc(var(--spacing) * 5);
    height: calc(var(--spacing) * 5);
  }
  .size-6 {
    width: calc(var(--spacing) * 6);
    height: calc(var(--spacing) * 6);
  }
  .size-7 {
    width: calc(var(--spacing) * 7);
    height: calc(var(--spacing) * 7);
  }
  .size-7\\.5 {
    width: calc(var(--spacing) * 7.5);
    height: calc(var(--spacing) * 7.5);
  }
  .size-7\\.25 {
    width: calc(var(--spacing) * 7.25);
    height: calc(var(--spacing) * 7.25);
  }
  .size-8 {
    width: calc(var(--spacing) * 8);
    height: calc(var(--spacing) * 8);
  }
  .size-9 {
    width: calc(var(--spacing) * 9);
    height: calc(var(--spacing) * 9);
  }
  .size-10 {
    width: calc(var(--spacing) * 10);
    height: calc(var(--spacing) * 10);
  }
  .size-11 {
    width: calc(var(--spacing) * 11);
    height: calc(var(--spacing) * 11);
  }
  .size-12 {
    width: calc(var(--spacing) * 12);
    height: calc(var(--spacing) * 12);
  }
  .size-13 {
    width: calc(var(--spacing) * 13);
    height: calc(var(--spacing) * 13);
  }
  .size-14 {
    width: calc(var(--spacing) * 14);
    height: calc(var(--spacing) * 14);
  }
  .size-16 {
    width: calc(var(--spacing) * 16);
    height: calc(var(--spacing) * 16);
  }
  .size-20 {
    width: calc(var(--spacing) * 20);
    height: calc(var(--spacing) * 20);
  }
  .size-24 {
    width: calc(var(--spacing) * 24);
    height: calc(var(--spacing) * 24);
  }
  .size-35 {
    width: calc(var(--spacing) * 35);
    height: calc(var(--spacing) * 35);
  }
  .size-\\[10px\\] {
    width: 10px;
    height: 10px;
  }
  .size-\\[13px\\] {
    width: 13px;
    height: 13px;
  }
  .size-\\[18px\\] {
    width: 18px;
    height: 18px;
  }
  .size-\\[19px\\] {
    width: 19px;
    height: 19px;
  }
  .size-\\[21px\\] {
    width: 21px;
    height: 21px;
  }
  .size-\\[26px\\] {
    width: 26px;
    height: 26px;
  }
  .size-\\[30px\\] {
    width: 30px;
    height: 30px;
  }
  .size-\\[38px\\] {
    width: 38px;
    height: 38px;
  }
  .size-\\[42px\\] {
    width: 42px;
    height: 42px;
  }
  .size-\\[44px\\] {
    width: 44px;
    height: 44px;
  }
  .size-\\[50px\\] {
    width: 50px;
    height: 50px;
  }
  .size-\\[52px\\] {
    width: 52px;
    height: 52px;
  }
  .size-\\[54px\\] {
    width: 54px;
    height: 54px;
  }
  .size-\\[60px\\] {
    width: 60px;
    height: 60px;
  }
  .size-\\[72px\\] {
    width: 72px;
    height: 72px;
  }
  .size-\\[78\\%\\] {
    width: 78%;
    height: 78%;
  }
  .size-\\[90px\\] {
    width: 90px;
    height: 90px;
  }
  .size-\\[140px\\] {
    width: 140px;
    height: 140px;
  }
  .size-\\[180px\\] {
    width: 180px;
    height: 180px;
  }
  .size-\\[684px\\] {
    width: 684px;
    height: 684px;
  }
  .size-\\[var\\(--icon-lg\\)\\] {
    width: var(--icon-lg);
    height: var(--icon-lg);
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .h-0\\.5 {
    height: calc(var(--spacing) * 0.5);
  }
  .h-1 {
    height: var(--spacing);
  }
  .h-1\\.5 {
    height: calc(var(--spacing) * 1.5);
  }
  .h-2 {
    height: calc(var(--spacing) * 2);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-3\\.5 {
    height: calc(var(--spacing) * 3.5);
  }
  .h-3\\.75 {
    height: calc(var(--spacing) * 3.75);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-4\\.5 {
    height: calc(var(--spacing) * 4.5);
  }
  .h-4\\.75 {
    height: calc(var(--spacing) * 4.75);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-5\\.25 {
    height: calc(var(--spacing) * 5.25);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-6\\.5 {
    height: calc(var(--spacing) * 6.5);
  }
  .h-7 {
    height: calc(var(--spacing) * 7);
  }
  .h-8 {
    height: calc(var(--spacing) * 8);
  }
  .h-9 {
    height: calc(var(--spacing) * 9);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-11 {
    height: calc(var(--spacing) * 11);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-14 {
    height: calc(var(--spacing) * 14);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-20 {
    height: calc(var(--spacing) * 20);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-28 {
    height: calc(var(--spacing) * 28);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-36 {
    height: calc(var(--spacing) * 36);
  }
  .h-40 {
    height: calc(var(--spacing) * 40);
  }
  .h-41 {
    height: calc(var(--spacing) * 41);
  }
  .h-44 {
    height: calc(var(--spacing) * 44);
  }
  .h-45 {
    height: calc(var(--spacing) * 45);
  }
  .h-48 {
    height: calc(var(--spacing) * 48);
  }
  .h-52 {
    height: calc(var(--spacing) * 52);
  }
  .h-56 {
    height: calc(var(--spacing) * 56);
  }
  .h-64 {
    height: calc(var(--spacing) * 64);
  }
  .h-105 {
    height: calc(var(--spacing) * 105);
  }
  .h-124\\.5 {
    height: calc(var(--spacing) * 124.5);
  }
  .h-\\[8px\\] {
    height: 8px;
  }
  .h-\\[11px\\] {
    height: 11px;
  }
  .h-\\[16px\\] {
    height: 16px;
  }
  .h-\\[18px\\] {
    height: 18px;
  }
  .h-\\[20px\\] {
    height: 20px;
  }
  .h-\\[22px\\] {
    height: 22px;
  }
  .h-\\[24px\\] {
    height: 24px;
  }
  .h-\\[26px\\] {
    height: 26px;
  }
  .h-\\[42px\\] {
    height: 42px;
  }
  .h-\\[47px\\] {
    height: 47px;
  }
  .h-\\[50px\\] {
    height: 50px;
  }
  .h-\\[51px\\] {
    height: 51px;
  }
  .h-\\[52px\\] {
    height: 52px;
  }
  .h-\\[57px\\] {
    height: 57px;
  }
  .h-\\[58px\\] {
    height: 58px;
  }
  .h-\\[60px\\] {
    height: 60px;
  }
  .h-\\[62px\\] {
    height: 62px;
  }
  .h-\\[68px\\] {
    height: 68px;
  }
  .h-\\[72px\\] {
    height: 72px;
  }
  .h-\\[74px\\] {
    height: 74px;
  }
  .h-\\[78px\\] {
    height: 78px;
  }
  .h-\\[88px\\] {
    height: 88px;
  }
  .h-\\[102px\\] {
    height: 102px;
  }
  .h-\\[120px\\] {
    height: 120px;
  }
  .h-\\[124px\\] {
    height: 124px;
  }
  .h-\\[132px\\] {
    height: 132px;
  }
  .h-\\[160px\\] {
    height: 160px;
  }
  .h-\\[180px\\] {
    height: 180px;
  }
  .h-\\[186px\\] {
    height: 186px;
  }
  .h-\\[200px\\] {
    height: 200px;
  }
  .h-\\[210px\\] {
    height: 210px;
  }
  .h-\\[220px\\] {
    height: 220px;
  }
  .h-\\[230px\\] {
    height: 230px;
  }
  .h-\\[268px\\] {
    height: 268px;
  }
  .h-\\[280px\\] {
    height: 280px;
  }
  .h-\\[316px\\] {
    height: 316px;
  }
  .h-\\[328px\\] {
    height: 328px;
  }
  .h-\\[353px\\] {
    height: 353px;
  }
  .h-\\[360px\\] {
    height: 360px;
  }
  .h-\\[405px\\] {
    height: 405px;
  }
  .h-\\[418px\\] {
    height: 418px;
  }
  .h-\\[420px\\] {
    height: 420px;
  }
  .h-\\[560px\\] {
    height: 560px;
  }
  .h-\\[590px\\] {
    height: 590px;
  }
  .h-\\[calc\\(var\\(--height-feed-cover-filmstrip\\)\\+12px\\)\\] {
    height: calc(var(--height-feed-cover-filmstrip) + 12px);
  }
  .h-\\[min\\(50vh\\,420px\\)\\] {
    height: min(50vh, 420px);
  }
  .h-\\[min\\(80vh\\,860px\\)\\] {
    height: min(80vh, 860px);
  }
  .h-\\[min\\(480px\\,calc\\(100vh-64px\\)\\)\\] {
    height: min(480px, calc(100vh - 64px));
  }
  .h-\\[var\\(--header-height\\)\\] {
    height: var(--header-height);
  }
  .h-auto {
    height: auto;
  }
  .h-dvh {
    height: 100dvh;
  }
  .h-full {
    height: 100%;
  }
  .h-px {
    height: 1px;
  }
  .max-h-6 {
    max-height: calc(var(--spacing) * 6);
  }
  .max-h-45 {
    max-height: calc(var(--spacing) * 45);
  }
  .max-h-55 {
    max-height: calc(var(--spacing) * 55);
  }
  .max-h-56 {
    max-height: calc(var(--spacing) * 56);
  }
  .max-h-60 {
    max-height: calc(var(--spacing) * 60);
  }
  .max-h-\\[40vh\\] {
    max-height: 40vh;
  }
  .max-h-\\[220px\\] {
    max-height: 220px;
  }
  .max-h-\\[360px\\] {
    max-height: 360px;
  }
  .max-h-\\[calc\\(100vh-7rem\\)\\] {
    max-height: calc(100vh - 7rem);
  }
  .max-h-\\[calc\\(100vh-24px\\)\\] {
    max-height: calc(100vh - 24px);
  }
  .max-h-\\[calc\\(100vh-32px\\)\\] {
    max-height: calc(100vh - 32px);
  }
  .max-h-\\[calc\\(100vh-64px\\)\\] {
    max-height: calc(100vh - 64px);
  }
  .max-h-\\[calc\\(100vh-220px\\)\\] {
    max-height: calc(100vh - 220px);
  }
  .max-h-\\[calc\\(var\\(--height-feed-cover-stage\\)-2px\\)\\] {
    max-height: calc(var(--height-feed-cover-stage) - 2px);
  }
  .max-h-\\[min\\(60vh\\,520px\\)\\] {
    max-height: min(60vh, 520px);
  }
  .max-h-\\[min\\(68vh\\,720px\\)\\] {
    max-height: min(68vh, 720px);
  }
  .max-h-\\[min\\(480px\\,calc\\(100vh-160px\\)\\)\\] {
    max-height: min(480px, calc(100vh - 160px));
  }
  .max-h-full {
    max-height: 100%;
  }
  .min-h-0 {
    min-height: 0px;
  }
  .min-h-6 {
    min-height: calc(var(--spacing) * 6);
  }
  .min-h-7 {
    min-height: calc(var(--spacing) * 7);
  }
  .min-h-8 {
    min-height: calc(var(--spacing) * 8);
  }
  .min-h-9 {
    min-height: calc(var(--spacing) * 9);
  }
  .min-h-9\\.5 {
    min-height: calc(var(--spacing) * 9.5);
  }
  .min-h-10 {
    min-height: calc(var(--spacing) * 10);
  }
  .min-h-11 {
    min-height: calc(var(--spacing) * 11);
  }
  .min-h-14 {
    min-height: calc(var(--spacing) * 14);
  }
  .min-h-15 {
    min-height: calc(var(--spacing) * 15);
  }
  .min-h-24 {
    min-height: calc(var(--spacing) * 24);
  }
  .min-h-40 {
    min-height: calc(var(--spacing) * 40);
  }
  .min-h-\\[38px\\] {
    min-height: 38px;
  }
  .min-h-\\[44px\\] {
    min-height: 44px;
  }
  .min-h-\\[60px\\] {
    min-height: 60px;
  }
  .min-h-\\[74px\\] {
    min-height: 74px;
  }
  .min-h-\\[160px\\] {
    min-height: 160px;
  }
  .min-h-\\[168px\\] {
    min-height: 168px;
  }
  .min-h-\\[180px\\] {
    min-height: 180px;
  }
  .min-h-\\[200px\\] {
    min-height: 200px;
  }
  .min-h-\\[210px\\] {
    min-height: 210px;
  }
  .min-h-\\[240px\\] {
    min-height: 240px;
  }
  .min-h-\\[280px\\] {
    min-height: 280px;
  }
  .min-h-\\[360px\\] {
    min-height: 360px;
  }
  .min-h-\\[500px\\] {
    min-height: 500px;
  }
  .min-h-\\[calc\\(100dvh-var\\(--header-height\\)\\)\\] {
    min-height: calc(100dvh - var(--header-height));
  }
  .min-h-\\[calc\\(100vh-var\\(--header-height\\)\\)\\] {
    min-height: calc(100vh - var(--header-height));
  }
  .min-h-dvh {
    min-height: 100dvh;
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .w-0\\.5 {
    width: calc(var(--spacing) * 0.5);
  }
  .w-1\\/2 {
    width: calc(1 / 2 * 100%);
  }
  .w-2 {
    width: calc(var(--spacing) * 2);
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-3\\.5 {
    width: calc(var(--spacing) * 3.5);
  }
  .w-3\\/4 {
    width: calc(3 / 4 * 100%);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-4\\/5 {
    width: calc(4 / 5 * 100%);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-5xl {
    width: var(--container-5xl);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-7 {
    width: calc(var(--spacing) * 7);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-9 {
    width: calc(var(--spacing) * 9);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-11 {
    width: calc(var(--spacing) * 11);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-13 {
    width: calc(var(--spacing) * 13);
  }
  .w-14 {
    width: calc(var(--spacing) * 14);
  }
  .w-15 {
    width: calc(var(--spacing) * 15);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-18 {
    width: calc(var(--spacing) * 18);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-24 {
    width: calc(var(--spacing) * 24);
  }
  .w-28 {
    width: calc(var(--spacing) * 28);
  }
  .w-32 {
    width: calc(var(--spacing) * 32);
  }
  .w-36 {
    width: calc(var(--spacing) * 36);
  }
  .w-40 {
    width: calc(var(--spacing) * 40);
  }
  .w-44 {
    width: calc(var(--spacing) * 44);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-52 {
    width: calc(var(--spacing) * 52);
  }
  .w-56 {
    width: calc(var(--spacing) * 56);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-80 {
    width: calc(var(--spacing) * 80);
  }
  .w-96 {
    width: calc(var(--spacing) * 96);
  }
  .w-\\[6px\\] {
    width: 6px;
  }
  .w-\\[12\\%\\] {
    width: 12%;
  }
  .w-\\[14\\%\\] {
    width: 14%;
  }
  .w-\\[16\\%\\] {
    width: 16%;
  }
  .w-\\[16px\\] {
    width: 16px;
  }
  .w-\\[18\\%\\] {
    width: 18%;
  }
  .w-\\[22px\\] {
    width: 22px;
  }
  .w-\\[32px\\] {
    width: 32px;
  }
  .w-\\[40\\%\\] {
    width: 40%;
  }
  .w-\\[42px\\] {
    width: 42px;
  }
  .w-\\[48px\\] {
    width: 48px;
  }
  .w-\\[60\\%\\] {
    width: 60%;
  }
  .w-\\[70\\%\\] {
    width: 70%;
  }
  .w-\\[80px\\] {
    width: 80px;
  }
  .w-\\[84px\\] {
    width: 84px;
  }
  .w-\\[85\\%\\] {
    width: 85%;
  }
  .w-\\[88px\\] {
    width: 88px;
  }
  .w-\\[90\\%\\] {
    width: 90%;
  }
  .w-\\[90px\\] {
    width: 90px;
  }
  .w-\\[92px\\] {
    width: 92px;
  }
  .w-\\[120px\\] {
    width: 120px;
  }
  .w-\\[126px\\] {
    width: 126px;
  }
  .w-\\[140px\\] {
    width: 140px;
  }
  .w-\\[230px\\] {
    width: 230px;
  }
  .w-\\[240px\\] {
    width: 240px;
  }
  .w-\\[358px\\] {
    width: 358px;
  }
  .w-\\[390px\\] {
    width: 390px;
  }
  .w-\\[399px\\] {
    width: 399px;
  }
  .w-\\[402px\\] {
    width: 402px;
  }
  .w-\\[calc\\(\\(var\\(--height-feed-cover-filmstrip\\)\\+12px\\)\\*46\\/76\\)\\] {
    width: calc((var(--height-feed-cover-filmstrip) + 12px) * 46 / 76);
  }
  .w-\\[min\\(100vw-32px\\,420px\\)\\] {
    width: min(100vw - 32px, 420px);
  }
  .w-\\[min\\(100vw-32px\\,539px\\)\\] {
    width: min(100vw - 32px, 539px);
  }
  .w-\\[min\\(854px\\,calc\\(100vw-32px\\)\\)\\] {
    width: min(854px, calc(100vw - 32px));
  }
  .w-\\[min\\(880px\\,calc\\(100vh-120px\\)\\,calc\\(100vw-128px\\)\\)\\] {
    width: min(880px, calc(100vh - 120px), calc(100vw - 128px));
  }
  .w-auto {
    width: auto;
  }
  .w-fit {
    width: fit-content;
  }
  .w-full {
    width: 100%;
  }
  .w-max {
    width: max-content;
  }
  .w-px {
    width: 1px;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-3xl {
    max-width: var(--container-3xl);
  }
  .max-w-6 {
    max-width: calc(var(--spacing) * 6);
  }
  .max-w-6xl {
    max-width: var(--container-6xl);
  }
  .max-w-65 {
    max-width: calc(var(--spacing) * 65);
  }
  .max-w-75 {
    max-width: calc(var(--spacing) * 75);
  }
  .max-w-95 {
    max-width: calc(var(--spacing) * 95);
  }
  .max-w-140 {
    max-width: calc(var(--spacing) * 140);
  }
  .max-w-150 {
    max-width: calc(var(--spacing) * 150);
  }
  .max-w-225 {
    max-width: calc(var(--spacing) * 225);
  }
  .max-w-290 {
    max-width: calc(var(--spacing) * 290);
  }
  .max-w-360 {
    max-width: calc(var(--spacing) * 360);
  }
  .max-w-\\[60vw\\] {
    max-width: 60vw;
  }
  .max-w-\\[70\\%\\] {
    max-width: 70%;
  }
  .max-w-\\[85\\%\\] {
    max-width: 85%;
  }
  .max-w-\\[95vw\\] {
    max-width: 95vw;
  }
  .max-w-\\[180px\\] {
    max-width: 180px;
  }
  .max-w-\\[220px\\] {
    max-width: 220px;
  }
  .max-w-\\[240px\\] {
    max-width: 240px;
  }
  .max-w-\\[260px\\] {
    max-width: 260px;
  }
  .max-w-\\[280px\\] {
    max-width: 280px;
  }
  .max-w-\\[320px\\] {
    max-width: 320px;
  }
  .max-w-\\[360px\\] {
    max-width: 360px;
  }
  .max-w-\\[390px\\] {
    max-width: 390px;
  }
  .max-w-\\[400px\\] {
    max-width: 400px;
  }
  .max-w-\\[402px\\] {
    max-width: 402px;
  }
  .max-w-\\[420px\\] {
    max-width: 420px;
  }
  .max-w-\\[440px\\] {
    max-width: 440px;
  }
  .max-w-\\[450px\\] {
    max-width: 450px;
  }
  .max-w-\\[460px\\] {
    max-width: 460px;
  }
  .max-w-\\[481px\\] {
    max-width: 481px;
  }
  .max-w-\\[509px\\] {
    max-width: 509px;
  }
  .max-w-\\[560px\\] {
    max-width: 560px;
  }
  .max-w-\\[600px\\] {
    max-width: 600px;
  }
  .max-w-\\[620px\\] {
    max-width: 620px;
  }
  .max-w-\\[920px\\] {
    max-width: 920px;
  }
  .max-w-\\[960px\\] {
    max-width: 960px;
  }
  .max-w-\\[1120px\\] {
    max-width: 1120px;
  }
  .max-w-\\[1705px\\] {
    max-width: 1705px;
  }
  .max-w-\\[calc\\(100\\%-32px\\)\\] {
    max-width: calc(100% - 32px);
  }
  .max-w-\\[min\\(220px\\,100\\%\\)\\] {
    max-width: min(220px, 100%);
  }
  .max-w-\\[min\\(420px\\,calc\\(100\\%-320px\\)\\)\\] {
    max-width: min(420px, calc(100% - 320px));
  }
  .max-w-\\[min\\(480px\\,calc\\(100vw-48px\\)\\)\\] {
    max-width: min(480px, calc(100vw - 48px));
  }
  .max-w-\\[min\\(920px\\,100\\%\\)\\] {
    max-width: min(920px, 100%);
  }
  .max-w-\\[var\\(--width-feed-detail-modal\\)\\] {
    max-width: var(--width-feed-detail-modal);
  }
  .max-w-\\[…\\] {
    max-width: …;
  }
  .max-w-full {
    max-width: 100%;
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .max-w-none {
    max-width: none;
  }
  .max-w-sm {
    max-width: var(--container-sm);
  }
  .max-w-xl {
    max-width: var(--container-xl);
  }
  .min-w-0 {
    min-width: 0px;
  }
  .min-w-3\\.5 {
    min-width: calc(var(--spacing) * 3.5);
  }
  .min-w-5\\.5 {
    min-width: calc(var(--spacing) * 5.5);
  }
  .min-w-10 {
    min-width: calc(var(--spacing) * 10);
  }
  .min-w-11 {
    min-width: calc(var(--spacing) * 11);
  }
  .min-w-16 {
    min-width: calc(var(--spacing) * 16);
  }
  .min-w-20 {
    min-width: calc(var(--spacing) * 20);
  }
  .min-w-24 {
    min-width: calc(var(--spacing) * 24);
  }
  .min-w-28 {
    min-width: calc(var(--spacing) * 28);
  }
  .min-w-35 {
    min-width: calc(var(--spacing) * 35);
  }
  .min-w-40 {
    min-width: calc(var(--spacing) * 40);
  }
  .min-w-56 {
    min-width: calc(var(--spacing) * 56);
  }
  .min-w-60 {
    min-width: calc(var(--spacing) * 60);
  }
  .min-w-150 {
    min-width: calc(var(--spacing) * 150);
  }
  .min-w-215 {
    min-width: calc(var(--spacing) * 215);
  }
  .min-w-\\[38px\\] {
    min-width: 38px;
  }
  .min-w-\\[72px\\] {
    min-width: 72px;
  }
  .min-w-\\[98px\\] {
    min-width: 98px;
  }
  .min-w-\\[120px\\] {
    min-width: 120px;
  }
  .min-w-\\[640px\\] {
    min-width: 640px;
  }
  .min-w-\\[820px\\] {
    min-width: 820px;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-\\[1_0_0\\] {
    flex: 1 0 0;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .grow-0 {
    flex-grow: 0;
  }
  .basis-full {
    flex-basis: 100%;
  }
  .border-collapse {
    border-collapse: collapse;
  }
  .origin-top-left {
    transform-origin: 0 0;
  }
  .-translate-x-1\\/2 {
    --tw-translate-x: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-0\\.5 {
    --tw-translate-x: calc(var(--spacing) * 0.5);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .translate-x-4\\.5 {
    --tw-translate-x: calc(var(--spacing) * 4.5);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-translate-y-full {
    --tw-translate-y: -100%;
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .-scale-y-100 {
    --tw-scale-y: calc(100% * -1);
    scale: var(--tw-scale-x) var(--tw-scale-y);
  }
  .-rotate-90 {
    rotate: calc(90deg * -1);
  }
  .rotate-90 {
    rotate: 90deg;
  }
  .rotate-180 {
    rotate: 180deg;
  }
  .transform {
    transform: var(--tw-rotate-x, ) var(--tw-rotate-y, ) var(--tw-rotate-z, ) var(--tw-skew-x, ) var(--tw-skew-y, );
  }
  .animate-fade-in {
    animation: var(--animate-fade-in);
  }
  .animate-feed-like-burst {
    animation: var(--animate-feed-like-burst);
  }
  .animate-feed-like-pop {
    animation: var(--animate-feed-like-pop);
  }
  .animate-pulse {
    animation: var(--animate-pulse);
  }
  .animate-slide-in-right {
    animation: var(--animate-slide-in-right);
  }
  .animate-slide-up {
    animation: var(--animate-slide-up);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-copy {
    cursor: copy;
  }
  .cursor-default {
    cursor: default;
  }
  .cursor-ew-resize {
    cursor: ew-resize;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-wait {
    cursor: wait;
  }
  .touch-none {
    touch-action: none;
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .resize-y {
    resize: vertical;
  }
  .scroll-mt-\\[calc\\(var\\(--header-height\\)\\+7rem\\)\\] {
    scroll-margin-top: calc(var(--header-height) + 7rem);
  }
  .\\[scrollbar-width\\:none\\] {
    scrollbar-width: none;
  }
  .scrollbar-none {
    scrollbar-width: none;
  }
  .scrollbar-thin {
    scrollbar-width: thin;
  }
  .\\[scrollbar-color\\:rgba\\(255\\,255\\,255\\,0\\.45\\)_transparent\\] {
    scrollbar-color: rgba(255,255,255,0.45) transparent;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .appearance-none {
    appearance: none;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .grid-cols-\\[28px_72px_52px_minmax\\(0\\,1fr\\)_220px_auto\\] {
    grid-template-columns: 28px 72px 52px minmax(0,1fr) 220px auto;
  }
  .grid-cols-\\[28px_72px_52px_minmax\\(0\\,1fr\\)_auto\\] {
    grid-template-columns: 28px 72px 52px minmax(0,1fr) auto;
  }
  .grid-cols-\\[32px_1fr_auto\\] {
    grid-template-columns: 32px 1fr auto;
  }
  .grid-cols-\\[auto_1fr\\] {
    grid-template-columns: auto 1fr;
  }
  .grid-cols-\\[auto_minmax\\(0\\,1fr\\)\\] {
    grid-template-columns: auto minmax(0,1fr);
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .items-stretch {
    align-items: stretch;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .\\!gap-1 {
    gap: var(--spacing) !important;
  }
  .gap-\\(--gap-nudge-ai-composer\\) {
    gap: var(--gap-nudge-ai-composer);
  }
  .gap-0\\.5 {
    gap: calc(var(--spacing) * 0.5);
  }
  .gap-0\\.75 {
    gap: calc(var(--spacing) * 0.75);
  }
  .gap-1 {
    gap: var(--spacing);
  }
  .gap-1\\! {
    gap: var(--spacing) !important;
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-1\\.25 {
    gap: calc(var(--spacing) * 1.25);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-2\\.25 {
    gap: calc(var(--spacing) * 2.25);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-3\\.5 {
    gap: calc(var(--spacing) * 3.5);
  }
  .gap-3\\.75 {
    gap: calc(var(--spacing) * 3.75);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-4\\.5 {
    gap: calc(var(--spacing) * 4.5);
  }
  .gap-5 {
    gap: calc(var(--spacing) * 5);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .gap-8 {
    gap: calc(var(--spacing) * 8);
  }
  .gap-9 {
    gap: calc(var(--spacing) * 9);
  }
  .gap-12 {
    gap: calc(var(--spacing) * 12);
  }
  .gap-\\[2px\\] {
    gap: 2px;
  }
  .gap-\\[3px\\] {
    gap: 3px;
  }
  .gap-\\[5px\\] {
    gap: 5px;
  }
  .gap-\\[10px\\] {
    gap: 10px;
  }
  .gap-\\[18px\\] {
    gap: 18px;
  }
  .gap-\\[var\\(--padding-post-overlay\\)\\] {
    gap: var(--padding-post-overlay);
  }
  .gap-px {
    gap: 1px;
  }
  :where(.space-y-2 > :not(:last-child)) {
    --tw-space-y-reverse: 0;
    margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
    margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2);
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-y-1 {
    row-gap: var(--spacing);
  }
  .gap-y-1\\.5 {
    row-gap: calc(var(--spacing) * 1.5);
  }
  :where(.divide-y > :not(:last-child)) {
    --tw-divide-y-reverse: 0;
    border-bottom-style: var(--tw-border-style);
    border-top-style: var(--tw-border-style);
    border-top-width: calc(1px * var(--tw-divide-y-reverse));
    border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  }
  :where(.divide-\\[\\#f3f4f6\\] > :not(:last-child)) {
    border-color: #f3f4f6;
  }
  :where(.divide-merchant-bg-unread > :not(:last-child)) {
    border-color: var(--color-merchant-bg-unread);
  }
  .self-center {
    align-self: center;
  }
  .self-end {
    align-self: flex-end;
  }
  .self-start {
    align-self: flex-start;
  }
  .self-stretch {
    align-self: stretch;
  }
  .justify-self-end {
    justify-self: flex-end;
  }
  .justify-self-start {
    justify-self: flex-start;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-clip {
    overflow: clip;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .overflow-visible {
    overflow: visible;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overscroll-contain {
    overscroll-behavior: contain;
  }
  .\\!rounded-sm {
    border-radius: var(--radius-sm) !important;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: var(--radius-2xl);
  }
  .rounded-\\[2px\\] {
    border-radius: 2px;
  }
  .rounded-\\[3px\\] {
    border-radius: 3px;
  }
  .rounded-\\[4\\.5px\\] {
    border-radius: 4.5px;
  }
  .rounded-\\[9\\.6px\\] {
    border-radius: 9.6px;
  }
  .rounded-\\[9px\\] {
    border-radius: 9px;
  }
  .rounded-\\[10px\\] {
    border-radius: 10px;
  }
  .rounded-\\[12px\\] {
    border-radius: 12px;
  }
  .rounded-\\[18px\\] {
    border-radius: 18px;
  }
  .rounded-\\[20px\\] {
    border-radius: 20px;
  }
  .rounded-\\[27px\\] {
    border-radius: 27px;
  }
  .rounded-\\[28px\\] {
    border-radius: 28px;
  }
  .rounded-\\[40px\\] {
    border-radius: 40px;
  }
  .rounded-\\[999px\\] {
    border-radius: 999px;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .rounded-xl {
    border-radius: var(--radius-xl);
  }
  .rounded-xs {
    border-radius: var(--radius-xs);
  }
  .rounded-t-\\[7px\\] {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }
  .rounded-t-\\[20px\\] {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .rounded-t-md {
    border-top-left-radius: var(--radius-md);
    border-top-right-radius: var(--radius-md);
  }
  .rounded-l-md {
    border-top-left-radius: var(--radius-md);
    border-bottom-left-radius: var(--radius-md);
  }
  .rounded-r-md {
    border-top-right-radius: var(--radius-md);
    border-bottom-right-radius: var(--radius-md);
  }
  .rounded-b-\\[7px\\] {
    border-bottom-right-radius: 7px;
    border-bottom-left-radius: 7px;
  }
  .\\!border {
    border-style: var(--tw-border-style) !important;
    border-width: 1px !important;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-0 {
    border-style: var(--tw-border-style);
    border-width: 0px;
  }
  .border-2 {
    border-style: var(--tw-border-style);
    border-width: 2px;
  }
  .border-3 {
    border-style: var(--tw-border-style);
    border-width: 3px;
  }
  .border-4 {
    border-style: var(--tw-border-style);
    border-width: 4px;
  }
  .border-\\[0\\.8px\\] {
    border-style: var(--tw-border-style);
    border-width: 0.8px;
  }
  .border-\\[1\\.5px\\] {
    border-style: var(--tw-border-style);
    border-width: 1.5px;
  }
  .border-\\[1\\.25px\\] {
    border-style: var(--tw-border-style);
    border-width: 1.25px;
  }
  .border-\\[3px\\] {
    border-style: var(--tw-border-style);
    border-width: 3px;
  }
  .border-y {
    border-block-style: var(--tw-border-style);
    border-block-width: 1px;
  }
  .border-y-2 {
    border-block-style: var(--tw-border-style);
    border-block-width: 2px;
  }
  .border-y-\\[3\\.5px\\] {
    border-block-style: var(--tw-border-style);
    border-block-width: 3.5px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-t-\\[1\\.25px\\] {
    border-top-style: var(--tw-border-style);
    border-top-width: 1.25px;
  }
  .border-r {
    border-right-style: var(--tw-border-style);
    border-right-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .border-l-\\[5px\\] {
    border-left-style: var(--tw-border-style);
    border-left-width: 5px;
  }
  .border-dashed {
    --tw-border-style: dashed;
    border-style: dashed;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-solid {
    --tw-border-style: solid;
    border-style: solid;
  }
  .\\!border-\\[\\#E8E9EC\\] {
    border-color: #E8E9EC !important;
  }
  .\\!border-transparent {
    border-color: transparent !important;
  }
  .border-\\[\\#1c64f2\\] {
    border-color: #1c64f2;
  }
  .border-\\[\\#2b6cff\\] {
    border-color: #2b6cff;
  }
  .border-\\[\\#171717\\] {
    border-color: #171717;
  }
  .border-\\[\\#262626\\] {
    border-color: #262626;
  }
  .border-\\[\\#374151\\] {
    border-color: #374151;
  }
  .border-\\[\\#B8D2FF\\] {
    border-color: #B8D2FF;
  }
  .border-\\[\\#BBF7D0\\] {
    border-color: #BBF7D0;
  }
  .border-\\[\\#D5E2FF\\] {
    border-color: #D5E2FF;
  }
  .border-\\[\\#D8DAE0\\] {
    border-color: #D8DAE0;
  }
  .border-\\[\\#DC2626\\] {
    border-color: #DC2626;
  }
  .border-\\[\\#E6E8EC\\] {
    border-color: #E6E8EC;
  }
  .border-\\[\\#E8E9EC\\] {
    border-color: #E8E9EC;
  }
  .border-\\[\\#c2c6cf\\] {
    border-color: #c2c6cf;
  }
  .border-\\[\\#c7c7cc\\] {
    border-color: #c7c7cc;
  }
  .border-\\[\\#d1d5db\\] {
    border-color: #d1d5db;
  }
  .border-\\[\\#d8dae0\\] {
    border-color: #d8dae0;
  }
  .border-\\[\\#dc2626\\] {
    border-color: #dc2626;
  }
  .border-\\[\\#e3e3e8\\] {
    border-color: #e3e3e8;
  }
  .border-\\[\\#e5e7eb\\] {
    border-color: #e5e7eb;
  }
  .border-\\[\\#e8e9ec\\] {
    border-color: #e8e9ec;
  }
  .border-\\[\\#eceef2\\] {
    border-color: #eceef2;
  }
  .border-\\[\\#f3f4f6\\] {
    border-color: #f3f4f6;
  }
  .border-\\[\\#f7f7f8\\] {
    border-color: #f7f7f8;
  }
  .border-\\[\\#fed7aa\\] {
    border-color: #fed7aa;
  }
  .border-error {
    border-color: var(--color-error);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-merchant-action {
    border-color: var(--color-merchant-action);
  }
  .border-merchant-border {
    border-color: var(--color-merchant-border);
  }
  .border-merchant-border-strong {
    border-color: var(--color-merchant-border-strong);
  }
  .border-merchant-primary {
    border-color: var(--color-merchant-primary);
  }
  .border-merchant-success\\/30 {
    border-color: color-mix(in srgb, #16a34a 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-merchant-success) 30%, transparent);
    }
  }
  .border-merchant-text-placeholder {
    border-color: var(--color-merchant-text-placeholder);
  }
  .border-merchant-text-primary {
    border-color: var(--color-merchant-text-primary);
  }
  .border-primary-300 {
    border-color: var(--color-primary-300);
  }
  .border-primary-500 {
    border-color: var(--color-primary-500);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-white {
    border-color: var(--color-white);
  }
  .border-white\\/10 {
    border-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
  }
  .border-white\\/20 {
    border-color: color-mix(in srgb, #fff 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 20%, transparent);
    }
  }
  .border-white\\/25 {
    border-color: color-mix(in srgb, #fff 25%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 25%, transparent);
    }
  }
  .border-white\\/30 {
    border-color: color-mix(in srgb, #fff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 30%, transparent);
    }
  }
  .border-white\\/45 {
    border-color: color-mix(in srgb, #fff 45%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 45%, transparent);
    }
  }
  .border-white\\/\\[0\\.07\\] {
    border-color: color-mix(in srgb, #fff 7.000000000000001%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 7.000000000000001%, transparent);
    }
  }
  .border-y-transparent {
    border-block-color: transparent;
  }
  .border-t-merchant-text-primary {
    border-top-color: var(--color-merchant-text-primary);
  }
  .border-t-white {
    border-top-color: var(--color-white);
  }
  .border-l-white {
    border-left-color: var(--color-white);
  }
  .\\!bg-\\[\\#F3F4F6\\] {
    background-color: #F3F4F6 !important;
  }
  .\\!bg-merchant-bg-subtle {
    background-color: var(--color-merchant-bg-subtle) !important;
  }
  .bg-\\[\\#0a0a0a\\] {
    background-color: #0a0a0a;
  }
  .bg-\\[\\#0b1220\\] {
    background-color: #0b1220;
  }
  .bg-\\[\\#0f0f0f\\] {
    background-color: #0f0f0f;
  }
  .bg-\\[\\#1a1a1a\\] {
    background-color: #1a1a1a;
  }
  .bg-\\[\\#1f2937\\] {
    background-color: #1f2937;
  }
  .bg-\\[\\#2B6CFF\\] {
    background-color: #2B6CFF;
  }
  .bg-\\[\\#2b6cff\\] {
    background-color: #2b6cff;
  }
  .bg-\\[\\#34c759\\] {
    background-color: #34c759;
  }
  .bg-\\[\\#111827\\] {
    background-color: #111827;
  }
  .bg-\\[\\#121212\\] {
    background-color: #121212;
  }
  .bg-\\[\\#141414\\] {
    background-color: #141414;
  }
  .bg-\\[\\#171717\\] {
    background-color: #171717;
  }
  .bg-\\[\\#374151\\] {
    background-color: #374151;
  }
  .bg-\\[\\#525866\\] {
    background-color: #525866;
  }
  .bg-\\[\\#808080\\] {
    background-color: #808080;
  }
  .bg-\\[\\#BBF7D0\\] {
    background-color: #BBF7D0;
  }
  .bg-\\[\\#D8DAE0\\] {
    background-color: #D8DAE0;
  }
  .bg-\\[\\#D92D20\\] {
    background-color: #D92D20;
  }
  .bg-\\[\\#DC2626\\] {
    background-color: #DC2626;
  }
  .bg-\\[\\#E07A2A\\] {
    background-color: #E07A2A;
  }
  .bg-\\[\\#E53333\\] {
    background-color: #E53333;
  }
  .bg-\\[\\#EAF1FF\\] {
    background-color: #EAF1FF;
  }
  .bg-\\[\\#ECEEF2\\] {
    background-color: #ECEEF2;
  }
  .bg-\\[\\#ECFDF3\\] {
    background-color: #ECFDF3;
  }
  .bg-\\[\\#EEF4FF\\] {
    background-color: #EEF4FF;
  }
  .bg-\\[\\#EFF6FF\\] {
    background-color: #EFF6FF;
  }
  .bg-\\[\\#F2F4F7\\] {
    background-color: #F2F4F7;
  }
  .bg-\\[\\#F3F4F6\\] {
    background-color: #F3F4F6;
  }
  .bg-\\[\\#F5F9FF\\] {
    background-color: #F5F9FF;
  }
  .bg-\\[\\#F7F7F8\\] {
    background-color: #F7F7F8;
  }
  .bg-\\[\\#FEF2F2\\] {
    background-color: #FEF2F2;
  }
  .bg-\\[\\#FFF4E8\\] {
    background-color: #FFF4E8;
  }
  .bg-\\[\\#FFF7ED\\] {
    background-color: #FFF7ED;
  }
  .bg-\\[\\#c2c6cf\\] {
    background-color: #c2c6cf;
  }
  .bg-\\[\\#d1d5db\\] {
    background-color: #d1d5db;
  }
  .bg-\\[\\#d6ebff\\] {
    background-color: #d6ebff;
  }
  .bg-\\[\\#d9e7ff\\] {
    background-color: #d9e7ff;
  }
  .bg-\\[\\#d92c2c\\] {
    background-color: #d92c2c;
  }
  .bg-\\[\\#d97706\\] {
    background-color: #d97706;
  }
  .bg-\\[\\#dc2626\\] {
    background-color: #dc2626;
  }
  .bg-\\[\\#e8e9ec\\] {
    background-color: #e8e9ec;
  }
  .bg-\\[\\#eceef2\\] {
    background-color: #eceef2;
  }
  .bg-\\[\\#eef4ff\\] {
    background-color: #eef4ff;
  }
  .bg-\\[\\#ef5a5a\\] {
    background-color: #ef5a5a;
  }
  .bg-\\[\\#ef4444\\]\\/30 {
    background-color: color-mix(in oklab, #ef4444 30%, transparent);
  }
  .bg-\\[\\#f3f4f6\\] {
    background-color: #f3f4f6;
  }
  .bg-\\[\\#f5f5f5\\] {
    background-color: #f5f5f5;
  }
  .bg-\\[\\#f9fafb\\] {
    background-color: #f9fafb;
  }
  .bg-\\[\\#fff2d9\\] {
    background-color: #fff2d9;
  }
  .bg-\\[\\#fff7ed\\] {
    background-color: #fff7ed;
  }
  .bg-\\[rgba\\(0\\,0\\,0\\,0\\.5\\)\\] {
    background-color: rgba(0,0,0,0.5);
  }
  .bg-\\[rgba\\(17\\,24\\,39\\,0\\.7\\)\\] {
    background-color: rgba(17,24,39,0.7);
  }
  .bg-\\[rgba\\(17\\,24\\,39\\,0\\.55\\)\\] {
    background-color: rgba(17,24,39,0.55);
  }
  .bg-\\[rgba\\(17\\,24\\,39\\,0\\.72\\)\\] {
    background-color: rgba(17,24,39,0.72);
  }
  .bg-\\[rgba\\(17\\,24\\,39\\,0\\.75\\)\\] {
    background-color: rgba(17,24,39,0.75);
  }
  .bg-black {
    background-color: var(--color-black);
  }
  .bg-black\\/10 {
    background-color: color-mix(in srgb, #000 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 10%, transparent);
    }
  }
  .bg-black\\/24 {
    background-color: color-mix(in srgb, #000 24%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 24%, transparent);
    }
  }
  .bg-black\\/50 {
    background-color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-black\\/60 {
    background-color: color-mix(in srgb, #000 60%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 60%, transparent);
    }
  }
  .bg-error {
    background-color: var(--color-error);
  }
  .bg-gray-50 {
    background-color: var(--color-gray-50);
  }
  .bg-merchant-action {
    background-color: var(--color-merchant-action);
  }
  .bg-merchant-bg-hover {
    background-color: var(--color-merchant-bg-hover);
  }
  .bg-merchant-bg-subtle {
    background-color: var(--color-merchant-bg-subtle);
  }
  .bg-merchant-bg-subtle\\/40 {
    background-color: color-mix(in srgb, #f7f7f8 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-merchant-bg-subtle) 40%, transparent);
    }
  }
  .bg-merchant-bg-unread {
    background-color: var(--color-merchant-bg-unread);
  }
  .bg-merchant-border {
    background-color: var(--color-merchant-border);
  }
  .bg-merchant-border-strong {
    background-color: var(--color-merchant-border-strong);
  }
  .bg-merchant-primary {
    background-color: var(--color-merchant-primary);
  }
  .bg-merchant-success {
    background-color: var(--color-merchant-success);
  }
  .bg-merchant-success\\/10 {
    background-color: color-mix(in srgb, #16a34a 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-merchant-success) 10%, transparent);
    }
  }
  .bg-merchant-text-primary {
    background-color: var(--color-merchant-text-primary);
  }
  .bg-merchant-text-secondary {
    background-color: var(--color-merchant-text-secondary);
  }
  .bg-primary-50 {
    background-color: var(--color-primary-50);
  }
  .bg-primary-500 {
    background-color: var(--color-primary-500);
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-transparent\\! {
    background-color: transparent !important;
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .bg-white\\/5 {
    background-color: color-mix(in srgb, #fff 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
    }
  }
  .bg-white\\/10 {
    background-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
  }
  .bg-white\\/30 {
    background-color: color-mix(in srgb, #fff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 30%, transparent);
    }
  }
  .bg-white\\/40 {
    background-color: color-mix(in srgb, #fff 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 40%, transparent);
    }
  }
  .bg-white\\/80 {
    background-color: color-mix(in srgb, #fff 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 80%, transparent);
    }
  }
  .bg-linear-to-br {
    --tw-gradient-position: to bottom right;
    @supports (background-image: linear-gradient(in lab, red, red)) {
      --tw-gradient-position: to bottom right in oklab;
    }
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-b {
    --tw-gradient-position: to bottom in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-br {
    --tw-gradient-position: to bottom right in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-gradient-to-t {
    --tw-gradient-position: to top in oklab;
    background-image: linear-gradient(var(--tw-gradient-stops));
  }
  .bg-\\[radial-gradient\\(\\#e4e4e4_1\\.25px\\,transparent_1\\.25px\\)\\] {
    background-image: radial-gradient(#e4e4e4 1.25px,transparent 1.25px);
  }
  .from-\\[rgba\\(10\\,10\\,10\\,0\\.2\\)\\] {
    --tw-gradient-from: rgba(10,10,10,0.2);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-black\\/40 {
    --tw-gradient-from: color-mix(in srgb, #000 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-from: color-mix(in oklab, var(--color-black) 40%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-black\\/55 {
    --tw-gradient-from: color-mix(in srgb, #000 55%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-from: color-mix(in oklab, var(--color-black) 55%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-primary-50 {
    --tw-gradient-from: var(--color-primary-50);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-transparent {
    --tw-gradient-from: transparent;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-white\\/30 {
    --tw-gradient-from: color-mix(in srgb, #fff 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-from: color-mix(in oklab, var(--color-white) 30%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .from-40\\% {
    --tw-gradient-from-position: 40%;
  }
  .from-\\[6\\%\\] {
    --tw-gradient-from-position: 6%;
  }
  .via-transparent {
    --tw-gradient-via: transparent;
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-white\\/10 {
    --tw-gradient-via: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-via: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
    --tw-gradient-via-stops: var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-via) var(--tw-gradient-via-position), var(--tw-gradient-to) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-via-stops);
  }
  .via-\\[22\\%\\] {
    --tw-gradient-via-position: 22%;
  }
  .to-\\[\\#0a0a0a\\] {
    --tw-gradient-to: #0a0a0a;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-black {
    --tw-gradient-to: var(--color-black);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-black\\/80 {
    --tw-gradient-to: color-mix(in srgb, #000 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-to: color-mix(in oklab, var(--color-black) 80%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-black\\/95 {
    --tw-gradient-to: color-mix(in srgb, #000 95%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-to: color-mix(in oklab, var(--color-black) 95%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-primary-100 {
    --tw-gradient-to: var(--color-primary-100);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-transparent {
    --tw-gradient-to: transparent;
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-white {
    --tw-gradient-to: var(--color-white);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-white\\/5 {
    --tw-gradient-to: color-mix(in srgb, #fff 5%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-gradient-to: color-mix(in oklab, var(--color-white) 5%, transparent);
    }
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .to-\\[63\\%\\] {
    --tw-gradient-to-position: 63%;
  }
  .\\[background-size\\:16px_16px\\] {
    background-size: 16px 16px;
  }
  .object-contain {
    object-fit: contain;
  }
  .object-cover {
    object-fit: cover;
  }
  .object-fill {
    object-fit: fill;
  }
  .object-center {
    object-position: center;
  }
  .object-top {
    object-position: top;
  }
  .p-0 {
    padding: 0px;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: var(--spacing);
  }
  .p-1\\.5 {
    padding: calc(var(--spacing) * 1.5);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-2\\.5 {
    padding: calc(var(--spacing) * 2.5);
  }
  .p-2\\.25 {
    padding: calc(var(--spacing) * 2.25);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-3\\.75 {
    padding: calc(var(--spacing) * 3.75);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-4\\.5 {
    padding: calc(var(--spacing) * 4.5);
  }
  .p-5 {
    padding: calc(var(--spacing) * 5);
  }
  .p-6 {
    padding: calc(var(--spacing) * 6);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .p-12 {
    padding: calc(var(--spacing) * 12);
  }
  .p-\\[3px\\] {
    padding: 3px;
  }
  .p-\\[4\\.5px\\] {
    padding: 4.5px;
  }
  .p-\\[5px\\] {
    padding: 5px;
  }
  .p-\\[10px\\] {
    padding: 10px;
  }
  .p-\\[11px\\] {
    padding: 11px;
  }
  .p-\\[18px\\] {
    padding: 18px;
  }
  .p-\\[var\\(--padding-post-overlay\\)\\] {
    padding: var(--padding-post-overlay);
  }
  .p-\\[var\\(--padding-welcome-card\\)\\] {
    padding: var(--padding-welcome-card);
  }
  .p-px {
    padding: 1px;
  }
  .\\!px-2 {
    padding-inline: calc(var(--spacing) * 2) !important;
  }
  .px-\\(--space-section\\) {
    padding-inline: var(--space-section);
  }
  .px-0 {
    padding-inline: 0px;
  }
  .px-0\\.5 {
    padding-inline: calc(var(--spacing) * 0.5);
  }
  .px-1 {
    padding-inline: var(--spacing);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-1\\.75 {
    padding-inline: calc(var(--spacing) * 1.75);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-2\\.25 {
    padding-inline: calc(var(--spacing) * 2.25);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-3\\.5 {
    padding-inline: calc(var(--spacing) * 3.5);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-4\\.5 {
    padding-inline: calc(var(--spacing) * 4.5);
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .px-8 {
    padding-inline: calc(var(--spacing) * 8);
  }
  .px-12 {
    padding-inline: calc(var(--spacing) * 12);
  }
  .px-\\[3px\\] {
    padding-inline: 3px;
  }
  .px-\\[9px\\] {
    padding-inline: 9px;
  }
  .px-\\[13px\\] {
    padding-inline: 13px;
  }
  .px-\\[14px\\] {
    padding-inline: 14px;
  }
  .px-\\[15px\\] {
    padding-inline: 15px;
  }
  .px-\\[18px\\] {
    padding-inline: 18px;
  }
  .px-\\[25px\\] {
    padding-inline: 25px;
  }
  .px-\\[var\\(--content-padding\\)\\] {
    padding-inline: var(--content-padding);
  }
  .\\!py-1 {
    padding-block: var(--spacing) !important;
  }
  .py-0 {
    padding-block: 0px;
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-0\\.75 {
    padding-block: calc(var(--spacing) * 0.75);
  }
  .py-1 {
    padding-block: var(--spacing);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-2\\.5 {
    padding-block: calc(var(--spacing) * 2.5);
  }
  .py-2\\.25 {
    padding-block: calc(var(--spacing) * 2.25);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-3\\.5 {
    padding-block: calc(var(--spacing) * 3.5);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-4\\.5 {
    padding-block: calc(var(--spacing) * 4.5);
  }
  .py-6 {
    padding-block: calc(var(--spacing) * 6);
  }
  .py-7\\.5 {
    padding-block: calc(var(--spacing) * 7.5);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .py-9 {
    padding-block: calc(var(--spacing) * 9);
  }
  .py-10 {
    padding-block: calc(var(--spacing) * 10);
  }
  .py-12 {
    padding-block: calc(var(--spacing) * 12);
  }
  .py-\\[3px\\] {
    padding-block: 3px;
  }
  .py-\\[4\\.5px\\] {
    padding-block: 4.5px;
  }
  .py-\\[5px\\] {
    padding-block: 5px;
  }
  .py-\\[7px\\] {
    padding-block: 7px;
  }
  .py-\\[11px\\] {
    padding-block: 11px;
  }
  .py-\\[13\\.5px\\] {
    padding-block: 13.5px;
  }
  .py-\\[15px\\] {
    padding-block: 15px;
  }
  .py-\\[18px\\] {
    padding-block: 18px;
  }
  .py-\\[30px\\] {
    padding-block: 30px;
  }
  .py-\\[60px\\] {
    padding-block: 60px;
  }
  .pt-0\\! {
    padding-top: 0px !important;
  }
  .pt-0\\.5 {
    padding-top: calc(var(--spacing) * 0.5);
  }
  .pt-1 {
    padding-top: var(--spacing);
  }
  .pt-1\\.5 {
    padding-top: calc(var(--spacing) * 1.5);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-2\\.5 {
    padding-top: calc(var(--spacing) * 2.5);
  }
  .pt-3 {
    padding-top: calc(var(--spacing) * 3);
  }
  .pt-3\\.5 {
    padding-top: calc(var(--spacing) * 3.5);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-4\\.5 {
    padding-top: calc(var(--spacing) * 4.5);
  }
  .pt-8 {
    padding-top: calc(var(--spacing) * 8);
  }
  .pt-10 {
    padding-top: calc(var(--spacing) * 10);
  }
  .pt-11 {
    padding-top: calc(var(--spacing) * 11);
  }
  .pt-14 {
    padding-top: calc(var(--spacing) * 14);
  }
  .pt-\\[18px\\] {
    padding-top: 18px;
  }
  .pt-\\[68px\\] {
    padding-top: 68px;
  }
  .pt-\\[92px\\] {
    padding-top: 92px;
  }
  .pt-\\[98px\\] {
    padding-top: 98px;
  }
  .pr-0\\! {
    padding-right: 0px !important;
  }
  .pr-0\\.5 {
    padding-right: calc(var(--spacing) * 0.5);
  }
  .pr-1\\.5 {
    padding-right: calc(var(--spacing) * 1.5);
  }
  .pr-3 {
    padding-right: calc(var(--spacing) * 3);
  }
  .pr-4 {
    padding-right: calc(var(--spacing) * 4);
  }
  .pr-4\\.5 {
    padding-right: calc(var(--spacing) * 4.5);
  }
  .pr-5 {
    padding-right: calc(var(--spacing) * 5);
  }
  .pr-8 {
    padding-right: calc(var(--spacing) * 8);
  }
  .pr-10 {
    padding-right: calc(var(--spacing) * 10);
  }
  .pr-12 {
    padding-right: calc(var(--spacing) * 12);
  }
  .pr-16 {
    padding-right: calc(var(--spacing) * 16);
  }
  .pr-\\[18px\\] {
    padding-right: 18px;
  }
  .pr-\\[30px\\] {
    padding-right: 30px;
  }
  .pb-1 {
    padding-bottom: var(--spacing);
  }
  .pb-1\\.5 {
    padding-bottom: calc(var(--spacing) * 1.5);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pb-2\\.5 {
    padding-bottom: calc(var(--spacing) * 2.5);
  }
  .pb-2\\.25 {
    padding-bottom: calc(var(--spacing) * 2.25);
  }
  .pb-3 {
    padding-bottom: calc(var(--spacing) * 3);
  }
  .pb-3\\.5 {
    padding-bottom: calc(var(--spacing) * 3.5);
  }
  .pb-4 {
    padding-bottom: calc(var(--spacing) * 4);
  }
  .pb-4\\.5 {
    padding-bottom: calc(var(--spacing) * 4.5);
  }
  .pb-6 {
    padding-bottom: calc(var(--spacing) * 6);
  }
  .pb-10 {
    padding-bottom: calc(var(--spacing) * 10);
  }
  .pb-14 {
    padding-bottom: calc(var(--spacing) * 14);
  }
  .pb-28 {
    padding-bottom: calc(var(--spacing) * 28);
  }
  .pb-\\[7px\\] {
    padding-bottom: 7px;
  }
  .pb-\\[18px\\] {
    padding-bottom: 18px;
  }
  .pb-\\[25px\\] {
    padding-bottom: 25px;
  }
  .pb-px {
    padding-bottom: 1px;
  }
  .pl-1 {
    padding-left: var(--spacing);
  }
  .pl-2 {
    padding-left: calc(var(--spacing) * 2);
  }
  .pl-3 {
    padding-left: calc(var(--spacing) * 3);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-4\\.5 {
    padding-left: calc(var(--spacing) * 4.5);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .pl-\\[18px\\] {
    padding-left: 18px;
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .font-sans {
    font-family: var(--font-sans);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .\\!text-\\[10px\\] {
    font-size: 10px !important;
  }
  .text-\\[4px\\] {
    font-size: 4px;
  }
  .text-\\[5px\\] {
    font-size: 5px;
  }
  .text-\\[6px\\] {
    font-size: 6px;
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .text-\\[15px\\] {
    font-size: 15px;
  }
  .text-\\[16px\\] {
    font-size: 16px;
  }
  .text-\\[18px\\] {
    font-size: 18px;
  }
  .text-\\[20px\\] {
    font-size: 20px;
  }
  .text-\\[22px\\] {
    font-size: 22px;
  }
  .text-\\[24px\\] {
    font-size: 24px;
  }
  .text-\\[32px\\] {
    font-size: 32px;
  }
  .text-\\[length\\:var\\(--text-caption\\)\\] {
    font-size: var(--text-caption);
  }
  .text-\\[length\\:var\\(--text-sm\\)\\] {
    font-size: var(--text-sm);
  }
  .\\!leading-4 {
    --tw-leading: calc(var(--spacing) * 4) !important;
    line-height: calc(var(--spacing) * 4) !important;
  }
  .leading-2\\.75 {
    --tw-leading: calc(var(--spacing) * 2.75);
    line-height: calc(var(--spacing) * 2.75);
  }
  .leading-3 {
    --tw-leading: calc(var(--spacing) * 3);
    line-height: calc(var(--spacing) * 3);
  }
  .leading-3\\.5 {
    --tw-leading: calc(var(--spacing) * 3.5);
    line-height: calc(var(--spacing) * 3.5);
  }
  .leading-3\\.75 {
    --tw-leading: calc(var(--spacing) * 3.75);
    line-height: calc(var(--spacing) * 3.75);
  }
  .leading-4 {
    --tw-leading: calc(var(--spacing) * 4);
    line-height: calc(var(--spacing) * 4);
  }
  .leading-4\\.5 {
    --tw-leading: calc(var(--spacing) * 4.5);
    line-height: calc(var(--spacing) * 4.5);
  }
  .leading-5 {
    --tw-leading: calc(var(--spacing) * 5);
    line-height: calc(var(--spacing) * 5);
  }
  .leading-5\\.5 {
    --tw-leading: calc(var(--spacing) * 5.5);
    line-height: calc(var(--spacing) * 5.5);
  }
  .leading-5\\.25 {
    --tw-leading: calc(var(--spacing) * 5.25);
    line-height: calc(var(--spacing) * 5.25);
  }
  .leading-6 {
    --tw-leading: calc(var(--spacing) * 6);
    line-height: calc(var(--spacing) * 6);
  }
  .leading-7 {
    --tw-leading: calc(var(--spacing) * 7);
    line-height: calc(var(--spacing) * 7);
  }
  .leading-7\\.5 {
    --tw-leading: calc(var(--spacing) * 7.5);
    line-height: calc(var(--spacing) * 7.5);
  }
  .leading-8 {
    --tw-leading: calc(var(--spacing) * 8);
    line-height: calc(var(--spacing) * 8);
  }
  .leading-10 {
    --tw-leading: calc(var(--spacing) * 10);
    line-height: calc(var(--spacing) * 10);
  }
  .leading-\\[1\\.5\\] {
    --tw-leading: 1.5;
    line-height: 1.5;
  }
  .leading-\\[14px\\] {
    --tw-leading: 14px;
    line-height: 14px;
  }
  .leading-\\[18px\\] {
    --tw-leading: 18px;
    line-height: 18px;
  }
  .leading-\\[22px\\] {
    --tw-leading: 22px;
    line-height: 22px;
  }
  .leading-\\[26px\\] {
    --tw-leading: 26px;
    line-height: 26px;
  }
  .leading-none {
    --tw-leading: 1;
    line-height: 1;
  }
  .leading-normal {
    --tw-leading: var(--leading-normal);
    line-height: var(--leading-normal);
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .\\!font-medium {
    --tw-font-weight: var(--font-weight-medium) !important;
    font-weight: var(--font-weight-medium) !important;
  }
  .font-\\[590\\] {
    --tw-font-weight: 590;
    font-weight: 590;
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .\\!tracking-normal {
    --tw-tracking: var(--tracking-normal) !important;
    letter-spacing: var(--tracking-normal) !important;
  }
  .tracking-\\[0\\.44px\\] {
    --tw-tracking: 0.44px;
    letter-spacing: 0.44px;
  }
  .tracking-normal {
    --tw-tracking: var(--tracking-normal);
    letter-spacing: var(--tracking-normal);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .wrap-break-word {
    overflow-wrap: break-word;
  }
  .whitespace-normal {
    white-space: normal;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .\\!text-merchant-text-secondary {
    color: var(--color-merchant-text-secondary) !important;
  }
  .\\!text-white {
    color: var(--color-white) !important;
  }
  .text-\\[\\#1B2559\\] {
    color: #1B2559;
  }
  .text-\\[\\#1c64f2\\] {
    color: #1c64f2;
  }
  .text-\\[\\#2b6cff\\] {
    color: #2b6cff;
  }
  .text-\\[\\#4A5160\\] {
    color: #4A5160;
  }
  .text-\\[\\#6b7280\\] {
    color: #6b7280;
  }
  .text-\\[\\#16A34A\\] {
    color: #16A34A;
  }
  .text-\\[\\#056DFF\\] {
    color: #056DFF;
  }
  .text-\\[\\#666\\] {
    color: #666;
  }
  .text-\\[\\#050505\\] {
    color: #050505;
  }
  .text-\\[\\#067647\\] {
    color: #067647;
  }
  .text-\\[\\#111827\\] {
    color: #111827;
  }
  .text-\\[\\#171717\\] {
    color: #171717;
  }
  .text-\\[\\#303030\\] {
    color: #303030;
  }
  .text-\\[\\#374151\\] {
    color: #374151;
  }
  .text-\\[\\#525866\\] {
    color: #525866;
  }
  .text-\\[\\#666666\\] {
    color: #666666;
  }
  .text-\\[\\#667085\\] {
    color: #667085;
  }
  .text-\\[\\#707785\\] {
    color: #707785;
  }
  .text-\\[\\#808080\\] {
    color: #808080;
  }
  .text-\\[\\#999999\\] {
    color: #999999;
  }
  .text-\\[\\#D92D20\\] {
    color: #D92D20;
  }
  .text-\\[\\#D97706\\] {
    color: #D97706;
  }
  .text-\\[\\#DC2626\\] {
    color: #DC2626;
  }
  .text-\\[\\#E07A2A\\] {
    color: #E07A2A;
  }
  .text-\\[\\#E53333\\] {
    color: #E53333;
  }
  .text-\\[\\#b3b3b3\\] {
    color: #b3b3b3;
  }
  .text-\\[\\#c2c6cf\\] {
    color: #c2c6cf;
  }
  .text-\\[\\#c2410c\\] {
    color: #c2410c;
  }
  .text-\\[\\#ccc\\] {
    color: #ccc;
  }
  .text-\\[\\#d97706\\] {
    color: #d97706;
  }
  .text-\\[\\#dc2626\\] {
    color: #dc2626;
  }
  .text-\\[\\#e6e6e6\\] {
    color: #e6e6e6;
  }
  .text-\\[\\#ef5a5a\\] {
    color: #ef5a5a;
  }
  .text-\\[\\#f5f5f5\\] {
    color: #f5f5f5;
  }
  .text-\\[\\#f7f7f8\\] {
    color: #f7f7f8;
  }
  .text-black {
    color: var(--color-black);
  }
  .text-error {
    color: var(--color-error);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-gray-600 {
    color: var(--color-gray-600);
  }
  .text-gray-700 {
    color: var(--color-gray-700);
  }
  .text-gray-900 {
    color: var(--color-gray-900);
  }
  .text-merchant-action {
    color: var(--color-merchant-action);
  }
  .text-merchant-primary {
    color: var(--color-merchant-primary);
  }
  .text-merchant-success {
    color: var(--color-merchant-success);
  }
  .text-merchant-text-placeholder {
    color: var(--color-merchant-text-placeholder);
  }
  .text-merchant-text-primary {
    color: var(--color-merchant-text-primary);
  }
  .text-merchant-text-secondary {
    color: var(--color-merchant-text-secondary);
  }
  .text-merchant-text-secondary\\/40 {
    color: color-mix(in srgb, #525866 40%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-merchant-text-secondary) 40%, transparent);
    }
  }
  .text-merchant-text-tertiary {
    color: var(--color-merchant-text-tertiary);
  }
  .text-success {
    color: var(--color-success);
  }
  .text-warning {
    color: var(--color-warning);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-white\\/50 {
    color: color-mix(in srgb, #fff 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-white) 50%, transparent);
    }
  }
  .capitalize {
    text-transform: capitalize;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal, ) var(--tw-slashed-zero, ) var(--tw-numeric-figure, ) var(--tw-numeric-spacing, ) var(--tw-numeric-fraction, );
  }
  .line-through {
    text-decoration-line: line-through;
  }
  .underline {
    text-decoration-line: underline;
  }
  .underline-offset-2 {
    text-underline-offset: 2px;
  }
  .accent-merchant-action {
    accent-color: var(--color-merchant-action);
  }
  .accent-merchant-primary {
    accent-color: var(--color-merchant-primary);
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-20 {
    opacity: 20%;
  }
  .opacity-30 {
    opacity: 30%;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-80 {
    opacity: 80%;
  }
  .opacity-90 {
    opacity: 90%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px var(--tw-shadow-color, rgb(0 0 0 / 0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[-8px_0_12px_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-shadow: -8px 0 12px var(--tw-shadow-color, rgba(0,0,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[-8px_0_24px_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-shadow: -8px 0 24px var(--tw-shadow-color, rgba(0,0,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_1px_2px_rgba\\(17\\,24\\,39\\,0\\.08\\)\\] {
    --tw-shadow: 0 1px 2px var(--tw-shadow-color, rgba(17,24,39,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_1px_2px_rgba\\(23\\,23\\,23\\,0\\.06\\)\\] {
    --tw-shadow: 0 1px 2px var(--tw-shadow-color, rgba(23,23,23,0.06));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_4px_6px_-4px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\,0_10px_15px_-3px_rgba\\(0\\,0\\,0\\,0\\.1\\)\\] {
    --tw-shadow: 0 4px 6px -4px var(--tw-shadow-color, rgba(0,0,0,0.1)), 0 10px 15px -3px var(--tw-shadow-color, rgba(0,0,0,0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_4px_12px_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-shadow: 0 4px 12px var(--tw-shadow-color, rgba(0,0,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_4px_40px_0_rgba\\(0\\,17\\,33\\,0\\.04\\)\\,-10px_12px_40px_0_rgba\\(0\\,0\\,0\\,0\\.04\\)\\] {
    --tw-shadow: 0 4px 40px 0 var(--tw-shadow-color, rgba(0,17,33,0.04)), -10px 12px 40px 0 var(--tw-shadow-color, rgba(0,0,0,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_4px_40px_1px_rgba\\(0\\,17\\,33\\,0\\.04\\)\\,-10px_12px_40px_1px_rgba\\(0\\,0\\,0\\,0\\.04\\)\\] {
    --tw-shadow: 0 4px 40px 1px var(--tw-shadow-color, rgba(0,17,33,0.04)), -10px 12px 40px 1px var(--tw-shadow-color, rgba(0,0,0,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_12px_24px_rgba\\(17\\,24\\,39\\,0\\.12\\)\\] {
    --tw-shadow: 0 12px 24px var(--tw-shadow-color, rgba(17,24,39,0.12));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_12px_32px_0_rgba\\(0\\,0\\,0\\,0\\.08\\)\\] {
    --tw-shadow: 0 12px 32px 0 var(--tw-shadow-color, rgba(0,0,0,0.08));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0_12px_32px_0_rgba\\(0\\,0\\,0\\,0\\.16\\)\\] {
    --tw-shadow: 0 12px 32px 0 var(--tw-shadow-color, rgba(0,0,0,0.16));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_0px_0px_1px_rgba\\(17\\,24\\,39\\,0\\.35\\)\\,0px_6px_16px_0px_rgba\\(17\\,24\\,39\\,0\\.35\\)\\] {
    --tw-shadow: 0px 0px 0px 1px var(--tw-shadow-color, rgba(17,24,39,0.35)), 0px 6px 16px 0px var(--tw-shadow-color, rgba(17,24,39,0.35));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_0px_4px_0px_rgba\\(0\\,0\\,0\\,0\\.2\\)\\] {
    --tw-shadow: 0px 0px 4px 0px var(--tw-shadow-color, rgba(0,0,0,0.2));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_1px_2px_0px_rgba\\(17\\,24\\,39\\,0\\.08\\)\\,0px_0px_0px_1px_\\#e5e7eb\\] {
    --tw-shadow: 0px 1px 2px 0px var(--tw-shadow-color, rgba(17,24,39,0.08)), 0px 0px 0px 1px var(--tw-shadow-color, #e5e7eb);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_16px_0px_rgba\\(0\\,17\\,33\\,0\\.16\\)\\] {
    --tw-shadow: 0px 4px 16px 0px var(--tw-shadow-color, rgba(0,17,33,0.16));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_4px_40px_0px_rgba\\(0\\,17\\,33\\,0\\.04\\)\\,-10px_12px_40px_0px_rgba\\(0\\,0\\,0\\,0\\.04\\)\\] {
    --tw-shadow: 0px 4px 40px 0px var(--tw-shadow-color, rgba(0,17,33,0.04)), -10px 12px 40px 0px var(--tw-shadow-color, rgba(0,0,0,0.04));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[0px_24px_48px_0px_rgba\\(17\\,24\\,39\\,0\\.24\\)\\] {
    --tw-shadow: 0px 24px 48px 0px var(--tw-shadow-color, rgba(17,24,39,0.24));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-\\[inset_0_1px_1px_rgba\\(255\\,255\\,255\\,0\\.45\\)\\,inset_0_-1px_2px_rgba\\(0\\,0\\,0\\,0\\.2\\)\\,0_4px_12px_rgba\\(0\\,0\\,0\\,0\\.25\\)\\] {
    --tw-shadow: inset 0 1px 1px var(--tw-shadow-color, rgba(255,255,255,0.45)), inset 0 -1px 2px var(--tw-shadow-color, rgba(0,0,0,0.2)), 0 4px 12px var(--tw-shadow-color, rgba(0,0,0,0.25));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-md {
    --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-none {
    --tw-shadow: 0 0 #0000;
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-sm {
    --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-2 {
    --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring-merchant-primary {
    --tw-ring-color: var(--color-merchant-primary);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .brightness-0 {
    --tw-brightness: brightness(0%);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .drop-shadow-\\[0_1px_2px_rgba\\(0\\,0\\,0\\,0\\.4\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgba(0,0,0,0.4)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .drop-shadow-\\[0_1px_2px_rgba\\(0\\,0\\,0\\,0\\.45\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgba(0,0,0,0.45)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .drop-shadow-\\[0_1px_2px_rgba\\(17\\,24\\,39\\,0\\.6\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0 1px 2px var(--tw-drop-shadow-color, rgba(17,24,39,0.6)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .drop-shadow-\\[0_1px_3px_rgba\\(0\\,0\\,0\\,0\\.55\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0 1px 3px var(--tw-drop-shadow-color, rgba(0,0,0,0.55)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .drop-shadow-\\[0_1px_3px_rgba\\(17\\,24\\,39\\,0\\.55\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0 1px 3px var(--tw-drop-shadow-color, rgba(17,24,39,0.55)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .drop-shadow-\\[0_24px_48px_rgba\\(23\\,23\\,23\\,0\\.32\\)\\] {
    --tw-drop-shadow-size: drop-shadow(0 24px 48px var(--tw-drop-shadow-color, rgba(23,23,23,0.32)));
    --tw-drop-shadow: var(--tw-drop-shadow-size);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .filter {
    filter: var(--tw-blur, ) var(--tw-brightness, ) var(--tw-contrast, ) var(--tw-grayscale, ) var(--tw-hue-rotate, ) var(--tw-invert, ) var(--tw-saturate, ) var(--tw-sepia, ) var(--tw-drop-shadow, );
  }
  .backdrop-blur-\\[2px\\] {
    --tw-backdrop-blur: blur(2px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
  }
  .backdrop-blur-\\[3\\.636px\\] {
    --tw-backdrop-blur: blur(3.636px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
  }
  .backdrop-blur-\\[5px\\] {
    --tw-backdrop-blur: blur(5px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
  }
  .backdrop-blur-\\[10px\\] {
    --tw-backdrop-blur: blur(10px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
  }
  .backdrop-blur-\\[50px\\] {
    --tw-backdrop-blur: blur(50px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
  }
  .backdrop-blur-md {
    --tw-backdrop-blur: blur(var(--blur-md));
    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
  }
  .backdrop-saturate-150 {
    --tw-backdrop-saturate: saturate(150%);
    -webkit-backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
    backdrop-filter: var(--tw-backdrop-blur, ) var(--tw-backdrop-brightness, ) var(--tw-backdrop-contrast, ) var(--tw-backdrop-grayscale, ) var(--tw-backdrop-hue-rotate, ) var(--tw-backdrop-invert, ) var(--tw-backdrop-opacity, ) var(--tw-backdrop-saturate, ) var(--tw-backdrop-sepia, );
  }
  .transition-\\[width\\] {
    transition-property: width;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-all {
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-transform {
    transition-property: transform, translate, scale, rotate;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-150 {
    --tw-duration: 150ms;
    transition-duration: 150ms;
  }
  .duration-200 {
    --tw-duration: 200ms;
    transition-duration: 200ms;
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .ease-out {
    --tw-ease: var(--ease-out);
    transition-timing-function: var(--ease-out);
  }
  .\\!outline-none {
    --tw-outline-style: none !important;
    outline-style: none !important;
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .\\[-ms-overflow-style\\:none\\] {
    -ms-overflow-style: none;
  }
  .\\[text-shadow\\:0_0_10px_rgba\\(0\\,0\\,0\\,0\\.25\\)\\] {
    text-shadow: 0 0 10px rgba(0,0,0,0.25);
  }
  .ring-inset {
    --tw-ring-inset: inset;
  }
  :is(:where(.group):focus-within .group-focus-within\\:opacity-100) {
    opacity: 100%;
  }
  @media (hover: hover) {
    :is(:where(.group):hover .group-hover\\:z-10) {
      z-index: 10;
    }
    :is(:where(.group):hover .group-hover\\:scale-125) {
      --tw-scale-x: 125%;
      --tw-scale-y: 125%;
      --tw-scale-z: 125%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
    :is(:where(.group):hover .group-hover\\:bg-\\[\\#F3F4F6\\]) {
      background-color: #F3F4F6;
    }
    :is(:where(.group):hover .group-hover\\:opacity-0) {
      opacity: 0%;
    }
    :is(:where(.group):hover .group-hover\\:opacity-100) {
      opacity: 100%;
    }
  }
  :is(:where(.group):focus-visible .group-focus-visible\\:opacity-0) {
    opacity: 0%;
  }
  :is(:where(.group):focus-visible .group-focus-visible\\:opacity-100) {
    opacity: 100%;
  }
  .placeholder\\:text-\\[\\#9ca3af\\]::placeholder {
    color: #9ca3af;
  }
  .placeholder\\:text-\\[\\#707785\\]::placeholder {
    color: #707785;
  }
  .placeholder\\:text-\\[\\#c2c6cf\\]::placeholder {
    color: #c2c6cf;
  }
  .placeholder\\:text-merchant-text-placeholder::placeholder {
    color: var(--color-merchant-text-placeholder);
  }
  .placeholder\\:text-merchant-text-secondary::placeholder {
    color: var(--color-merchant-text-secondary);
  }
  .placeholder\\:opacity-80::placeholder {
    opacity: 80%;
  }
  .first\\:pl-0:first-child {
    padding-left: 0px;
  }
  .last\\:border-b-0:last-child {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0px;
  }
  .last\\:pr-0:last-child {
    padding-right: 0px;
  }
  .read-only\\:cursor-default:read-only {
    cursor: default;
  }
  .focus-within\\:border:focus-within {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .focus-within\\:border-merchant-action:focus-within {
    border-color: var(--color-merchant-action);
  }
  .focus-within\\:border-merchant-primary:focus-within {
    border-color: var(--color-merchant-primary);
  }
  .focus-within\\:ring-1:focus-within {
    --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-within\\:ring-merchant-action:focus-within {
    --tw-ring-color: var(--color-merchant-action);
  }
  @media (hover: hover) {
    .hover\\:scale-105:hover {
      --tw-scale-x: 105%;
      --tw-scale-y: 105%;
      --tw-scale-z: 105%;
      scale: var(--tw-scale-x) var(--tw-scale-y);
    }
    .hover\\:border-merchant-action:hover {
      border-color: var(--color-merchant-action);
    }
    .hover\\:border-merchant-border-strong:hover {
      border-color: var(--color-merchant-border-strong);
    }
    .hover\\:border-primary-300:hover {
      border-color: var(--color-primary-300);
    }
    .hover\\:bg-\\[\\#ECEEF2\\]:hover {
      background-color: #ECEEF2;
    }
    .hover\\:bg-\\[\\#FDEEEE\\]:hover {
      background-color: #FDEEEE;
    }
    .hover\\:bg-\\[\\#eef4ff\\]:hover {
      background-color: #eef4ff;
    }
    .hover\\:bg-black\\/80:hover {
      background-color: color-mix(in srgb, #000 80%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-black\\/80:hover {
        background-color: color-mix(in oklab, var(--color-black) 80%, transparent);
      }
    }
    .hover\\:bg-gray-100:hover {
      background-color: var(--color-gray-100);
    }
    .hover\\:bg-merchant-action:hover {
      background-color: var(--color-merchant-action);
    }
    .hover\\:bg-merchant-bg-hover:hover {
      background-color: var(--color-merchant-bg-hover);
    }
    .hover\\:bg-merchant-bg-subtle:hover {
      background-color: var(--color-merchant-bg-subtle);
    }
    .hover\\:bg-primary-50:hover {
      background-color: var(--color-primary-50);
    }
    .hover\\:bg-white:hover {
      background-color: var(--color-white);
    }
    .hover\\:bg-white\\/20:hover {
      background-color: color-mix(in srgb, #fff 20%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-white\\/20:hover {
        background-color: color-mix(in oklab, var(--color-white) 20%, transparent);
      }
    }
    .hover\\:bg-white\\/70:hover {
      background-color: color-mix(in srgb, #fff 70%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .hover\\:bg-white\\/70:hover {
        background-color: color-mix(in oklab, var(--color-white) 70%, transparent);
      }
    }
    .hover\\:text-merchant-text-primary:hover {
      color: var(--color-merchant-text-primary);
    }
    .hover\\:text-merchant-text-secondary:hover {
      color: var(--color-merchant-text-secondary);
    }
    .hover\\:text-white:hover {
      color: var(--color-white);
    }
    .hover\\:underline:hover {
      text-decoration-line: underline;
    }
    .hover\\:opacity-70:hover {
      opacity: 70%;
    }
    .hover\\:opacity-75:hover {
      opacity: 75%;
    }
    .hover\\:opacity-80:hover {
      opacity: 80%;
    }
    .hover\\:opacity-85:hover {
      opacity: 85%;
    }
    .hover\\:opacity-90:hover {
      opacity: 90%;
    }
    .hover\\:shadow-md:hover {
      --tw-shadow: 0 4px 6px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 2px 4px -2px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:border-merchant-action:focus {
    border-color: var(--color-merchant-action);
  }
  .focus\\:border-merchant-primary:focus {
    border-color: var(--color-merchant-primary);
  }
  .focus\\:ring-1:focus {
    --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus\\:ring-merchant-action:focus {
    --tw-ring-color: var(--color-merchant-action);
  }
  .focus\\:outline-none:focus {
    --tw-outline-style: none;
    outline-style: none;
  }
  .focus-visible\\:bg-\\[\\#eef4ff\\]:focus-visible {
    background-color: #eef4ff;
  }
  .focus-visible\\:bg-merchant-bg-subtle:focus-visible {
    background-color: var(--color-merchant-bg-subtle);
  }
  .focus-visible\\:ring-2:focus-visible {
    --tw-ring-shadow: var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .focus-visible\\:ring-merchant-action:focus-visible {
    --tw-ring-color: var(--color-merchant-action);
  }
  .focus-visible\\:ring-merchant-primary:focus-visible {
    --tw-ring-color: var(--color-merchant-primary);
  }
  .focus-visible\\:ring-primary-500:focus-visible {
    --tw-ring-color: var(--color-primary-500);
  }
  .focus-visible\\:ring-offset-1:focus-visible {
    --tw-ring-offset-width: 1px;
    --tw-ring-offset-shadow: var(--tw-ring-inset, ) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .focus-visible\\:ring-offset-2:focus-visible {
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset, ) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  }
  .focus-visible\\:outline-none:focus-visible {
    --tw-outline-style: none;
    outline-style: none;
  }
  .disabled\\:cursor-default:disabled {
    cursor: default;
  }
  .disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed;
  }
  .disabled\\:bg-\\[\\#c2c6cf\\]:disabled {
    background-color: #c2c6cf;
  }
  .disabled\\:no-underline:disabled {
    text-decoration-line: none;
  }
  .disabled\\:opacity-40:disabled {
    opacity: 40%;
  }
  .disabled\\:opacity-50:disabled {
    opacity: 50%;
  }
  .disabled\\:opacity-60:disabled {
    opacity: 60%;
  }
  .disabled\\:opacity-70:disabled {
    opacity: 70%;
  }
  .disabled\\:opacity-100:disabled {
    opacity: 100%;
  }
  @media (hover: hover) {
    .disabled\\:hover\\:bg-transparent:disabled:hover {
      background-color: transparent;
    }
    .disabled\\:hover\\:bg-white:disabled:hover {
      background-color: var(--color-white);
    }
    .disabled\\:hover\\:no-underline:disabled:hover {
      text-decoration-line: none;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .motion-reduce\\:animate-none {
      animation: none;
    }
  }
  @media (width < 1440px) {
    .max-\\[1440px\\]\\:max-w-\\[500px\\] {
      max-width: 500px;
    }
    .max-\\[1440px\\]\\:pr-6 {
      padding-right: calc(var(--spacing) * 6);
    }
    .max-\\[1440px\\]\\:pl-\\[24px\\] {
      padding-left: 24px;
    }
  }
  @media (width < 1280px) {
    .max-xl\\:flex-col {
      flex-direction: column;
    }
  }
  @media (width < 1024px) {
    .max-lg\\:flex-col {
      flex-direction: column;
    }
    .max-lg\\:border-b {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 1px;
    }
    .max-lg\\:border-merchant-border {
      border-color: var(--color-merchant-border);
    }
  }
  @media (width >= 640px) {
    .sm\\:mt-4 {
      margin-top: calc(var(--spacing) * 4);
    }
    .sm\\:mb-4 {
      margin-bottom: calc(var(--spacing) * 4);
    }
    .sm\\:inline {
      display: inline;
    }
    .sm\\:h-20 {
      height: calc(var(--spacing) * 20);
    }
    .sm\\:h-36 {
      height: calc(var(--spacing) * 36);
    }
    .sm\\:max-w-68 {
      max-width: calc(var(--spacing) * 68);
    }
    .sm\\:max-w-\\[280px\\] {
      max-width: 280px;
    }
    .sm\\:max-w-lg {
      max-width: var(--container-lg);
    }
    .sm\\:max-w-sm {
      max-width: var(--container-sm);
    }
    .sm\\:max-w-xs {
      max-width: var(--container-xs);
    }
    .sm\\:flex-1 {
      flex: 1;
    }
    .sm\\:grid-cols-1 {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .sm\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .sm\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .sm\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .sm\\:flex-row {
      flex-direction: row;
    }
    .sm\\:items-center {
      align-items: center;
    }
    .sm\\:items-start {
      align-items: flex-start;
    }
    .sm\\:justify-between {
      justify-content: space-between;
    }
    .sm\\:justify-end {
      justify-content: flex-end;
    }
    .sm\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .sm\\:gap-4 {
      gap: calc(var(--spacing) * 4);
    }
    .sm\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
    .sm\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .sm\\:py-8 {
      padding-block: calc(var(--spacing) * 8);
    }
    .sm\\:py-12 {
      padding-block: calc(var(--spacing) * 12);
    }
    .sm\\:text-left {
      text-align: left;
    }
    .sm\\:text-base {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    .sm\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .sm\\:text-xl {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  @media (width >= 768px) {
    .md\\:-top-3 {
      top: calc(var(--spacing) * -3);
    }
    .md\\:-right-3 {
      right: calc(var(--spacing) * -3);
    }
    .md\\:right-16 {
      right: calc(var(--spacing) * 16);
    }
    .md\\:bottom-4 {
      bottom: calc(var(--spacing) * 4);
    }
    .md\\:mx-3\\.75 {
      margin-inline: calc(var(--spacing) * 3.75);
    }
    .md\\:-mr-\\[13px\\] {
      margin-right: calc(13px * -1);
    }
    .md\\:mr-3 {
      margin-right: calc(var(--spacing) * 3);
    }
    .md\\:block {
      display: block;
    }
    .md\\:hidden {
      display: none;
    }
    .md\\:inline {
      display: inline;
    }
    .md\\:size-2 {
      width: calc(var(--spacing) * 2);
      height: calc(var(--spacing) * 2);
    }
    .md\\:size-3 {
      width: calc(var(--spacing) * 3);
      height: calc(var(--spacing) * 3);
    }
    .md\\:size-3\\.5 {
      width: calc(var(--spacing) * 3.5);
      height: calc(var(--spacing) * 3.5);
    }
    .md\\:size-3\\.75 {
      width: calc(var(--spacing) * 3.75);
      height: calc(var(--spacing) * 3.75);
    }
    .md\\:size-4 {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
    .md\\:size-4\\.5 {
      width: calc(var(--spacing) * 4.5);
      height: calc(var(--spacing) * 4.5);
    }
    .md\\:size-6 {
      width: calc(var(--spacing) * 6);
      height: calc(var(--spacing) * 6);
    }
    .md\\:size-8 {
      width: calc(var(--spacing) * 8);
      height: calc(var(--spacing) * 8);
    }
    .md\\:size-9 {
      width: calc(var(--spacing) * 9);
      height: calc(var(--spacing) * 9);
    }
    .md\\:size-10 {
      width: calc(var(--spacing) * 10);
      height: calc(var(--spacing) * 10);
    }
    .md\\:size-11 {
      width: calc(var(--spacing) * 11);
      height: calc(var(--spacing) * 11);
    }
    .md\\:size-12 {
      width: calc(var(--spacing) * 12);
      height: calc(var(--spacing) * 12);
    }
    .md\\:size-\\[15px\\] {
      width: 15px;
      height: 15px;
    }
    .md\\:size-\\[22px\\] {
      width: 22px;
      height: 22px;
    }
    .md\\:size-\\[30px\\] {
      width: 30px;
      height: 30px;
    }
    .md\\:size-\\[33px\\] {
      width: 33px;
      height: 33px;
    }
    .md\\:size-\\[42px\\] {
      width: 42px;
      height: 42px;
    }
    .md\\:size-\\[45px\\] {
      width: 45px;
      height: 45px;
    }
    .md\\:size-\\[60px\\] {
      width: 60px;
      height: 60px;
    }
    .md\\:size-\\[66px\\] {
      width: 66px;
      height: 66px;
    }
    .md\\:size-\\[72px\\] {
      width: 72px;
      height: 72px;
    }
    .md\\:size-\\[90px\\] {
      width: 90px;
      height: 90px;
    }
    .md\\:size-\\[210px\\] {
      width: 210px;
      height: 210px;
    }
    .min-\\[768px\\]\\:size-\\[60px\\] {
      width: 60px;
      height: 60px;
    }
    .md\\:h-3 {
      height: calc(var(--spacing) * 3);
    }
    .md\\:h-5 {
      height: calc(var(--spacing) * 5);
    }
    .md\\:h-9 {
      height: calc(var(--spacing) * 9);
    }
    .md\\:h-\\[15px\\] {
      height: 15px;
    }
    .md\\:h-\\[33px\\] {
      height: 33px;
    }
    .md\\:h-\\[60px\\] {
      height: 60px;
    }
    .md\\:h-\\[76px\\] {
      height: 76px;
    }
    .md\\:h-\\[90px\\] {
      height: 90px;
    }
    .md\\:h-\\[120px\\] {
      height: 120px;
    }
    .md\\:h-\\[165px\\] {
      height: 165px;
    }
    .md\\:h-\\[203px\\] {
      height: 203px;
    }
    .md\\:h-\\[210px\\] {
      height: 210px;
    }
    .md\\:h-\\[220px\\] {
      height: 220px;
    }
    .md\\:h-\\[240px\\] {
      height: 240px;
    }
    .md\\:h-\\[254px\\] {
      height: 254px;
    }
    .md\\:h-\\[390px\\] {
      height: 390px;
    }
    .md\\:h-\\[min\\(var\\(--height-feed-detail-modal\\)\\,calc\\(100vh-7rem\\)\\)\\] {
      height: min(var(--height-feed-detail-modal), calc(100vh - 7rem));
    }
    .md\\:h-full {
      height: 100%;
    }
    .min-\\[768px\\]\\:h-\\[33px\\] {
      height: 33px;
    }
    .min-\\[768px\\]\\:h-\\[203px\\] {
      height: 203px;
    }
    .min-\\[768px\\]\\:h-\\[248px\\] {
      height: 248px;
    }
    .md\\:min-h-0 {
      min-height: 0px;
    }
    .md\\:min-h-\\[188px\\] {
      min-height: 188px;
    }
    .md\\:min-h-\\[420px\\] {
      min-height: 420px;
    }
    .md\\:w-1\\/2 {
      width: calc(1 / 2 * 100%);
    }
    .md\\:w-4\\.5 {
      width: calc(var(--spacing) * 4.5);
    }
    .md\\:w-20 {
      width: calc(var(--spacing) * 20);
    }
    .md\\:w-\\[60\\%\\] {
      width: 60%;
    }
    .md\\:w-\\[154px\\] {
      width: 154px;
    }
    .md\\:w-\\[220px\\] {
      width: 220px;
    }
    .md\\:w-\\[300px\\] {
      width: 300px;
    }
    .md\\:w-\\[404px\\] {
      width: 404px;
    }
    .md\\:w-\\[420px\\] {
      width: 420px;
    }
    .md\\:w-\\[min\\(100\\%\\,var\\(--width-feed-detail-modal\\)\\)\\] {
      width: min(100%, var(--width-feed-detail-modal));
    }
    .md\\:w-\\[var\\(--width-feed-cover-preview\\)\\] {
      width: var(--width-feed-cover-preview);
    }
    .md\\:w-\\[var\\(--width-feed-detail-sidebar\\)\\] {
      width: var(--width-feed-detail-sidebar);
    }
    .md\\:w-\\[var\\(--width-nudge-cover-preview\\)\\] {
      width: var(--width-nudge-cover-preview);
    }
    .md\\:w-full {
      width: 100%;
    }
    .min-\\[768px\\]\\:w-\\[30px\\] {
      width: 30px;
    }
    .md\\:max-w-77\\.5 {
      max-width: calc(var(--spacing) * 77.5);
    }
    .md\\:max-w-90 {
      max-width: calc(var(--spacing) * 90);
    }
    .md\\:max-w-\\[360px\\] {
      max-width: 360px;
    }
    .md\\:max-w-\\[480px\\] {
      max-width: 480px;
    }
    .md\\:max-w-\\[540px\\] {
      max-width: 540px;
    }
    .md\\:max-w-\\[560px\\] {
      max-width: 560px;
    }
    .md\\:max-w-\\[var\\(--width-feed-detail-sidebar\\)\\] {
      max-width: var(--width-feed-detail-sidebar);
    }
    .md\\:max-w-md {
      max-width: var(--container-md);
    }
    .md\\:min-w-0 {
      min-width: 0px;
    }
    .md\\:flex-1 {
      flex: 1;
    }
    .md\\:flex-none {
      flex: none;
    }
    .md\\:shrink-0 {
      flex-shrink: 0;
    }
    .md\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .md\\:grid-cols-5 {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .min-\\[768px\\]\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .min-\\[768px\\]\\:grid-cols-\\[minmax\\(0\\,2fr\\)_minmax\\(0\\,1fr\\)\\] {
      grid-template-columns: minmax(0,2fr) minmax(0,1fr);
    }
    .md\\:flex-col {
      flex-direction: column;
    }
    .md\\:flex-row {
      flex-direction: row;
    }
    .min-\\[768px\\]\\:flex-row {
      flex-direction: row;
    }
    .md\\:flex-wrap {
      flex-wrap: wrap;
    }
    .md\\:items-center {
      align-items: center;
    }
    .md\\:items-start {
      align-items: flex-start;
    }
    .md\\:items-stretch {
      align-items: stretch;
    }
    .min-\\[768px\\]\\:items-center {
      align-items: center;
    }
    .min-\\[768px\\]\\:items-end {
      align-items: flex-end;
    }
    .md\\:justify-between {
      justify-content: space-between;
    }
    .md\\:justify-center {
      justify-content: center;
    }
    .min-\\[768px\\]\\:justify-between {
      justify-content: space-between;
    }
    .md\\:gap-0\\.5 {
      gap: calc(var(--spacing) * 0.5);
    }
    .md\\:gap-1 {
      gap: var(--spacing);
    }
    .md\\:gap-1\\.5 {
      gap: calc(var(--spacing) * 1.5);
    }
    .md\\:gap-2 {
      gap: calc(var(--spacing) * 2);
    }
    .md\\:gap-2\\.5 {
      gap: calc(var(--spacing) * 2.5);
    }
    .md\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .md\\:gap-3\\.5 {
      gap: calc(var(--spacing) * 3.5);
    }
    .md\\:gap-3\\.75 {
      gap: calc(var(--spacing) * 3.75);
    }
    .md\\:gap-4 {
      gap: calc(var(--spacing) * 4);
    }
    .md\\:gap-4\\.5 {
      gap: calc(var(--spacing) * 4.5);
    }
    .md\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    .md\\:gap-7 {
      gap: calc(var(--spacing) * 7);
    }
    .md\\:gap-10 {
      gap: calc(var(--spacing) * 10);
    }
    .md\\:gap-\\[3px\\] {
      gap: 3px;
    }
    .md\\:gap-\\[9px\\] {
      gap: 9px;
    }
    .md\\:gap-\\[10px\\] {
      gap: 10px;
    }
    .md\\:gap-\\[18px\\] {
      gap: 18px;
    }
    .min-\\[768px\\]\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .min-\\[768px\\]\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    .min-\\[768px\\]\\:gap-9 {
      gap: calc(var(--spacing) * 9);
    }
    .min-\\[768px\\]\\:gap-\\[9px\\] {
      gap: 9px;
    }
    .min-\\[768px\\]\\:gap-\\[18px\\] {
      gap: 18px;
    }
    .md\\:gap-x-3 {
      column-gap: calc(var(--spacing) * 3);
    }
    .md\\:gap-y-4 {
      row-gap: calc(var(--spacing) * 4);
    }
    .min-\\[768px\\]\\:self-auto {
      align-self: auto;
    }
    .min-\\[768px\\]\\:self-center {
      align-self: center;
    }
    .md\\:overflow-hidden {
      overflow: hidden;
    }
    .md\\:overflow-visible {
      overflow: visible;
    }
    .md\\:rounded-\\[3px\\] {
      border-radius: 3px;
    }
    .md\\:rounded-\\[6px\\] {
      border-radius: 6px;
    }
    .md\\:rounded-\\[7px\\] {
      border-radius: 7px;
    }
    .md\\:rounded-\\[9px\\] {
      border-radius: 9px;
    }
    .md\\:rounded-\\[22px\\] {
      border-radius: 22px;
    }
    .md\\:rounded-md {
      border-radius: var(--radius-md);
    }
    .md\\:rounded-sm {
      border-radius: var(--radius-sm);
    }
    .md\\:rounded-xl {
      border-radius: var(--radius-xl);
    }
    .md\\:border-\\[2\\.5px\\] {
      border-style: var(--tw-border-style);
      border-width: 2.5px;
    }
    .md\\:border-\\[3px\\] {
      border-style: var(--tw-border-style);
      border-width: 3px;
    }
    .md\\:border-r {
      border-right-style: var(--tw-border-style);
      border-right-width: 1px;
    }
    .md\\:border-solid {
      --tw-border-style: solid;
      border-style: solid;
    }
    .md\\:border-merchant-border {
      border-color: var(--color-merchant-border);
    }
    .md\\:p-1\\.5 {
      padding: calc(var(--spacing) * 1.5);
    }
    .md\\:p-2\\.25 {
      padding: calc(var(--spacing) * 2.25);
    }
    .md\\:p-3 {
      padding: calc(var(--spacing) * 3);
    }
    .md\\:p-3\\.75 {
      padding: calc(var(--spacing) * 3.75);
    }
    .md\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
    .md\\:p-8 {
      padding: calc(var(--spacing) * 8);
    }
    .md\\:p-\\[10px\\] {
      padding: 10px;
    }
    .md\\:p-\\[18px\\] {
      padding: 18px;
    }
    .min-\\[768px\\]\\:p-\\[18px\\] {
      padding: 18px;
    }
    .md\\:px-3 {
      padding-inline: calc(var(--spacing) * 3);
    }
    .md\\:px-3\\.5 {
      padding-inline: calc(var(--spacing) * 3.5);
    }
    .md\\:px-3\\.75 {
      padding-inline: calc(var(--spacing) * 3.75);
    }
    .md\\:px-4\\.5 {
      padding-inline: calc(var(--spacing) * 4.5);
    }
    .md\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
    .md\\:px-8 {
      padding-inline: calc(var(--spacing) * 8);
    }
    .md\\:px-12 {
      padding-inline: calc(var(--spacing) * 12);
    }
    .md\\:px-\\[5px\\] {
      padding-inline: 5px;
    }
    .md\\:px-\\[18px\\] {
      padding-inline: 18px;
    }
    .md\\:py-1\\.5 {
      padding-block: calc(var(--spacing) * 1.5);
    }
    .md\\:py-2 {
      padding-block: calc(var(--spacing) * 2);
    }
    .md\\:py-2\\.5 {
      padding-block: calc(var(--spacing) * 2.5);
    }
    .md\\:py-3 {
      padding-block: calc(var(--spacing) * 3);
    }
    .md\\:py-3\\.5 {
      padding-block: calc(var(--spacing) * 3.5);
    }
    .md\\:py-12 {
      padding-block: calc(var(--spacing) * 12);
    }
    .md\\:py-15 {
      padding-block: calc(var(--spacing) * 15);
    }
    .md\\:py-\\[9px\\] {
      padding-block: 9px;
    }
    .md\\:py-\\[18px\\] {
      padding-block: 18px;
    }
    .md\\:py-\\[60px\\] {
      padding-block: 60px;
    }
    .min-\\[768px\\]\\:py-\\[60px\\] {
      padding-block: 60px;
    }
    .md\\:pt-3\\.75 {
      padding-top: calc(var(--spacing) * 3.75);
    }
    .md\\:pt-\\[18px\\] {
      padding-top: 18px;
    }
    .md\\:pt-\\[60px\\] {
      padding-top: 60px;
    }
    .md\\:pt-\\[66px\\] {
      padding-top: 66px;
    }
    .md\\:pt-\\[118px\\] {
      padding-top: 118px;
    }
    .min-\\[768px\\]\\:pt-\\[66px\\] {
      padding-top: 66px;
    }
    .md\\:pr-0 {
      padding-right: 0px;
    }
    .md\\:pr-4 {
      padding-right: calc(var(--spacing) * 4);
    }
    .md\\:pr-5 {
      padding-right: calc(var(--spacing) * 5);
    }
    .md\\:pr-6 {
      padding-right: calc(var(--spacing) * 6);
    }
    .md\\:pr-9 {
      padding-right: calc(var(--spacing) * 9);
    }
    .md\\:pr-14 {
      padding-right: calc(var(--spacing) * 14);
    }
    .md\\:pb-3 {
      padding-bottom: calc(var(--spacing) * 3);
    }
    .md\\:pb-\\[60px\\] {
      padding-bottom: 60px;
    }
    .min-\\[768px\\]\\:pb-\\[60px\\] {
      padding-bottom: 60px;
    }
    .md\\:pl-6 {
      padding-left: calc(var(--spacing) * 6);
    }
    .md\\:pl-\\[18px\\] {
      padding-left: 18px;
    }
    .md\\:text-2xl {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
    .md\\:text-lg {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    .md\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .md\\:text-\\[11px\\] {
      font-size: 11px;
    }
    .md\\:text-\\[24px\\] {
      font-size: 24px;
    }
    .min-\\[768px\\]\\:text-\\[18px\\] {
      font-size: 18px;
    }
    .min-\\[768px\\]\\:text-\\[30px\\] {
      font-size: 30px;
    }
    .md\\:leading-3\\.75 {
      --tw-leading: calc(var(--spacing) * 3.75);
      line-height: calc(var(--spacing) * 3.75);
    }
    .md\\:leading-5 {
      --tw-leading: calc(var(--spacing) * 5);
      line-height: calc(var(--spacing) * 5);
    }
    .md\\:leading-8 {
      --tw-leading: calc(var(--spacing) * 8);
      line-height: calc(var(--spacing) * 8);
    }
    .min-\\[768px\\]\\:leading-7 {
      --tw-leading: calc(var(--spacing) * 7);
      line-height: calc(var(--spacing) * 7);
    }
    .min-\\[768px\\]\\:leading-9 {
      --tw-leading: calc(var(--spacing) * 9);
      line-height: calc(var(--spacing) * 9);
    }
    .md\\:whitespace-nowrap {
      white-space: nowrap;
    }
  }
  @media (width >= 1024px) {
    .lg\\:sticky {
      position: sticky;
    }
    .lg\\:top-6 {
      top: calc(var(--spacing) * 6);
    }
    .lg\\:top-\\[calc\\(var\\(--header-height\\)\\+124px\\)\\] {
      top: calc(var(--header-height) + 124px);
    }
    .lg\\:col-span-2 {
      grid-column: span 2 / span 2;
    }
    .lg\\:mx-0 {
      margin-inline: 0px;
    }
    .lg\\:block {
      display: block;
    }
    .lg\\:flex {
      display: flex;
    }
    .lg\\:h-full {
      height: 100%;
    }
    .lg\\:min-h-0 {
      min-height: 0px;
    }
    .lg\\:w-65 {
      width: calc(var(--spacing) * 65);
    }
    .lg\\:w-70 {
      width: calc(var(--spacing) * 70);
    }
    .lg\\:w-80 {
      width: calc(var(--spacing) * 80);
    }
    .lg\\:w-95 {
      width: calc(var(--spacing) * 95);
    }
    .lg\\:w-\\[316px\\] {
      width: 316px;
    }
    .lg\\:w-\\[320px\\] {
      width: 320px;
    }
    .lg\\:w-\\[460px\\] {
      width: 460px;
    }
    .lg\\:max-w-3xl {
      max-width: var(--container-3xl);
    }
    .lg\\:max-w-lg {
      max-width: var(--container-lg);
    }
    .lg\\:shrink-0 {
      flex-shrink: 0;
    }
    .lg\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .lg\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .lg\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .lg\\:grid-cols-5 {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    .lg\\:flex-row {
      flex-direction: row;
    }
    .lg\\:items-center {
      align-items: center;
    }
    .lg\\:items-start {
      align-items: flex-start;
    }
    .lg\\:justify-between {
      justify-content: space-between;
    }
    .lg\\:gap-0 {
      gap: 0px;
    }
    .lg\\:gap-2 {
      gap: calc(var(--spacing) * 2);
    }
    .lg\\:border-r {
      border-right-style: var(--tw-border-style);
      border-right-width: 1px;
    }
    .lg\\:border-l {
      border-left-style: var(--tw-border-style);
      border-left-width: 1px;
    }
    .lg\\:border-merchant-border {
      border-color: var(--color-merchant-border);
    }
    .lg\\:px-3 {
      padding-inline: calc(var(--spacing) * 3);
    }
    .lg\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
    .lg\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .lg\\:py-2 {
      padding-block: calc(var(--spacing) * 2);
    }
    .lg\\:py-2\\.5 {
      padding-block: calc(var(--spacing) * 2.5);
    }
    .lg\\:pr-6 {
      padding-right: calc(var(--spacing) * 6);
    }
    .lg\\:pl-6 {
      padding-left: calc(var(--spacing) * 6);
    }
    .lg\\:last\\:border-r-0:last-child {
      border-right-style: var(--tw-border-style);
      border-right-width: 0px;
    }
  }
  @media (width >= 1100px) {
    .min-\\[1100px\\]\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  @media (width >= 1200px) {
    .min-\\[1200px\\]\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  @media (width >= 1280px) {
    .xl\\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .xl\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .xl\\:flex-row {
      flex-direction: row;
    }
    .xl\\:items-center {
      align-items: center;
    }
    .xl\\:justify-between {
      justify-content: space-between;
    }
    .xl\\:gap-\\[18px\\] {
      gap: 18px;
    }
    .xl\\:text-\\[32px\\] {
      font-size: 32px;
    }
  }
  @media (width >= 1440px) {
    .min-\\[1440px\\]\\:col-span-1 {
      grid-column: span 1 / span 1;
    }
    .min-\\[1440px\\]\\:col-start-2 {
      grid-column-start: 2;
    }
    .min-\\[1440px\\]\\:col-start-3 {
      grid-column-start: 3;
    }
    .min-\\[1440px\\]\\:row-start-1 {
      grid-row-start: 1;
    }
    .min-\\[1440px\\]\\:w-auto {
      width: auto;
    }
    .min-\\[1440px\\]\\:max-w-\\[360px\\] {
      max-width: 360px;
    }
    .min-\\[1440px\\]\\:grid-cols-\\[auto_minmax\\(0\\,1fr\\)_auto\\] {
      grid-template-columns: auto minmax(0,1fr) auto;
    }
    .min-\\[1440px\\]\\:border-t-0 {
      border-top-style: var(--tw-border-style);
      border-top-width: 0px;
    }
    .min-\\[1440px\\]\\:px-12 {
      padding-inline: calc(var(--spacing) * 12);
    }
    .min-\\[1440px\\]\\:pt-0 {
      padding-top: 0px;
    }
  }
  @media (width >= 1550px) {
    .desktop\\:-top-4 {
      top: calc(var(--spacing) * -4);
    }
    .desktop\\:top-4 {
      top: calc(var(--spacing) * 4);
    }
    .desktop\\:top-\\[5px\\] {
      top: 5px;
    }
    .desktop\\:top-\\[calc\\(var\\(--header-height\\)\\+152px\\)\\] {
      top: calc(var(--header-height) + 152px);
    }
    .desktop\\:-right-4 {
      right: calc(var(--spacing) * -4);
    }
    .desktop\\:right-4 {
      right: calc(var(--spacing) * 4);
    }
    .desktop\\:right-12 {
      right: calc(var(--spacing) * 12);
    }
    .desktop\\:right-\\[5px\\] {
      right: 5px;
    }
    .desktop\\:right-\\[181px\\] {
      right: 181px;
    }
    .desktop\\:bottom-3 {
      bottom: calc(var(--spacing) * 3);
    }
    .desktop\\:bottom-6 {
      bottom: calc(var(--spacing) * 6);
    }
    .desktop\\:bottom-23 {
      bottom: calc(var(--spacing) * 23);
    }
    .desktop\\:left-0\\.5 {
      left: calc(var(--spacing) * 0.5);
    }
    .desktop\\:left-3 {
      left: calc(var(--spacing) * 3);
    }
    .desktop\\:left-\\[2px\\] {
      left: 2px;
    }
    .desktop\\:left-\\[22px\\] {
      left: 22px;
    }
    .desktop\\:left-\\[38px\\] {
      left: 38px;
    }
    .desktop\\:left-\\[181px\\] {
      left: 181px;
    }
    .desktop\\:mx-5 {
      margin-inline: calc(var(--spacing) * 5);
    }
    .desktop\\:mt-1 {
      margin-top: var(--spacing);
    }
    .desktop\\:mt-1\\.5 {
      margin-top: calc(var(--spacing) * 1.5);
    }
    .desktop\\:mt-2 {
      margin-top: calc(var(--spacing) * 2);
    }
    .desktop\\:mt-3 {
      margin-top: calc(var(--spacing) * 3);
    }
    .desktop\\:mt-6 {
      margin-top: calc(var(--spacing) * 6);
    }
    .desktop\\:-mr-\\[18px\\] {
      margin-right: calc(18px * -1);
    }
    .desktop\\:mr-4 {
      margin-right: calc(var(--spacing) * 4);
    }
    .desktop\\:mb-3 {
      margin-bottom: calc(var(--spacing) * 3);
    }
    .desktop\\:mb-4 {
      margin-bottom: calc(var(--spacing) * 4);
    }
    .desktop\\:mb-6 {
      margin-bottom: calc(var(--spacing) * 6);
    }
    .desktop\\:-ml-\\[18px\\] {
      margin-left: calc(18px * -1);
    }
    .desktop\\:ml-3 {
      margin-left: calc(var(--spacing) * 3);
    }
    .desktop\\:size-2 {
      width: calc(var(--spacing) * 2);
      height: calc(var(--spacing) * 2);
    }
    .desktop\\:size-2\\.5 {
      width: calc(var(--spacing) * 2.5);
      height: calc(var(--spacing) * 2.5);
    }
    .desktop\\:size-3 {
      width: calc(var(--spacing) * 3);
      height: calc(var(--spacing) * 3);
    }
    .desktop\\:size-3\\.5 {
      width: calc(var(--spacing) * 3.5);
      height: calc(var(--spacing) * 3.5);
    }
    .desktop\\:size-4 {
      width: calc(var(--spacing) * 4);
      height: calc(var(--spacing) * 4);
    }
    .desktop\\:size-4\\.5 {
      width: calc(var(--spacing) * 4.5);
      height: calc(var(--spacing) * 4.5);
    }
    .desktop\\:size-5 {
      width: calc(var(--spacing) * 5);
      height: calc(var(--spacing) * 5);
    }
    .desktop\\:size-6 {
      width: calc(var(--spacing) * 6);
      height: calc(var(--spacing) * 6);
    }
    .desktop\\:size-7 {
      width: calc(var(--spacing) * 7);
      height: calc(var(--spacing) * 7);
    }
    .desktop\\:size-8 {
      width: calc(var(--spacing) * 8);
      height: calc(var(--spacing) * 8);
    }
    .desktop\\:size-9 {
      width: calc(var(--spacing) * 9);
      height: calc(var(--spacing) * 9);
    }
    .desktop\\:size-9\\.5 {
      width: calc(var(--spacing) * 9.5);
      height: calc(var(--spacing) * 9.5);
    }
    .desktop\\:size-10 {
      width: calc(var(--spacing) * 10);
      height: calc(var(--spacing) * 10);
    }
    .desktop\\:size-10\\.5 {
      width: calc(var(--spacing) * 10.5);
      height: calc(var(--spacing) * 10.5);
    }
    .desktop\\:size-11 {
      width: calc(var(--spacing) * 11);
      height: calc(var(--spacing) * 11);
    }
    .desktop\\:size-12 {
      width: calc(var(--spacing) * 12);
      height: calc(var(--spacing) * 12);
    }
    .desktop\\:size-14 {
      width: calc(var(--spacing) * 14);
      height: calc(var(--spacing) * 14);
    }
    .desktop\\:size-14\\.5 {
      width: calc(var(--spacing) * 14.5);
      height: calc(var(--spacing) * 14.5);
    }
    .desktop\\:size-16 {
      width: calc(var(--spacing) * 16);
      height: calc(var(--spacing) * 16);
    }
    .desktop\\:size-20 {
      width: calc(var(--spacing) * 20);
      height: calc(var(--spacing) * 20);
    }
    .desktop\\:size-24 {
      width: calc(var(--spacing) * 24);
      height: calc(var(--spacing) * 24);
    }
    .desktop\\:size-30 {
      width: calc(var(--spacing) * 30);
      height: calc(var(--spacing) * 30);
    }
    .desktop\\:size-40 {
      width: calc(var(--spacing) * 40);
      height: calc(var(--spacing) * 40);
    }
    .desktop\\:size-\\[18px\\] {
      width: 18px;
      height: 18px;
    }
    .desktop\\:size-\\[19px\\] {
      width: 19px;
      height: 19px;
    }
    .desktop\\:size-\\[21px\\] {
      width: 21px;
      height: 21px;
    }
    .desktop\\:size-\\[50px\\] {
      width: 50px;
      height: 50px;
    }
    .desktop\\:size-\\[52px\\] {
      width: 52px;
      height: 52px;
    }
    .desktop\\:size-\\[60px\\] {
      width: 60px;
      height: 60px;
    }
    .desktop\\:size-\\[72px\\] {
      width: 72px;
      height: 72px;
    }
    .desktop\\:size-\\[88px\\] {
      width: 88px;
      height: 88px;
    }
    .desktop\\:size-\\[120px\\] {
      width: 120px;
      height: 120px;
    }
    .desktop\\:size-\\[160px\\] {
      width: 160px;
      height: 160px;
    }
    .desktop\\:size-\\[240px\\] {
      width: 240px;
      height: 240px;
    }
    .desktop\\:h-2 {
      height: calc(var(--spacing) * 2);
    }
    .desktop\\:h-3\\.5 {
      height: calc(var(--spacing) * 3.5);
    }
    .desktop\\:h-4 {
      height: calc(var(--spacing) * 4);
    }
    .desktop\\:h-4\\.5 {
      height: calc(var(--spacing) * 4.5);
    }
    .desktop\\:h-5 {
      height: calc(var(--spacing) * 5);
    }
    .desktop\\:h-6 {
      height: calc(var(--spacing) * 6);
    }
    .desktop\\:h-7 {
      height: calc(var(--spacing) * 7);
    }
    .desktop\\:h-7\\.5 {
      height: calc(var(--spacing) * 7.5);
    }
    .desktop\\:h-8 {
      height: calc(var(--spacing) * 8);
    }
    .desktop\\:h-8\\.5 {
      height: calc(var(--spacing) * 8.5);
    }
    .desktop\\:h-10 {
      height: calc(var(--spacing) * 10);
    }
    .desktop\\:h-11 {
      height: calc(var(--spacing) * 11);
    }
    .desktop\\:h-12 {
      height: calc(var(--spacing) * 12);
    }
    .desktop\\:h-14 {
      height: calc(var(--spacing) * 14);
    }
    .desktop\\:h-15 {
      height: calc(var(--spacing) * 15);
    }
    .desktop\\:h-16 {
      height: calc(var(--spacing) * 16);
    }
    .desktop\\:h-20 {
      height: calc(var(--spacing) * 20);
    }
    .desktop\\:h-22 {
      height: calc(var(--spacing) * 22);
    }
    .desktop\\:h-30 {
      height: calc(var(--spacing) * 30);
    }
    .desktop\\:h-32 {
      height: calc(var(--spacing) * 32);
    }
    .desktop\\:h-40 {
      height: calc(var(--spacing) * 40);
    }
    .desktop\\:h-44 {
      height: calc(var(--spacing) * 44);
    }
    .desktop\\:h-52 {
      height: calc(var(--spacing) * 52);
    }
    .desktop\\:h-55 {
      height: calc(var(--spacing) * 55);
    }
    .desktop\\:h-\\[24px\\] {
      height: 24px;
    }
    .desktop\\:h-\\[26px\\] {
      height: 26px;
    }
    .desktop\\:h-\\[28px\\] {
      height: 28px;
    }
    .desktop\\:h-\\[42px\\] {
      height: 42px;
    }
    .desktop\\:h-\\[50px\\] {
      height: 50px;
    }
    .desktop\\:h-\\[60px\\] {
      height: 60px;
    }
    .desktop\\:h-\\[68px\\] {
      height: 68px;
    }
    .desktop\\:h-\\[70px\\] {
      height: 70px;
    }
    .desktop\\:h-\\[74px\\] {
      height: 74px;
    }
    .desktop\\:h-\\[84px\\] {
      height: 84px;
    }
    .desktop\\:h-\\[88px\\] {
      height: 88px;
    }
    .desktop\\:h-\\[90px\\] {
      height: 90px;
    }
    .desktop\\:h-\\[92px\\] {
      height: 92px;
    }
    .desktop\\:h-\\[120px\\] {
      height: 120px;
    }
    .desktop\\:h-\\[136px\\] {
      height: 136px;
    }
    .desktop\\:h-\\[165px\\] {
      height: 165px;
    }
    .desktop\\:h-\\[215px\\] {
      height: 215px;
    }
    .desktop\\:h-\\[220px\\] {
      height: 220px;
    }
    .desktop\\:h-\\[230px\\] {
      height: 230px;
    }
    .desktop\\:h-\\[240px\\] {
      height: 240px;
    }
    .desktop\\:h-\\[260px\\] {
      height: 260px;
    }
    .desktop\\:h-\\[268px\\] {
      height: 268px;
    }
    .desktop\\:h-\\[271px\\] {
      height: 271px;
    }
    .desktop\\:h-\\[280px\\] {
      height: 280px;
    }
    .desktop\\:h-\\[339px\\] {
      height: 339px;
    }
    .desktop\\:h-\\[520px\\] {
      height: 520px;
    }
    .desktop\\:h-\\[622px\\] {
      height: 622px;
    }
    .desktop\\:max-h-70 {
      max-height: calc(var(--spacing) * 70);
    }
    .desktop\\:max-h-\\[240px\\] {
      max-height: 240px;
    }
    .desktop\\:max-h-\\[743px\\] {
      max-height: 743px;
    }
    .desktop\\:max-h-\\[calc\\(100vh-32px\\)\\] {
      max-height: calc(100vh - 32px);
    }
    .desktop\\:min-h-0 {
      min-height: 0px;
    }
    .desktop\\:min-h-8 {
      min-height: calc(var(--spacing) * 8);
    }
    .desktop\\:min-h-10 {
      min-height: calc(var(--spacing) * 10);
    }
    .desktop\\:min-h-11 {
      min-height: calc(var(--spacing) * 11);
    }
    .desktop\\:min-h-14 {
      min-height: calc(var(--spacing) * 14);
    }
    .desktop\\:min-h-18 {
      min-height: calc(var(--spacing) * 18);
    }
    .desktop\\:min-h-52 {
      min-height: calc(var(--spacing) * 52);
    }
    .desktop\\:min-h-65 {
      min-height: calc(var(--spacing) * 65);
    }
    .desktop\\:min-h-\\[48px\\] {
      min-height: 48px;
    }
    .desktop\\:min-h-\\[76px\\] {
      min-height: 76px;
    }
    .desktop\\:min-h-\\[180px\\] {
      min-height: 180px;
    }
    .desktop\\:min-h-\\[230px\\] {
      min-height: 230px;
    }
    .desktop\\:min-h-\\[240px\\] {
      min-height: 240px;
    }
    .desktop\\:min-h-\\[480px\\] {
      min-height: 480px;
    }
    .desktop\\:w-0\\.5 {
      width: calc(var(--spacing) * 0.5);
    }
    .desktop\\:w-3 {
      width: calc(var(--spacing) * 3);
    }
    .desktop\\:w-3\\.5 {
      width: calc(var(--spacing) * 3.5);
    }
    .desktop\\:w-4 {
      width: calc(var(--spacing) * 4);
    }
    .desktop\\:w-4\\.5 {
      width: calc(var(--spacing) * 4.5);
    }
    .desktop\\:w-5 {
      width: calc(var(--spacing) * 5);
    }
    .desktop\\:w-6 {
      width: calc(var(--spacing) * 6);
    }
    .desktop\\:w-7 {
      width: calc(var(--spacing) * 7);
    }
    .desktop\\:w-8 {
      width: calc(var(--spacing) * 8);
    }
    .desktop\\:w-8\\.5 {
      width: calc(var(--spacing) * 8.5);
    }
    .desktop\\:w-9\\.75 {
      width: calc(var(--spacing) * 9.75);
    }
    .desktop\\:w-10 {
      width: calc(var(--spacing) * 10);
    }
    .desktop\\:w-11 {
      width: calc(var(--spacing) * 11);
    }
    .desktop\\:w-12 {
      width: calc(var(--spacing) * 12);
    }
    .desktop\\:w-14 {
      width: calc(var(--spacing) * 14);
    }
    .desktop\\:w-16 {
      width: calc(var(--spacing) * 16);
    }
    .desktop\\:w-20 {
      width: calc(var(--spacing) * 20);
    }
    .desktop\\:w-22 {
      width: calc(var(--spacing) * 22);
    }
    .desktop\\:w-24 {
      width: calc(var(--spacing) * 24);
    }
    .desktop\\:w-30 {
      width: calc(var(--spacing) * 30);
    }
    .desktop\\:w-32 {
      width: calc(var(--spacing) * 32);
    }
    .desktop\\:w-40 {
      width: calc(var(--spacing) * 40);
    }
    .desktop\\:w-48 {
      width: calc(var(--spacing) * 48);
    }
    .desktop\\:w-52 {
      width: calc(var(--spacing) * 52);
    }
    .desktop\\:w-56 {
      width: calc(var(--spacing) * 56);
    }
    .desktop\\:w-65 {
      width: calc(var(--spacing) * 65);
    }
    .desktop\\:w-85 {
      width: calc(var(--spacing) * 85);
    }
    .desktop\\:w-95 {
      width: calc(var(--spacing) * 95);
    }
    .desktop\\:w-\\[24px\\] {
      width: 24px;
    }
    .desktop\\:w-\\[64px\\] {
      width: 64px;
    }
    .desktop\\:w-\\[72px\\] {
      width: 72px;
    }
    .desktop\\:w-\\[120px\\] {
      width: 120px;
    }
    .desktop\\:w-\\[160px\\] {
      width: 160px;
    }
    .desktop\\:w-\\[205px\\] {
      width: 205px;
    }
    .desktop\\:w-\\[252px\\] {
      width: 252px;
    }
    .desktop\\:w-\\[380px\\] {
      width: 380px;
    }
    .desktop\\:w-\\[422px\\] {
      width: 422px;
    }
    .desktop\\:w-\\[520px\\] {
      width: 520px;
    }
    .desktop\\:w-\\[539px\\] {
      width: 539px;
    }
    .desktop\\:w-\\[min\\(880px\\,calc\\(100vh-136px\\)\\,calc\\(100vw-264px\\)\\)\\] {
      width: min(880px, calc(100vh - 136px), calc(100vw - 264px));
    }
    .desktop\\:w-auto {
      width: auto;
    }
    .desktop\\:max-w-7xl {
      max-width: var(--container-7xl);
    }
    .desktop\\:max-w-131 {
      max-width: calc(var(--spacing) * 131);
    }
    .desktop\\:max-w-190 {
      max-width: calc(var(--spacing) * 190);
    }
    .desktop\\:max-w-280 {
      max-width: calc(var(--spacing) * 280);
    }
    .desktop\\:max-w-360 {
      max-width: calc(var(--spacing) * 360);
    }
    .desktop\\:max-w-\\[290px\\] {
      max-width: 290px;
    }
    .desktop\\:max-w-\\[320px\\] {
      max-width: 320px;
    }
    .desktop\\:max-w-\\[520px\\] {
      max-width: 520px;
    }
    .desktop\\:max-w-\\[600px\\] {
      max-width: 600px;
    }
    .desktop\\:max-w-\\[620px\\] {
      max-width: 620px;
    }
    .desktop\\:max-w-\\[720px\\] {
      max-width: 720px;
    }
    .desktop\\:max-w-none {
      max-width: none;
    }
    .desktop\\:min-w-5 {
      min-width: calc(var(--spacing) * 5);
    }
    .desktop\\:min-w-7\\.5 {
      min-width: calc(var(--spacing) * 7.5);
    }
    .desktop\\:min-w-24 {
      min-width: calc(var(--spacing) * 24);
    }
    .desktop\\:min-w-30 {
      min-width: calc(var(--spacing) * 30);
    }
    .desktop\\:min-w-\\[76px\\] {
      min-width: 76px;
    }
    .desktop\\:min-w-\\[110px\\] {
      min-width: 110px;
    }
    .desktop\\:translate-x-0\\.75 {
      --tw-translate-x: calc(var(--spacing) * 0.75);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
    .desktop\\:translate-x-5\\.75 {
      --tw-translate-x: calc(var(--spacing) * 5.75);
      translate: var(--tw-translate-x) var(--tw-translate-y);
    }
    .desktop\\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .desktop\\:grid-cols-8 {
      grid-template-columns: repeat(8, minmax(0, 1fr));
    }
    .desktop\\:grid-cols-\\[32px_82px_64px_minmax\\(0\\,1fr\\)_280px_auto\\] {
      grid-template-columns: 32px 82px 64px minmax(0,1fr) 280px auto;
    }
    .desktop\\:grid-cols-\\[32px_82px_64px_minmax\\(0\\,1fr\\)_auto\\] {
      grid-template-columns: 32px 82px 64px minmax(0,1fr) auto;
    }
    .desktop\\:flex-row {
      flex-direction: row;
    }
    .desktop\\:items-center {
      align-items: center;
    }
    .desktop\\:justify-end {
      justify-content: flex-end;
    }
    .desktop\\:\\!gap-1\\.5 {
      gap: calc(var(--spacing) * 1.5) !important;
    }
    .desktop\\:gap-0 {
      gap: 0px;
    }
    .desktop\\:gap-1 {
      gap: var(--spacing);
    }
    .desktop\\:gap-1\\.5 {
      gap: calc(var(--spacing) * 1.5);
    }
    .desktop\\:gap-2 {
      gap: calc(var(--spacing) * 2);
    }
    .desktop\\:gap-2\\.5 {
      gap: calc(var(--spacing) * 2.5);
    }
    .desktop\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .desktop\\:gap-3\\.5 {
      gap: calc(var(--spacing) * 3.5);
    }
    .desktop\\:gap-4 {
      gap: calc(var(--spacing) * 4);
    }
    .desktop\\:gap-5 {
      gap: calc(var(--spacing) * 5);
    }
    .desktop\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    .desktop\\:gap-8 {
      gap: calc(var(--spacing) * 8);
    }
    .desktop\\:gap-9 {
      gap: calc(var(--spacing) * 9);
    }
    .desktop\\:gap-12 {
      gap: calc(var(--spacing) * 12);
    }
    .desktop\\:gap-\\[4px\\] {
      gap: 4px;
    }
    .desktop\\:gap-\\[6px\\] {
      gap: 6px;
    }
    .desktop\\:gap-\\[8px\\] {
      gap: 8px;
    }
    .desktop\\:gap-\\[10px\\] {
      gap: 10px;
    }
    .desktop\\:gap-\\[12px\\] {
      gap: 12px;
    }
    .desktop\\:gap-\\[48px\\] {
      gap: 48px;
    }
    .desktop\\:\\!rounded-md {
      border-radius: var(--radius-md) !important;
    }
    .desktop\\:rounded {
      border-radius: 0.25rem;
    }
    .desktop\\:rounded-2xl {
      border-radius: var(--radius-2xl);
    }
    .desktop\\:rounded-3xl {
      border-radius: var(--radius-3xl);
    }
    .desktop\\:rounded-\\[10px\\] {
      border-radius: 10px;
    }
    .desktop\\:rounded-\\[20px\\] {
      border-radius: 20px;
    }
    .desktop\\:rounded-\\[30px\\] {
      border-radius: 30px;
    }
    .desktop\\:rounded-lg {
      border-radius: var(--radius-lg);
    }
    .desktop\\:rounded-md {
      border-radius: var(--radius-md);
    }
    .desktop\\:rounded-xl {
      border-radius: var(--radius-xl);
    }
    .desktop\\:rounded-t-lg {
      border-top-left-radius: var(--radius-lg);
      border-top-right-radius: var(--radius-lg);
    }
    .desktop\\:border-4 {
      border-style: var(--tw-border-style);
      border-width: 4px;
    }
    .desktop\\:border-\\[3px\\] {
      border-style: var(--tw-border-style);
      border-width: 3px;
    }
    .desktop\\:p-1 {
      padding: var(--spacing);
    }
    .desktop\\:p-1\\.5 {
      padding: calc(var(--spacing) * 1.5);
    }
    .desktop\\:p-2 {
      padding: calc(var(--spacing) * 2);
    }
    .desktop\\:p-2\\.5 {
      padding: calc(var(--spacing) * 2.5);
    }
    .desktop\\:p-3 {
      padding: calc(var(--spacing) * 3);
    }
    .desktop\\:p-3\\.5 {
      padding: calc(var(--spacing) * 3.5);
    }
    .desktop\\:p-3\\.75 {
      padding: calc(var(--spacing) * 3.75);
    }
    .desktop\\:p-4 {
      padding: calc(var(--spacing) * 4);
    }
    .desktop\\:p-5 {
      padding: calc(var(--spacing) * 5);
    }
    .desktop\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
    .desktop\\:p-8 {
      padding: calc(var(--spacing) * 8);
    }
    .desktop\\:p-10 {
      padding: calc(var(--spacing) * 10);
    }
    .desktop\\:p-\\[12px\\] {
      padding: 12px;
    }
    .desktop\\:p-\\[13px\\] {
      padding: 13px;
    }
    .desktop\\:p-\\[24px\\] {
      padding: 24px;
    }
    .desktop\\:p-\\[32px\\] {
      padding: 32px;
    }
    .desktop\\:\\!px-2\\.5 {
      padding-inline: calc(var(--spacing) * 2.5) !important;
    }
    .desktop\\:px-0 {
      padding-inline: 0px;
    }
    .desktop\\:px-1 {
      padding-inline: var(--spacing);
    }
    .desktop\\:px-1\\.5 {
      padding-inline: calc(var(--spacing) * 1.5);
    }
    .desktop\\:px-2 {
      padding-inline: calc(var(--spacing) * 2);
    }
    .desktop\\:px-2\\.5 {
      padding-inline: calc(var(--spacing) * 2.5);
    }
    .desktop\\:px-3 {
      padding-inline: calc(var(--spacing) * 3);
    }
    .desktop\\:px-3\\.5 {
      padding-inline: calc(var(--spacing) * 3.5);
    }
    .desktop\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
    .desktop\\:px-4\\.5 {
      padding-inline: calc(var(--spacing) * 4.5);
    }
    .desktop\\:px-5 {
      padding-inline: calc(var(--spacing) * 5);
    }
    .desktop\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .desktop\\:px-8 {
      padding-inline: calc(var(--spacing) * 8);
    }
    .desktop\\:px-12 {
      padding-inline: calc(var(--spacing) * 12);
    }
    .desktop\\:px-16 {
      padding-inline: calc(var(--spacing) * 16);
    }
    .desktop\\:px-18 {
      padding-inline: calc(var(--spacing) * 18);
    }
    .desktop\\:px-\\[8px\\] {
      padding-inline: 8px;
    }
    .desktop\\:px-\\[9px\\] {
      padding-inline: 9px;
    }
    .desktop\\:px-\\[15px\\] {
      padding-inline: 15px;
    }
    .desktop\\:px-\\[16px\\] {
      padding-inline: 16px;
    }
    .desktop\\:px-\\[18px\\] {
      padding-inline: 18px;
    }
    .desktop\\:px-\\[22px\\] {
      padding-inline: 22px;
    }
    .desktop\\:\\!py-1\\.5 {
      padding-block: calc(var(--spacing) * 1.5) !important;
    }
    .desktop\\:py-1 {
      padding-block: var(--spacing);
    }
    .desktop\\:py-1\\.5 {
      padding-block: calc(var(--spacing) * 1.5);
    }
    .desktop\\:py-2 {
      padding-block: calc(var(--spacing) * 2);
    }
    .desktop\\:py-2\\.5 {
      padding-block: calc(var(--spacing) * 2.5);
    }
    .desktop\\:py-2\\.75 {
      padding-block: calc(var(--spacing) * 2.75);
    }
    .desktop\\:py-3 {
      padding-block: calc(var(--spacing) * 3);
    }
    .desktop\\:py-3\\.5 {
      padding-block: calc(var(--spacing) * 3.5);
    }
    .desktop\\:py-4 {
      padding-block: calc(var(--spacing) * 4);
    }
    .desktop\\:py-4\\.5 {
      padding-block: calc(var(--spacing) * 4.5);
    }
    .desktop\\:py-5 {
      padding-block: calc(var(--spacing) * 5);
    }
    .desktop\\:py-6 {
      padding-block: calc(var(--spacing) * 6);
    }
    .desktop\\:py-8 {
      padding-block: calc(var(--spacing) * 8);
    }
    .desktop\\:py-10 {
      padding-block: calc(var(--spacing) * 10);
    }
    .desktop\\:py-12 {
      padding-block: calc(var(--spacing) * 12);
    }
    .desktop\\:py-20 {
      padding-block: calc(var(--spacing) * 20);
    }
    .desktop\\:py-\\[4px\\] {
      padding-block: 4px;
    }
    .desktop\\:py-\\[6px\\] {
      padding-block: 6px;
    }
    .desktop\\:py-\\[8px\\] {
      padding-block: 8px;
    }
    .desktop\\:py-\\[18px\\] {
      padding-block: 18px;
    }
    .desktop\\:py-\\[22px\\] {
      padding-block: 22px;
    }
    .desktop\\:py-\\[100px\\] {
      padding-block: 100px;
    }
    .desktop\\:pt-2 {
      padding-top: calc(var(--spacing) * 2);
    }
    .desktop\\:pt-3 {
      padding-top: calc(var(--spacing) * 3);
    }
    .desktop\\:pt-3\\.5 {
      padding-top: calc(var(--spacing) * 3.5);
    }
    .desktop\\:pt-5 {
      padding-top: calc(var(--spacing) * 5);
    }
    .desktop\\:pt-6 {
      padding-top: calc(var(--spacing) * 6);
    }
    .desktop\\:pt-10 {
      padding-top: calc(var(--spacing) * 10);
    }
    .desktop\\:pt-20 {
      padding-top: calc(var(--spacing) * 20);
    }
    .desktop\\:pt-\\[18px\\] {
      padding-top: 18px;
    }
    .desktop\\:pt-\\[88px\\] {
      padding-top: 88px;
    }
    .desktop\\:pt-\\[90px\\] {
      padding-top: 90px;
    }
    .desktop\\:pt-\\[138px\\] {
      padding-top: 138px;
    }
    .desktop\\:pr-0 {
      padding-right: 0px;
    }
    .desktop\\:pr-3 {
      padding-right: calc(var(--spacing) * 3);
    }
    .desktop\\:pr-6 {
      padding-right: calc(var(--spacing) * 6);
    }
    .desktop\\:pr-7 {
      padding-right: calc(var(--spacing) * 7);
    }
    .desktop\\:pr-8 {
      padding-right: calc(var(--spacing) * 8);
    }
    .desktop\\:pr-10 {
      padding-right: calc(var(--spacing) * 10);
    }
    .desktop\\:pr-12 {
      padding-right: calc(var(--spacing) * 12);
    }
    .desktop\\:pr-\\[27px\\] {
      padding-right: 27px;
    }
    .desktop\\:pr-\\[54px\\] {
      padding-right: 54px;
    }
    .desktop\\:pb-3 {
      padding-bottom: calc(var(--spacing) * 3);
    }
    .desktop\\:pb-3\\.5 {
      padding-bottom: calc(var(--spacing) * 3.5);
    }
    .desktop\\:pb-4 {
      padding-bottom: calc(var(--spacing) * 4);
    }
    .desktop\\:pb-5 {
      padding-bottom: calc(var(--spacing) * 5);
    }
    .desktop\\:pb-6 {
      padding-bottom: calc(var(--spacing) * 6);
    }
    .desktop\\:pb-20 {
      padding-bottom: calc(var(--spacing) * 20);
    }
    .desktop\\:pl-3 {
      padding-left: calc(var(--spacing) * 3);
    }
    .desktop\\:pl-4 {
      padding-left: calc(var(--spacing) * 4);
    }
    .desktop\\:pl-6 {
      padding-left: calc(var(--spacing) * 6);
    }
    .desktop\\:pl-8 {
      padding-left: calc(var(--spacing) * 8);
    }
    .desktop\\:pl-10 {
      padding-left: calc(var(--spacing) * 10);
    }
    .desktop\\:pl-\\[54px\\] {
      padding-left: 54px;
    }
    .desktop\\:text-2xl {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
    .desktop\\:text-base {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    .desktop\\:text-lg {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    .desktop\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .desktop\\:text-xl {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
    .desktop\\:text-xs {
      font-size: var(--text-xs);
      line-height: var(--tw-leading, var(--text-xs--line-height));
    }
    .desktop\\:\\!text-\\[12px\\] {
      font-size: 12px !important;
    }
    @media (width >= 1550px) {
      .desktop\\:desktop\\:text-\\[16px\\] {
        font-size: 16px;
      }
    }
    .desktop\\:text-\\[11px\\] {
      font-size: 11px;
    }
    .desktop\\:text-\\[12px\\] {
      font-size: 12px;
    }
    .desktop\\:text-\\[13px\\] {
      font-size: 13px;
    }
    .desktop\\:text-\\[14px\\] {
      font-size: 14px;
    }
    .desktop\\:text-\\[15px\\] {
      font-size: 15px;
    }
    .desktop\\:text-\\[16px\\] {
      font-size: 16px;
    }
    .desktop\\:text-\\[18px\\] {
      font-size: 18px;
    }
    .desktop\\:text-\\[24px\\] {
      font-size: 24px;
    }
    .desktop\\:text-\\[28px\\] {
      font-size: 28px;
    }
    .desktop\\:text-\\[32px\\] {
      font-size: 32px;
    }
    .desktop\\:leading-3\\.5 {
      --tw-leading: calc(var(--spacing) * 3.5);
      line-height: calc(var(--spacing) * 3.5);
    }
    .desktop\\:leading-3\\.75 {
      --tw-leading: calc(var(--spacing) * 3.75);
      line-height: calc(var(--spacing) * 3.75);
    }
    .desktop\\:leading-4 {
      --tw-leading: calc(var(--spacing) * 4);
      line-height: calc(var(--spacing) * 4);
    }
    .desktop\\:leading-4\\.5 {
      --tw-leading: calc(var(--spacing) * 4.5);
      line-height: calc(var(--spacing) * 4.5);
    }
    .desktop\\:leading-5 {
      --tw-leading: calc(var(--spacing) * 5);
      line-height: calc(var(--spacing) * 5);
    }
    .desktop\\:leading-5\\.5 {
      --tw-leading: calc(var(--spacing) * 5.5);
      line-height: calc(var(--spacing) * 5.5);
    }
    .desktop\\:leading-6 {
      --tw-leading: calc(var(--spacing) * 6);
      line-height: calc(var(--spacing) * 6);
    }
    .desktop\\:leading-6\\.5 {
      --tw-leading: calc(var(--spacing) * 6.5);
      line-height: calc(var(--spacing) * 6.5);
    }
    .desktop\\:leading-8 {
      --tw-leading: calc(var(--spacing) * 8);
      line-height: calc(var(--spacing) * 8);
    }
    .desktop\\:leading-10 {
      --tw-leading: calc(var(--spacing) * 10);
      line-height: calc(var(--spacing) * 10);
    }
    .desktop\\:leading-11 {
      --tw-leading: calc(var(--spacing) * 11);
      line-height: calc(var(--spacing) * 11);
    }
    .desktop\\:leading-\\[16px\\] {
      --tw-leading: 16px;
      line-height: 16px;
    }
    .desktop\\:leading-\\[18px\\] {
      --tw-leading: 18px;
      line-height: 18px;
    }
    .desktop\\:leading-\\[21px\\] {
      --tw-leading: 21px;
      line-height: 21px;
    }
    .desktop\\:leading-\\[26px\\] {
      --tw-leading: 26px;
      line-height: 26px;
    }
    .desktop\\:leading-\\[40px\\] {
      --tw-leading: 40px;
      line-height: 40px;
    }
    .desktop\\:shadow-sm {
      --tw-shadow: 0 1px 2px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.05));
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  @media (width >= 1551px) {
    .min-\\[1551px\\]\\:mt-2 {
      margin-top: calc(var(--spacing) * 2);
    }
    .min-\\[1551px\\]\\:size-9 {
      width: calc(var(--spacing) * 9);
      height: calc(var(--spacing) * 9);
    }
    .min-\\[1551px\\]\\:size-16 {
      width: calc(var(--spacing) * 16);
      height: calc(var(--spacing) * 16);
    }
    .min-\\[1551px\\]\\:size-20 {
      width: calc(var(--spacing) * 20);
      height: calc(var(--spacing) * 20);
    }
    .min-\\[1551px\\]\\:size-\\[18px\\] {
      width: 18px;
      height: 18px;
    }
    .min-\\[1551px\\]\\:h-2 {
      height: calc(var(--spacing) * 2);
    }
    .min-\\[1551px\\]\\:h-10 {
      height: calc(var(--spacing) * 10);
    }
    .min-\\[1551px\\]\\:h-11 {
      height: calc(var(--spacing) * 11);
    }
    .min-\\[1551px\\]\\:h-\\[98px\\] {
      height: 98px;
    }
    .min-\\[1551px\\]\\:h-\\[220px\\] {
      height: 220px;
    }
    .min-\\[1551px\\]\\:h-\\[271px\\] {
      height: 271px;
    }
    .min-\\[1551px\\]\\:h-\\[520px\\] {
      height: 520px;
    }
    .min-\\[1551px\\]\\:min-h-10 {
      min-height: calc(var(--spacing) * 10);
    }
    .min-\\[1551px\\]\\:w-10 {
      width: calc(var(--spacing) * 10);
    }
    .min-\\[1551px\\]\\:max-w-80 {
      max-width: calc(var(--spacing) * 80);
    }
    .min-\\[1551px\\]\\:gap-2 {
      gap: calc(var(--spacing) * 2);
    }
    .min-\\[1551px\\]\\:gap-3 {
      gap: calc(var(--spacing) * 3);
    }
    .min-\\[1551px\\]\\:gap-4 {
      gap: calc(var(--spacing) * 4);
    }
    .min-\\[1551px\\]\\:gap-6 {
      gap: calc(var(--spacing) * 6);
    }
    .min-\\[1551px\\]\\:gap-8 {
      gap: calc(var(--spacing) * 8);
    }
    .min-\\[1551px\\]\\:gap-12 {
      gap: calc(var(--spacing) * 12);
    }
    .min-\\[1551px\\]\\:rounded-xl {
      border-radius: var(--radius-xl);
    }
    .min-\\[1551px\\]\\:p-4 {
      padding: calc(var(--spacing) * 4);
    }
    .min-\\[1551px\\]\\:p-6 {
      padding: calc(var(--spacing) * 6);
    }
    .min-\\[1551px\\]\\:px-4 {
      padding-inline: calc(var(--spacing) * 4);
    }
    .min-\\[1551px\\]\\:px-6 {
      padding-inline: calc(var(--spacing) * 6);
    }
    .min-\\[1551px\\]\\:py-2\\.5 {
      padding-block: calc(var(--spacing) * 2.5);
    }
    .min-\\[1551px\\]\\:py-3 {
      padding-block: calc(var(--spacing) * 3);
    }
    .min-\\[1551px\\]\\:py-20 {
      padding-block: calc(var(--spacing) * 20);
    }
    .min-\\[1551px\\]\\:pt-\\[88px\\] {
      padding-top: 88px;
    }
    .min-\\[1551px\\]\\:pb-20 {
      padding-bottom: calc(var(--spacing) * 20);
    }
    .min-\\[1551px\\]\\:text-sm {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
    .min-\\[1551px\\]\\:text-\\[11px\\] {
      font-size: 11px;
    }
    .min-\\[1551px\\]\\:text-\\[15px\\] {
      font-size: 15px;
    }
    .min-\\[1551px\\]\\:text-\\[24px\\] {
      font-size: 24px;
    }
    .min-\\[1551px\\]\\:text-\\[40px\\] {
      font-size: 40px;
    }
    .min-\\[1551px\\]\\:leading-5 {
      --tw-leading: calc(var(--spacing) * 5);
      line-height: calc(var(--spacing) * 5);
    }
    .min-\\[1551px\\]\\:leading-8 {
      --tw-leading: calc(var(--spacing) * 8);
      line-height: calc(var(--spacing) * 8);
    }
    .min-\\[1551px\\]\\:leading-10 {
      --tw-leading: calc(var(--spacing) * 10);
      line-height: calc(var(--spacing) * 10);
    }
    .min-\\[1551px\\]\\:leading-\\[18px\\] {
      --tw-leading: 18px;
      line-height: 18px;
    }
    .min-\\[1551px\\]\\:leading-\\[26px\\] {
      --tw-leading: 26px;
      line-height: 26px;
    }
    .min-\\[1551px\\]\\:leading-\\[44px\\] {
      --tw-leading: 44px;
      line-height: 44px;
    }
    .min-\\[1551px\\]\\:tracking-\\[-0\\.8px\\] {
      --tw-tracking: -0.8px;
      letter-spacing: -0.8px;
    }
    .min-\\[1551px\\]\\:tracking-\\[0\\.44px\\] {
      --tw-tracking: 0.44px;
      letter-spacing: 0.44px;
    }
  }
  @media (width >= 1700px) {
    .min-\\[1700px\\]\\:max-w-\\[540px\\] {
      max-width: 540px;
    }
  }
  .dark\\:border-gray-600:where([data-theme=dark], [data-theme=dark] *) {
    border-color: var(--color-gray-600);
  }
  .dark\\:bg-gray-800:where([data-theme=dark], [data-theme=dark] *) {
    background-color: var(--color-gray-800);
  }
  .dark\\:bg-gray-900:where([data-theme=dark], [data-theme=dark] *) {
    background-color: var(--color-gray-900);
  }
  .dark\\:bg-gray-900\\/80:where([data-theme=dark], [data-theme=dark] *) {
    background-color: color-mix(in srgb, oklch(21% 0.034 264.665) 80%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-900) 80%, transparent);
    }
  }
  .dark\\:from-gray-900:where([data-theme=dark], [data-theme=dark] *) {
    --tw-gradient-from: var(--color-gray-900);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .dark\\:to-gray-800:where([data-theme=dark], [data-theme=dark] *) {
    --tw-gradient-to: var(--color-gray-800);
    --tw-gradient-stops: var(--tw-gradient-via-stops, var(--tw-gradient-position), var(--tw-gradient-from) var(--tw-gradient-from-position), var(--tw-gradient-to) var(--tw-gradient-to-position));
  }
  .dark\\:text-gray-100:where([data-theme=dark], [data-theme=dark] *) {
    color: var(--color-gray-100);
  }
  .dark\\:text-gray-200:where([data-theme=dark], [data-theme=dark] *) {
    color: var(--color-gray-200);
  }
  .dark\\:text-gray-300:where([data-theme=dark], [data-theme=dark] *) {
    color: var(--color-gray-300);
  }
  .dark\\:text-gray-400:where([data-theme=dark], [data-theme=dark] *) {
    color: var(--color-gray-400);
  }
  @media (hover: hover) {
    .dark\\:hover\\:border-primary-400:where([data-theme=dark], [data-theme=dark] *):hover {
      border-color: var(--color-primary-400);
    }
    .dark\\:hover\\:bg-gray-800:where([data-theme=dark], [data-theme=dark] *):hover {
      background-color: var(--color-gray-800);
    }
  }
  .\\[\\&_\\.ant-upload-drag\\]\\:border-merchant-border .ant-upload-drag {
    border-color: var(--color-merchant-border);
  }
  .\\[\\&_svg\\]\\:size-full svg {
    width: 100%;
    height: 100%;
  }
  .\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
    display: none;
  }
  .\\[\\&\\:\\:-webkit-scrollbar\\]\\:h-1\\.5::-webkit-scrollbar {
    height: calc(var(--spacing) * 1.5);
  }
  .\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
    border-radius: calc(infinity * 1px);
  }
  .\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-white\\/45::-webkit-scrollbar-thumb {
    background-color: color-mix(in srgb, #fff 45%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 45%, transparent);
    }
  }
  @media (hover: hover) {
    .\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:hover\\:bg-white\\/70::-webkit-scrollbar-thumb:hover {
      background-color: color-mix(in srgb, #fff 70%, transparent);
    }
    @supports (color: color-mix(in lab, red, red)) {
      .\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:hover\\:bg-white\\/70::-webkit-scrollbar-thumb:hover {
        background-color: color-mix(in oklab, var(--color-white) 70%, transparent);
      }
    }
  }
  .\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-transparent::-webkit-scrollbar-track {
    background-color: transparent;
  }
}
:root {
  --space-page: 48px;
  --space-section: 32px;
  --space-form: 24px;
  --space-field: 16px;
  --text-heading-lg: 32px;
  --text-heading-md: 24px;
  --text-body: 18px;
  --text-base: 16px;
  --text-sm: 14px;
  --text-caption: 12px;
  --line-height-caption: 16px;
  --line-height-body-xs: 20px;
  --space-business-results: 12px;
  --space-business-result-row: 4px;
  --space-business-detail-section: 16px;
  --space-business-actions: 12px;
  --radius-field: 8px;
  --radius-card: 16px;
  --radius-button: 999px;
  --radius-control-sm: 4px;
  --icon-sm: 16px;
  --icon-md: 20px;
  --icon-lg: 24px;
  --icon-xl: 32px;
  --input-height: 48px;
  --width-auth-form: 600px;
  --width-onboarding: 620px;
  --width-feed-create-select-btn: 195px;
  --height-feed-create-post-modal: 680px;
  --width-feed-create-caption-modal: 1240px;
  --height-feed-create-caption-content: 622px;
  --width-feed-gallery-modal: 880px;
  --height-feed-gallery-grid: 657px;
  --height-feed-cover-stage: 342px;
  --height-feed-cover-filmstrip: 64px;
  --width-feed-cover-preview: 200px;
  --height-feed-cover-preview: 250px;
  --width-nudge-cover-preview: 300px;
  --width-feed-aspect-ratio-panel: 205px;
  --size-feed-overlay-icon: 21px;
  --radius-feed-caption-modal: 18px;
  --width-feed-emoji-picker: 320px;
  --height-feed-emoji-picker: 348px;
  --width-feed-detail-modal: 1422px;
  --height-feed-detail-modal: 880px;
  --width-feed-detail-media: 880px;
  --width-feed-detail-sidebar: 542px;
  --size-feed-detail-nav: 48px;
  --width-otp-group: 278px;
  --width-dashboard-content: 1120px;
  --width-business-switcher: 419px;
  --height-dashboard-logo: 44px;
  --width-dashboard-logo: 540px;
  --icon-nav: 18px;
  --size-notification-badge: 24px;
  --text-notification-badge: 12px;
  --offset-notification-badge: -8px;
  --space-dashboard-section: 16px;
  --space-dashboard-cards: 12px;
  --radius-welcome-card: 12px;
  --radius-dashboard-post: 12px;
  --padding-welcome-card: 24px;
  --padding-post-overlay: 5px;
  --radius-post-overlay: 5px;
  --width-profile-form: 554px;
  --height-profile-field: 50px;
  --duration-restaurant-profile-enter: 0.35s;
  --duration-restaurant-profile-exit: 0.3s;
  --width-nudge-ai-btn: 178px;
  --height-nudge-ai-btn: 40px;
  --padding-nudge-ai-btn-y: 10px;
  --padding-nudge-ai-btn-x: 18px;
  --gap-nudge-ai-btn: 4px;
  --border-nudge-ai-btn: 2px;
  --width-nudge-ai-chat: 556px;
  --padding-nudge-ai-chat: 40px;
  --gap-nudge-ai-chat: 24px;
  --gap-nudge-ai-empty: 24px;
  --size-nudge-ai-close: 32px;
  --size-nudge-ai-icon-wrap: 72px;
  --width-nudge-ai-empty: 520px;
  --height-nudge-ai-composer: 56px;
  --size-nudge-ai-send: 40px;
  --size-nudge-ai-thumb: 40px;
  --padding-nudge-ai-composer-x: 8px;
  --padding-nudge-ai-composer-y: 12px;
  --gap-nudge-ai-composer: 8px;
  --line-height-nudge-ai-prompt: 20px;
  --radius-nudge-ai-composer: 16px;
  --radius-nudge-ai-icon-wrap: 16px;
  --size-nudge-ai-upload: 48px;
  --size-nudge-ai-upload-lg: 80px;
  --size-nudge-ai-creating: 280px;
  --radius-nudge-ai-creating: 24px;
  --padding-nudge-ai-creating: 20px;
  --height-nudge-ai-segment: 32px;
  --padding-nudge-ai-segment: 2px;
  --padding-nudge-ai-segment-x: 12px;
  --padding-nudge-ai-media-actions: 10px;
  --gap-nudge-ai-media-actions: 8px;
  --padding-nudge-media-ai: 40px 32px 32px;
  --gap-nudge-media-ai: 16px;
  --radius-nudge-media-ai: 12px;
  --size-nudge-media-ai-icon: 48px;
  --height-nudge-media-start: 44px;
  --padding-nudge-media-start-x: 20px;
  --gap-nudge-media-start: 8px;
  --gap-nudge-media-stack: 24px;
  --gap-nudge-media-or: 12px;
  --size-nudge-media-close: 24px;
  --height-nudge-media-source: 48px;
  --padding-nudge-media-source-x: 24px;
  --gap-nudge-media-source: 16px;
  --gap-nudge-media-sources: 12px;
  --radius-nudge-media-source: 8px;
  --size-nudge-ai-launcher: 48px;
  --size-nudge-ai-launcher-dot: 8px;
}
@media (min-width: 1024px) {
  :root {
    --width-auth-form: 620px;
  }
}
@layer base {
  *,
  ::after,
  ::before,
  ::backdrop,
  ::file-selector-button {
    border-color: var(--color-gray-200, currentColor);
  }
  html {
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body {
    margin: 0px;
    min-height: 100vh;
    background-color: var(--color-gray-50);
    font-family: var(--font-sans);
    color: var(--color-gray-900);
  }
  [data-theme='dark'] body {
    background-color: var(--color-gray-900);
    color: var(--color-gray-100);
  }
}
@layer components {
  .container-app {
    margin-inline: auto;
    width: 100%;
    max-width: var(--container-7xl);
    padding-inline: calc(var(--spacing) * 4);
    @media (width >= 640px) {
      padding-inline: calc(var(--spacing) * 6);
    }
    @media (width >= 1024px) {
      padding-inline: calc(var(--spacing) * 8);
    }
    @media (width >= 1536px) {
      max-width: 1600px;
    }
  }
  .page-header {
    margin-bottom: calc(var(--spacing) * 4);
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 2);
    @media (width >= 640px) {
      margin-bottom: calc(var(--spacing) * 6);
    }
    @media (width >= 640px) {
      flex-direction: row;
    }
    @media (width >= 640px) {
      align-items: center;
    }
    @media (width >= 640px) {
      justify-content: space-between;
    }
    @media (width >= 768px) {
      margin-bottom: calc(var(--spacing) * 8);
    }
  }
  .page-title {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-gray-900);
    @media (width >= 640px) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
    @media (width >= 1024px) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
    &:where([data-theme=dark], [data-theme=dark] *) {
      color: var(--color-white);
    }
  }
  .card-grid {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: calc(var(--spacing) * 4);
    @media (width >= 640px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (width >= 1024px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @media (width >= 1280px) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .form-grid {
    display: grid;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    gap: calc(var(--spacing) * 4);
    @media (width >= 768px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (width >= 1024px) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @media (width >= 1280px) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .responsive-table-wrapper {
    width: 100%;
    overflow-x: auto;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-gray-200);
    &:where([data-theme=dark], [data-theme=dark] *) {
      border-color: var(--color-gray-700);
    }
  }
  .mobile-card-view {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing) * 3);
    @media (width >= 768px) {
      display: none;
    }
  }
  .desktop-table-view {
    display: none;
    @media (width >= 768px) {
      display: block;
    }
  }
}
@layer utilities {
  .feed-media-aspect-host {
    container-type: size;
  }
  .text-responsive-sm {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    @media (width >= 640px) {
      font-size: var(--text-sm);
      line-height: var(--tw-leading, var(--text-sm--line-height));
    }
  }
  .text-responsive-base {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    @media (width >= 640px) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .text-responsive-lg {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 640px) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
    @media (width >= 1024px) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .spacing-responsive {
    padding: var(--space-section);
  }
  .text-heading-lg {
    font-size: var(--text-heading-lg);
  }
  .text-heading-md {
    font-size: var(--text-heading-md);
  }
  .text-body {
    font-size: var(--text-body);
  }
  .text-base {
    font-size: var(--text-base);
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--line-height-body-xs);
  }
  .text-caption {
    font-size: var(--text-caption);
    line-height: var(--line-height-caption);
  }
  .gap-business-results {
    gap: var(--space-business-results);
  }
  .gap-business-result-row {
    gap: var(--space-business-result-row);
  }
  .gap-business-detail-section {
    gap: var(--space-business-detail-section);
  }
  .gap-business-actions {
    gap: var(--space-business-actions);
  }
  .p-page {
    padding: var(--space-page);
  }
  .p-section {
    padding: var(--space-section);
  }
  .gap-section {
    gap: var(--space-section);
  }
  .gap-page {
    gap: var(--space-page);
  }
  .gap-form {
    gap: var(--space-form);
  }
  .gap-field {
    gap: var(--space-field);
  }
  .px-page {
    padding-left: var(--space-page);
    padding-right: var(--space-page);
  }
  .py-page {
    padding-top: var(--space-page);
    padding-bottom: var(--space-page);
  }
  .px-section {
    padding-left: var(--space-section);
    padding-right: var(--space-section);
  }
  .py-section {
    padding-top: var(--space-section);
    padding-bottom: var(--space-section);
  }
  .rounded-field {
    border-radius: var(--radius-field);
  }
  .rounded-card {
    border-radius: var(--radius-card);
  }
  .rounded-control-sm {
    border-radius: var(--radius-control-sm);
  }
  .rounded-welcome-card {
    border-radius: var(--radius-welcome-card);
  }
  .rounded-dashboard-post {
    border-radius: var(--radius-dashboard-post);
  }
  .rounded-post-overlay {
    border-radius: var(--radius-post-overlay);
  }
  .icon-sm {
    width: var(--icon-sm);
    height: var(--icon-sm);
  }
  .icon-md {
    width: var(--icon-md);
    height: var(--icon-md);
  }
  .icon-lg {
    width: var(--icon-lg);
    height: var(--icon-lg);
  }
  .icon-xl {
    width: var(--icon-xl);
    height: var(--icon-xl);
  }
  .max-w-auth-form {
    max-width: var(--width-auth-form);
  }
  .max-w-onboarding {
    max-width: var(--width-onboarding);
  }
  .h-feed-create-post-modal {
    height: var(--height-feed-create-post-modal);
  }
  .w-feed-create-select-btn {
    width: var(--width-feed-create-select-btn);
  }
  .max-w-feed-create-caption-modal {
    max-width: var(--width-feed-create-caption-modal);
  }
  .h-feed-create-caption-content {
    height: var(--height-feed-create-caption-content);
  }
  .max-w-feed-gallery-modal {
    max-width: var(--width-feed-gallery-modal);
  }
  .h-feed-gallery-grid {
    height: var(--height-feed-gallery-grid);
  }
  .h-feed-cover-stage {
    height: var(--height-feed-cover-stage);
  }
  .h-feed-cover-filmstrip {
    height: var(--height-feed-cover-filmstrip);
  }
  .size-feed-cover-preview {
    width: var(--width-feed-cover-preview);
    height: var(--height-feed-cover-preview);
  }
  .w-feed-aspect-ratio-panel {
    width: var(--width-feed-aspect-ratio-panel);
  }
  .size-feed-overlay-icon {
    width: var(--size-feed-overlay-icon);
    height: var(--size-feed-overlay-icon);
  }
  .animate-feed-like-pop {
    animation: var(--animate-feed-like-pop);
    transform-origin: center;
  }
  .animate-feed-like-burst {
    animation: var(--animate-feed-like-burst);
    transform-origin: center;
  }
  .rounded-feed-caption-modal {
    border-radius: var(--radius-feed-caption-modal);
  }
  .w-feed-emoji-picker {
    width: var(--width-feed-emoji-picker);
  }
  .h-feed-emoji-picker {
    height: var(--height-feed-emoji-picker);
  }
  .max-w-feed-detail-modal {
    max-width: var(--width-feed-detail-modal);
  }
  .h-feed-detail-modal {
    height: var(--height-feed-detail-modal);
  }
  .w-feed-detail-media {
    width: var(--width-feed-detail-media);
  }
  .w-feed-detail-sidebar {
    width: var(--width-feed-detail-sidebar);
  }
  .max-w-feed-detail-sidebar {
    max-width: var(--width-feed-detail-sidebar);
  }
  .size-feed-detail-nav {
    width: var(--size-feed-detail-nav);
    height: var(--size-feed-detail-nav);
  }
  .max-w-otp-group {
    max-width: var(--width-otp-group);
  }
  .max-w-dashboard {
    max-width: var(--width-dashboard-content);
  }
  .max-w-profile-form {
    max-width: var(--width-profile-form);
  }
  .icon-nav {
    width: var(--icon-nav);
    height: var(--icon-nav);
  }
  .notification-badge {
    position: absolute;
    top: var(--offset-notification-badge);
    right: var(--offset-notification-badge);
    display: flex;
    width: var(--size-notification-badge);
    height: var(--size-notification-badge);
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    background-color: var(--color-merchant-notification-badge);
    font-size: var(--text-notification-badge);
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0;
    color: #fff;
    white-space: nowrap;
  }
  .gap-dashboard-section {
    gap: var(--space-dashboard-section);
  }
  .gap-dashboard-cards {
    gap: var(--space-dashboard-cards);
  }
  .logo-dashboard-header {
    height: var(--height-dashboard-logo);
    width: auto;
    max-width: var(--width-dashboard-logo);
  }
  .restaurant-profile-enter-panel-only {
    animation: slide-in-right var(--duration-restaurant-profile-enter) ease-out both;
  }
  .restaurant-profile-exit-sidebar {
    animation: slide-out-left var(--duration-restaurant-profile-exit) ease-in forwards;
  }
  .restaurant-profile-exit-panel {
    animation: slide-out-right var(--duration-restaurant-profile-exit) ease-in forwards;
  }
  @media (prefers-reduced-motion: reduce) {
    .restaurant-profile-enter-panel-only,
    .restaurant-profile-exit-sidebar,
    .restaurant-profile-exit-panel {
      animation: none;
    }
  }
  @keyframes skeleton-shimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
  .skeleton {
    display: block;
    background: linear-gradient(90deg, #eceef2 0%, #f7f7f8 40%, #eceef2 80%);
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.4s ease-in-out infinite;
    border-radius: var(--radius-field);
  }
  .skeleton-dark {
    background: linear-gradient(90deg, #1f1f1f 0%, #474747 40%, #1f1f1f 80%);
    background-size: 200% 100%;
  }
  .skeleton-strong {
    background: linear-gradient(90deg, #d9dce3 0%, #f2f3f6 40%, #d9dce3 80%);
    background-size: 200% 100%;
  }
  .skeleton-circle {
    border-radius: 999px;
  }
  .skeleton-line {
    height: 16px;
    width: 100%;
  }
  .skeleton-title {
    height: 28px;
    width: 60%;
  }
  .skeleton-field {
    height: var(--height-profile-field, 50px);
    width: 100%;
  }
  .skeleton-card {
    height: 120px;
    width: 100%;
    border-radius: var(--radius-card);
  }
}
.nudge-picker.ant-picker {
  width: 100%;
  padding: 12px;
  border-radius: var(--radius-field);
  background-color: #ffffff;
}
.nudge-picker.ant-picker:not(.ant-picker-status-error) {
  border-color: #e8e9ec;
}
.nudge-picker.ant-picker.ant-picker-status-error {
  border-color: var(--color-error);
}
.nudge-picker.ant-picker .ant-picker-input > input {
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #171717;
}
.nudge-picker.ant-picker .ant-picker-input > input::placeholder {
  color: #c2c6cf;
}
.nudge-picker.ant-picker.ant-picker-disabled {
  background-color: #f3f4f6;
}
.nudge-picker.ant-picker.ant-picker-disabled .ant-picker-input > input {
  color: #c2c6cf;
}
.nudge-generate-ai-btn {
  min-width: var(--width-nudge-ai-btn);
  height: var(--height-nudge-ai-btn);
  gap: var(--gap-nudge-ai-btn);
  padding: var(--padding-nudge-ai-btn-y) var(--padding-nudge-ai-btn-x);
  border-radius: 999px;
  border: var(--border-nudge-ai-btn) solid transparent;
  background: linear-gradient(#fff, #fff) padding-box,
    linear-gradient(93.03deg, #2b6cff 4.27%, #d8dae0 23.41%, #d8dae0 80.85%, #2b6cff 100%)
      border-box;
}
.nudge-media-ai-empty {
  gap: var(--gap-nudge-media-ai);
  padding: var(--padding-nudge-media-ai);
  border-radius: var(--radius-nudge-media-ai);
  border: 1px solid #e8e9ec;
  background: linear-gradient(180deg, rgba(43, 108, 255, 0.2) 0%, rgba(236, 238, 242, 0.2) 50%);
  background-color: #f3f4f6;
}
.nudge-media-ai-icon {
  width: var(--size-nudge-media-ai-icon);
  height: var(--size-nudge-media-ai-icon);
  background: linear-gradient(180deg, #87b2ff 0%, #2b6cff 100%);
  border: 1px solid #2b6cff;
}
.nudge-media-start-btn {
  overflow: hidden;
  min-width: 0;
  height: var(--height-nudge-media-start);
  min-height: var(--height-nudge-media-start);
  gap: var(--gap-nudge-media-start);
  padding: 0 var(--padding-nudge-media-start-x);
  border-radius: 999px;
  background-color: #568cff;
  background-position: 0 0,
    center;
}
.nudge-media-start-btn.is-hug {
  width: max-content;
}
.nudge-media-action-btn {
  min-height: var(--height-nudge-media-start);
  gap: var(--gap-nudge-media-start);
  padding: 0 var(--padding-nudge-media-start-x);
  border-radius: 999px;
}
.nudge-media-sources {
  gap: var(--gap-nudge-media-sources);
}
.nudge-media-source-btn {
  height: var(--height-nudge-media-source);
  gap: var(--gap-nudge-media-source);
  padding: 0 var(--padding-nudge-media-source-x);
  border: 1px solid var(--color-merchant-border);
  border-radius: var(--radius-nudge-media-source);
  background-color: #f3f4f6;
}
.nudge-media-close {
  width: var(--size-nudge-media-close);
  height: var(--size-nudge-media-close);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
}
.nudge-media-or {
  gap: var(--gap-nudge-media-or);
}
.nudge-media-or-line {
  height: 1px;
  background-color: var(--color-merchant-border);
}
.nudge-media-stack {
  gap: var(--gap-nudge-media-stack);
}
.nudge-ai-chat-launcher {
  width: var(--size-nudge-ai-launcher);
  height: var(--size-nudge-ai-launcher);
  border: 1px solid var(--color-merchant-border-strong);
}
.nudge-ai-chat-launcher-dot {
  position: absolute;
  width: var(--size-nudge-ai-launcher-dot);
  height: var(--size-nudge-ai-launcher-dot);
  top: 1px;
  right: 1px;
  pointer-events: none;
}
.nudge-ai-chat-panel {
  width: 100%;
  max-width: var(--width-nudge-ai-chat);
  height: 100%;
}
.nudge-ai-chat-header {
  min-height: var(--size-nudge-ai-close);
  padding: 16px;
}
.nudge-ai-chat-body {
  padding: var(--gap-nudge-ai-chat) var(--padding-nudge-ai-chat) 0;
}
.nudge-ai-composer-wrap {
  padding: var(--gap-nudge-ai-chat) var(--padding-nudge-ai-chat) var(--padding-nudge-ai-chat);
}
.nudge-ai-close {
  min-height: 44px;
  min-width: 44px;
}
.nudge-ai-close-icon {
  width: var(--size-nudge-ai-close);
  height: var(--size-nudge-ai-close);
}
.nudge-ai-composer {
  min-height: 0;
  gap: var(--gap-nudge-ai-composer);
  padding: var(--padding-nudge-ai-composer-y) var(--padding-nudge-ai-composer-x);
  border-radius: var(--radius-nudge-ai-composer);
  background-color: var(--color-merchant-bg-subtle);
  overflow: visible;
}
.nudge-ai-thumbs {
  gap: var(--gap-nudge-ai-composer);
  overflow: visible;
  padding: 4px 4px 2px;
}
.nudge-ai-send {
  width: var(--size-nudge-ai-send);
  height: var(--size-nudge-ai-send);
}
.nudge-ai-composer-prompt {
  display: block;
  width: 100%;
  resize: none;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: var(--line-height-nudge-ai-prompt);
  max-height: calc(var(--line-height-nudge-ai-prompt) * 5);
  padding: 0;
  padding-inline-end: 6px;
  line-height: var(--line-height-nudge-ai-prompt);
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #d8dae0 transparent;
}
.nudge-ai-composer-prompt::-webkit-scrollbar {
  width: 4px;
}
.nudge-ai-composer-prompt::-webkit-scrollbar-track {
  background: transparent;
}
.nudge-ai-composer-prompt::-webkit-scrollbar-thumb {
  background: #d8dae0;
  border-radius: 999px;
}
.nudge-ai-source-toggle {
  display: inline-flex;
  flex-shrink: 0;
  align-items: stretch;
  height: var(--height-nudge-ai-segment);
  padding: var(--padding-nudge-ai-segment);
  border: 1px solid var(--color-merchant-border);
  border-radius: 999px;
  background-color: #fff;
}
.nudge-ai-source-option {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 0 var(--padding-nudge-ai-segment-x);
  border: 0;
  border-radius: 999px;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--color-merchant-text-secondary);
  outline: none;
  white-space: nowrap;
}
.nudge-ai-source-option.is-active {
  background-color: var(--color-merchant-text-primary);
  font-weight: 600;
  color: #fff;
}
.nudge-ai-source-option:disabled {
  cursor: not-allowed;
}
.nudge-ai-thumb {
  width: var(--size-nudge-ai-upload);
  height: var(--size-nudge-ai-upload);
}
.nudge-ai-thumb-media {
  width: 100%;
  height: 100%;
}
.nudge-ai-thumb-media.is-processing {
  opacity: 0.65;
}
.nudge-ai-thumb-ring {
  position: absolute;
  inset: -4px;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  pointer-events: none;
  transform-origin: 50% 50%;
  animation: var(--animate-nudge-ai-thumb-spin);
}
.nudge-ai-thumb-dots {
  fill: none;
  stroke: var(--color-merchant-primary);
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-dasharray: 2 5.8;
}
.nudge-ai-upload-loader {
  position: relative;
  display: flex;
  width: var(--size-nudge-ai-upload);
  height: var(--size-nudge-ai-upload);
  align-items: center;
  justify-content: center;
  animation: var(--animate-nudge-ai-upload-in);
}
.nudge-ai-upload-loader.is-featured {
  width: var(--size-nudge-ai-upload-lg);
  height: var(--size-nudge-ai-upload-lg);
}
.nudge-ai-upload-ring {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
}
.nudge-ai-upload-ring-spin {
  transform-origin: 50% 50%;
  animation: var(--animate-nudge-ai-upload-spin);
}
.nudge-ai-upload-track {
  fill: none;
  stroke: rgb(43 108 255 / 0.14);
  stroke-width: 2;
}
.nudge-ai-upload-arc {
  fill: none;
  stroke: var(--color-merchant-primary);
  stroke-width: 2.25;
  stroke-linecap: round;
  stroke-dasharray: 36 96;
}
.ant-empty-image img {
  margin: 0 auto;
}
.nudge-ai-upload-media {
  width: 78%;
  height: 78%;
  overflow: hidden;
  border-radius: 50%;
  background-color: var(--color-merchant-bg-subtle);
  animation: var(--animate-nudge-ai-upload-pulse);
}
.nudge-ai-upload-placeholder {
  display: block;
  width: 100%;
  height: 100%;
  background-color: var(--color-merchant-bg-hover);
}
.nudge-ai-creating-card {
  position: relative;
  width: var(--size-nudge-ai-creating);
  height: var(--size-nudge-ai-creating);
  overflow: hidden;
  border: 1px solid #e8e9ec;
  border-radius: var(--radius-nudge-ai-creating);
  background-color: #ffffff;
  padding: var(--padding-nudge-ai-creating);
}
.nudge-ai-creating-title {
  position: relative;
  z-index: 1;
  color: var(--color-merchant-text-secondary);
}
.nudge-ai-creating-field {
  position: absolute;
  top: calc(var(--padding-nudge-ai-creating) + 22px);
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  border-radius: 0 0 var(--radius-nudge-ai-creating) var(--radius-nudge-ai-creating);
}
.nudge-ai-creating-dots-svg {
  display: block;
  width: 100%;
  height: 100%;
}
.nudge-ai-creating-dot {
  transform-box: fill-box;
  transform-origin: center;
  animation: var(--animate-nudge-ai-creating-twinkle), var(--animate-nudge-ai-creating-blink);
  animation-delay: var(--travel-delay, 0s), var(--blink-delay, 0s);
}
.nudge-ai-media-actions {
  position: absolute;
  inset-inline-start: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  gap: var(--gap-nudge-ai-media-actions);
  padding: var(--padding-nudge-ai-media-actions);
}
@media (hover: hover) and (pointer: fine) {
  .nudge-ai-media-card:not(:hover):not(:focus-within) .nudge-ai-media-actions {
    opacity: 0;
    pointer-events: none;
  }
  .nudge-ai-media-actions {
    opacity: 1;
    pointer-events: auto;
    transition: opacity 0.15s ease;
  }
}
@media (prefers-reduced-motion: reduce) {
  .nudge-ai-thumb-ring,
  .nudge-ai-upload-loader,
  .nudge-ai-upload-ring-spin,
  .nudge-ai-upload-media,
  .nudge-ai-creating-dot {
    animation: none;
  }
  .nudge-ai-media-actions {
    transition: none;
  }
  .nudge-ai-upload-media {
    opacity: 0.88;
  }
}
.nudge-ai-icon-wrap {
  width: var(--size-nudge-ai-icon-wrap);
  height: var(--size-nudge-ai-icon-wrap);
  border-radius: var(--radius-nudge-ai-icon-wrap);
}
.nudge-ai-empty {
  width: 100%;
  max-width: var(--width-nudge-ai-empty);
  gap: var(--gap-nudge-ai-empty);
}
@media (min-width: 1551px) {
  .nudge-ai-close {
    min-height: var(--size-nudge-ai-close);
    min-width: var(--size-nudge-ai-close);
  }
}
.business-hours-time-picker.ant-picker {
  width: 100%;
  min-height: var(--input-height);
  border-radius: var(--radius-field);
  background-color: var(--color-merchant-bg-subtle);
  padding: 12px;
}
.business-hours-time-picker.ant-picker:not(.ant-picker-status-error) {
  border-color: var(--color-merchant-border);
}
.business-hours-time-picker.ant-picker .ant-picker-input > input {
  color: var(--color-merchant-text-secondary);
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
}
.recharts-wrapper,
.recharts-wrapper:focus,
.recharts-wrapper:focus-visible,
.recharts-wrapper *:focus,
.recharts-wrapper *:focus-visible,
.recharts-surface,
.recharts-surface:focus,
.recharts-surface:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.custom-trigger-class input {
  font-size: 12px !important;
  width: 40px !important;
}
.custom-trigger-class .ant-picker-range-separator {
  padding: 0 !important;
}
.custom-modal .ant-modal-content {
  padding: 0 !important;
}
@media (max-width: 1550px) {
  .nudge-ai-close {
    min-height: 36px;
    min-width: 36px;
  }
  .nudge-ai-chat-header {
    padding: 12px;
  }
  .text-base {
    font-size: 14px;
  }
  .custom-trigger-class input {
    font-size: 10px !important;
    width: 35px !important;
  }
  .custom-modal {
    width: 500px !important;
  }
  .max-w-dashboard {
    max-width: 900px;
  }
  :root {
    --space-page: 36px;
    --space-section: 24px;
    --space-form: 18px;
    --space-field: 12px;
    --text-heading-lg: 24px;
    --text-heading-md: 18px;
    --text-body: 14px;
    --text-caption: 9px;
    --line-height-caption: 12px;
    --line-height-body-xs: 15px;
    --space-business-results: 9px;
    --space-business-result-row: 3px;
    --space-business-detail-section: 12px;
    --space-business-actions: 9px;
    --radius-field: 6px;
    --radius-card: 12px;
    --radius-control-sm: 3px;
    --radius-welcome-card: 9px;
    --radius-dashboard-post: 9px;
    --radius-post-overlay: 4px;
    --width-business-switcher: 314px;
    --width-profile-form: 416px;
    --height-profile-field: 44px;
    --width-auth-form: 500px;
    --width-onboarding: 500px;
    --icon-sm: 12px;
    --icon-md: 15px;
    --icon-lg: 18px;
    --icon-xl: 24px;
    --input-height: 44px;
    --space-dashboard-section: 12px;
    --space-dashboard-cards: 9px;
    --padding-welcome-card: 18px;
    --padding-post-overlay: 4px;
    --height-feed-create-post-modal: 510px;
    --width-feed-create-select-btn: 146px;
    --width-feed-create-caption-modal: 930px;
    --height-feed-create-caption-content: 466px;
    --width-feed-gallery-modal: 660px;
    --height-feed-gallery-grid: 493px;
    --height-feed-cover-stage: 256px;
    --height-feed-cover-filmstrip: 48px;
    --width-feed-cover-preview: 150px;
    --height-feed-cover-preview: 188px;
    --width-nudge-cover-preview: 225px;
    --width-feed-aspect-ratio-panel: 154px;
    --size-feed-overlay-icon: 16px;
    --radius-feed-caption-modal: 12px;
    --width-feed-emoji-picker: 240px;
    --height-feed-emoji-picker: 261px;
    --width-feed-detail-modal: 1066px;
    --height-feed-detail-modal: 660px;
    --width-feed-detail-media: 660px;
    --width-feed-detail-sidebar: 406px;
    --size-feed-detail-nav: 36px;
    --height-dashboard-logo: 33px;
    --width-dashboard-logo: 405px;
    --icon-nav: 14px;
    --size-notification-badge: 18px;
    --text-notification-badge: 10px;
    --offset-notification-badge: -6px;
    --width-nudge-ai-btn: 134px;
    --height-nudge-ai-btn: 44px;
    --padding-nudge-ai-btn-y: 8px;
    --padding-nudge-ai-btn-x: 14px;
    --gap-nudge-ai-btn: 3px;
    --width-nudge-ai-chat: 402px;
    --padding-nudge-ai-chat: 30px;
    --gap-nudge-ai-chat: 18px;
    --gap-nudge-ai-empty: 18px;
    --size-nudge-ai-close: 24px;
    --size-nudge-ai-icon-wrap: 54px;
    --width-nudge-ai-empty: 390px;
    --height-nudge-ai-composer: 44px;
    --size-nudge-ai-send: 32px;
    --size-nudge-ai-thumb: 32px;
    --padding-nudge-ai-composer-x: 8px;
    --padding-nudge-ai-composer-y: 8px;
    --gap-nudge-ai-composer: 6px;
    --line-height-nudge-ai-prompt: 16px;
    --radius-nudge-ai-composer: 12px;
    --radius-nudge-ai-icon-wrap: 12px;
    --size-nudge-ai-upload: 44px;
    --size-nudge-ai-upload-lg: 64px;
    --size-nudge-ai-creating: 210px;
    --radius-nudge-ai-creating: 18px;
    --padding-nudge-ai-creating: 15px;
    --height-nudge-ai-segment: 28px;
    --padding-nudge-ai-segment: 2px;
    --padding-nudge-ai-segment-x: 9px;
    --padding-nudge-ai-media-actions: 8px;
    --gap-nudge-ai-media-actions: 6px;
    --padding-nudge-media-ai: 30px 24px 24px;
    --gap-nudge-media-ai: 12px;
    --radius-nudge-media-ai: 8px;
    --size-nudge-media-ai-icon: 36px;
    --height-nudge-media-start: 36px;
    --padding-nudge-media-start-x: 16px;
    --gap-nudge-media-start: 6px;
    --gap-nudge-media-stack: 18px;
    --gap-nudge-media-or: 9px;
    --size-nudge-media-close: 18px;
    --height-nudge-media-source: 44px;
    --padding-nudge-media-source-x: 18px;
    --gap-nudge-media-source: 12px;
    --gap-nudge-media-sources: 9px;
    --radius-nudge-media-source: 6px;
    --size-nudge-ai-launcher: 32px;
    --size-nudge-ai-launcher-dot: 5px;
  }
  .nudge-picker.ant-picker {
    padding: 8px;
  }
  .nudge-ai-source-option {
    font-size: 12px;
    line-height: 16px;
  }
}
@media (max-width: 767px) {
  :root {
    --space-page: 24px;
    --space-section: 16px;
    --space-form: 16px;
    --space-field: 10px;
    --text-heading-lg: 20px;
    --text-heading-md: 16px;
    --text-body: 14px;
    --text-base: 14px;
    --text-sm: 10px;
    --text-caption: 8px;
    --line-height-caption: 11px;
    --line-height-body-xs: 14px;
    --space-business-results: 8px;
    --space-business-result-row: 2px;
    --space-business-detail-section: 10px;
    --space-business-actions: 8px;
    --radius-field: 4px;
    --radius-card: 8px;
    --radius-welcome-card: 6px;
    --radius-dashboard-post: 6px;
    --radius-post-overlay: 3px;
    --icon-sm: 10px;
    --icon-md: 12px;
    --icon-lg: 14px;
    --icon-xl: 18px;
    --input-height: 44px;
    --height-feed-create-post-modal: 408px;
    --width-feed-create-select-btn: 117px;
    --width-feed-create-caption-modal: 744px;
    --height-feed-create-caption-content: 373px;
    --width-feed-gallery-modal: 100%;
    --height-feed-gallery-grid: 60vh;
    --height-feed-cover-stage: 220px;
    --height-feed-cover-filmstrip: 44px;
    --width-feed-cover-preview: 120px;
    --height-feed-cover-preview: 150px;
    --width-feed-aspect-ratio-panel: 123px;
    --size-feed-overlay-icon: 13px;
    --radius-feed-caption-modal: 8px;
    --width-feed-emoji-picker: 100%;
    --height-feed-emoji-picker: 220px;
    --width-feed-detail-modal: 100%;
    --height-feed-detail-modal: auto;
    --width-feed-detail-media: 100%;
    --width-feed-detail-sidebar: 100%;
    --size-feed-detail-nav: 44px;
    --height-dashboard-logo: 28px;
    --width-dashboard-logo: 160px;
    --icon-nav: 12px;
    --size-notification-badge: 16px;
    --text-notification-badge: 10px;
    --offset-notification-badge: -4px;
    --width-business-switcher: 100%;
    --width-profile-form: 100%;
    --height-profile-field: 44px;
    --width-nudge-ai-btn: 120px;
    --height-nudge-ai-btn: 44px;
    --padding-nudge-ai-btn-y: 6px;
    --padding-nudge-ai-btn-x: 12px;
    --gap-nudge-ai-btn: 2px;
    --padding-nudge-ai-chat: 24px;
    --gap-nudge-ai-chat: 16px;
    --gap-nudge-ai-empty: 16px;
    --size-nudge-ai-close: 24px;
    --size-nudge-ai-icon-wrap: 48px;
    --width-nudge-ai-empty: 100%;
    --height-nudge-ai-composer: 44px;
    --size-nudge-ai-send: 32px;
    --size-nudge-ai-thumb: 32px;
    --padding-nudge-ai-composer-x: 8px;
    --padding-nudge-ai-composer-y: 8px;
    --gap-nudge-ai-composer: 4px;
    --line-height-nudge-ai-prompt: 16px;
    --radius-nudge-ai-composer: 8px;
    --radius-nudge-ai-icon-wrap: 8px;
    --size-nudge-ai-upload: 44px;
    --size-nudge-ai-upload-lg: 56px;
    --size-nudge-ai-creating: 168px;
    --radius-nudge-ai-creating: 16px;
    --padding-nudge-ai-creating: 12px;
    --height-nudge-ai-segment: 28px;
    --padding-nudge-ai-segment: 2px;
    --padding-nudge-ai-segment-x: 8px;
    --padding-nudge-ai-media-actions: 8px;
    --gap-nudge-ai-media-actions: 6px;
    --padding-nudge-media-ai: 24px 16px 16px;
    --gap-nudge-media-ai: 12px;
    --radius-nudge-media-ai: 8px;
    --size-nudge-media-ai-icon: 32px;
    --height-nudge-media-start: 32px;
    --padding-nudge-media-start-x: 16px;
    --gap-nudge-media-start: 6px;
    --gap-nudge-media-stack: 16px;
    --gap-nudge-media-or: 8px;
    --size-nudge-media-close: 18px;
    --height-nudge-media-source: 44px;
    --padding-nudge-media-source-x: 12px;
    --gap-nudge-media-source: 8px;
    --gap-nudge-media-sources: 8px;
    --radius-nudge-media-source: 4px;
    --size-nudge-ai-launcher: 36px;
    --size-nudge-ai-launcher-dot: 6px;
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-scale-x {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-y {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-scale-z {
  syntax: "*";
  inherits: false;
  initial-value: 1;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-gradient-position {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-via {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-to {
  syntax: "<color>";
  inherits: false;
  initial-value: #0000;
}
@property --tw-gradient-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-via-stops {
  syntax: "*";
  inherits: false;
}
@property --tw-gradient-from-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 0%;
}
@property --tw-gradient-via-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 50%;
}
@property --tw-gradient-to-position {
  syntax: "<length-percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes feed-like-pop {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(0.8);
  }
  45% {
    transform: scale(1.4);
  }
  70% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes feed-like-burst {
  0% {
    opacity: 0.55;
    transform: scale(0.35);
  }
  45% {
    opacity: 0.3;
    transform: scale(1.55);
  }
  100% {
    opacity: 0;
    transform: scale(2.1);
  }
}
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in-right {
  from {
    opacity: 0;
    transform: translateX(32px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes nudge-ai-thumb-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes nudge-ai-upload-spin {
  from {
    transform: rotate(-90deg);
  }
  to {
    transform: rotate(270deg);
  }
}
@keyframes nudge-ai-upload-pulse {
  0%,
    100% {
    opacity: 0.78;
    transform: scale(1);
  }
  50% {
    opacity: 0.96;
    transform: scale(1.04);
  }
}
@keyframes nudge-ai-upload-in {
  from {
    opacity: 0;
    transform: scale(0.94);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes nudge-ai-creating-twinkle {
  0%,
    100% {
    opacity: 0.34;
    transform: scale(0.96);
  }
  36% {
    opacity: 0.5;
    transform: scale(0.98);
  }
  50% {
    opacity: 1;
    transform: scale(1.08);
  }
  64% {
    opacity: 0.5;
    transform: scale(0.98);
  }
}
@keyframes nudge-ai-creating-blink {
  0%,
    100% {
    filter: brightness(1);
  }
  50% {
    filter: brightness(1.08);
  }
}
@keyframes slide-out-right {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(32px);
  }
}
@keyframes slide-out-left {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-24px);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: block))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-scale-x: 1;
      --tw-scale-y: 1;
      --tw-scale-z: 1;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-gradient-position: initial;
      --tw-gradient-from: #0000;
      --tw-gradient-via: #0000;
      --tw-gradient-to: #0000;
      --tw-gradient-stops: initial;
      --tw-gradient-via-stops: initial;
      --tw-gradient-from-position: 0%;
      --tw-gradient-via-position: 50%;
      --tw-gradient-to-position: 100%;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA,iEAAA;ACo7BE,iBAAmB;AAp7BrB,yCAAyC;AAEzC;EACE;ICEA,uFAAwF;IDItF;8BAE0B;IA0N1B,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,2CAA2C;IAC3C,4CAA4C;IAC5C,4CAA4C;IAC5C,0CAA0C;IAuF1C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAUlB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IAEtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IAEtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAiB3C,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAMvB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IAGxB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IAIrB,qBAAqB;IC1WvB,gBAAiB;IACjB,gBAAiB;IACjB,iBAAkB;IAClB,iBAAkB;IAClB,kBAAmB;ID4WjB,oBAAoB;IAsCpB,sCAAsC;IAGtC,uCAAuC;IAEvC,+DAA+D;IAsC/D,eAAe;IAYf,sBAAsB;IAEtB,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;ICxf3D,2BAA4B;IAC5B,4BAA6B;IAE7B,4BAA6B;IAC7B,4BAA6B;IAC7B,4BAA6B;IAM7B,wBAAyB;IACzB,wBAAyB;IACzB,sBAAuB;IAGvB,gCAAiC;IACjC,iCAAkC;IAClC,sCAAuC;IACvC,wCAAyC;IACzC,0CAA2C;IAC3C,uCAAwC;IACxC,mCAAoC;IACpC,kCAAmC;IACnC,mCAAoC;IACpC,gCAAiC;IACjC,uCAAwC;IACxC,iCAAkC;IAClC,4CAA6C;IAkB7C,4BAA6B;IAE7B,2CAA4C;IAC5C,0CAA2C;IAE3C,uDAAwD;IAExD,uEAAwE;IACxE,0EAA2E;IAC3E,gFAAiF;IACjF,8DAA+D;IAC/D,mFAAoF;IACpF,oFAAqF;IACrF,0EAA2E;IAC3E,kEAAmE;EDjEpD;AADJ;AAohBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,8NAcC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EA3BpC;EAoCN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADqB;EAQpC;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAxZnC;AA6ZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,UAAmB;IAAnB,WAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,UAAmB;IAAnB,WAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,YAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,YAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,YAAmB;IAAnB,aAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,uDAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kEAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,2DAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,4CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,0CAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,+GAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,8DAAmB;EAAA;EAAnB;IAAA,wDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,QAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,8EAAmB;IAAnB,sFAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,2CAAmB;IAAnB,wCAAmB;IAAnB,wDAAmB;IAAnB,qEAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,6BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,4BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,yBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,oBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,sEAAmB;IAAnB;MAAA,qFAAmB;IAAA;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,4DAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+DAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,uFAAmB;IAAA;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,qDAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,+CAAmB;EAAA;EAAnB;IAAA,8DAAmB;IAAnB;MAAA,qFAAmB;IAAA;EAAA;EAAnB;IAAA,oDAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;IAAnB;MAAA,gDAAmB;IAAA;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,oEAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,4EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,4EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6DAAmB;IAAnB;MAAA,4EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,4DAAmB;IAAnB;MAAA,2EAAmB;IAAA;IAAnB,4NAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,0DAAmB;IAAnB;MAAA,yEAAmB;IAAA;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iDAAmB;IAAnB,gDAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,iBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,eAAmB;IAAnB,cAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iCAAmB;EAAA;EAAnB;IAAA,sDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,gBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB,iDAAmB;EAAA;EAAnB;IAAA,qBAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,sDAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,mDAAmB;IAAnB;MAAA,iFAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,+DAAmB;IAAA;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,sJAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,iEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,mEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,oEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0EAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,0LAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sBAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,kEAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,yHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,0FAAmB;IAAnB,4CAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,4CAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,6FAAmB;IAAnB,4CAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,2FAAmB;IAAnB,4CAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,8FAAmB;IAAnB,4CAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,gGAAmB;IAAnB,4CAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,mMAAmB;EAAA;EAAnB;IAAA,mMAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,iSAAmB;IAAnB,yRAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,iSAAmB;IAAnB,yRAAmB;EAAA;EAAnB;IAAA,6BAAmB;IAAnB,iSAAmB;IAAnB,yRAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,iSAAmB;IAAnB,yRAAmB;EAAA;EAAnB;IAAA,8BAAmB;IAAnB,iSAAmB;IAAnB,yRAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,iSAAmB;IAAnB,yRAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,iSAAmB;IAAnB,yRAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,+BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wDAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,2CAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,8BAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA;MAAA,WAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,kBAAmB;MAAnB,kBAAmB;MAAnB,0CAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,kBAAmB;MAAnB,kBAAmB;MAAnB,0CAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,iDAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,2DAAmB;IAAA;IAAnB;MAAA;QAAA,0EAAmB;MAAA;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,8CAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,iDAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,2DAAmB;IAAA;IAAnB;MAAA;QAAA,0EAAmB;MAAA;IAAA;IAAnB;MAAA,2DAAmB;IAAA;IAAnB;MAAA;QAAA,0EAAmB;MAAA;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,6HAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,2CAAmB;EAAA;EAAnB;IAAA,yHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,iDAAmB;EAAA;EAAnB;IAAA,yHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,8CAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6GAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6GAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;IAAnB;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,OAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,2BAAmB;MAAnB,6DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;MAAnB,kCAAmB;IAAA;IAAnB;MAAA,kCAAmB;MAAnB,mCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;MAAnB,kCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,YAAmB;MAAnB,aAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,gEAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,OAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,kDAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,qBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,oCAAmB;MAAnB,mBAAmB;IAAA;IAAnB;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;IAAnB;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,2CAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,wCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,cAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,sBAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,0CAAmB;MAAnB,uBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,8CAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,qBAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,4BAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;MAAnB,kCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;MAAnB,kCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;MAAnB,kCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;MAAnB,kCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,kCAAmB;MAAnB,mCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,kCAAmB;MAAnB,mCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,YAAmB;MAAnB,aAAmB;IAAA;IAAnB;MAAA,YAAmB;MAAnB,aAAmB;IAAA;IAAnB;MAAA,YAAmB;MAAnB,aAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,2DAAmB;IAAA;IAAnB;MAAA,WAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,6CAAmB;MAAnB,sDAAmB;IAAA;IAAnB;MAAA,6CAAmB;MAAnB,sDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,gDAAmB;IAAA;IAAnB;MAAA,8DAAmB;IAAA;IAAnB;MAAA,wDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,yBAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,QAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,SAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,sBAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,yCAAmB;IAAA;IAAnB;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,oCAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,uBAAmB;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,mCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,kCAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,qDAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,oDAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,oBAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,mBAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,0CAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,kBAAmB;IAAA;IAAnB;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;IAAnB;MAAA,2BAAmB;MAAnB,6DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA;QAAA,eAAmB;MAAA;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,uCAAmB;IAAA;IAAnB;MAAA,yCAAmB;MAAnB,wCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,uCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,uCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,wCAAmB;MAAnB,uCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,uCAAmB;MAAnB,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;MAAnB,sCAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,kEAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;IAAnB;MAAA,+BAAmB;MAAnB,gCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,gCAAmB;MAAnB,iCAAmB;IAAA;IAAnB;MAAA,WAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,YAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,aAAmB;IAAA;IAAnB;MAAA,qCAAmB;IAAA;IAAnB;MAAA,gCAAmB;IAAA;IAAnB;MAAA,oCAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,6BAAmB;IAAA;IAAnB;MAAA,8BAAmB;IAAA;IAAnB;MAAA,+BAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,iCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;IAAnB;MAAA,wCAAmB;IAAA;IAAnB;MAAA,iBAAmB;IAAA;IAAnB;MAAA,yCAAmB;IAAA;IAAnB;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,eAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,sCAAmB;MAAnB,qCAAmB;IAAA;IAAnB;MAAA,uCAAmB;MAAnB,sCAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,kBAAmB;MAAnB,iBAAmB;IAAA;IAAnB;MAAA,qBAAmB;MAAnB,sBAAmB;IAAA;IAAnB;MAAA,qBAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,uCAAmB;IAAnB,8LAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;IAAnB;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2DAAmB;IAAA;IAAnB;MAAA;QAAA,0EAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;AADJ;ACzrBjB;EACE,kBAAmB;EACnB,qBAAsB;EACtB,kBAAmB;EACnB,mBAAoB;EACpB,uBAAwB;EACxB,uBAAwB;EACxB,iBAAkB;EAClB,iBAAkB;EAClB,eAAgB;EAChB,oBAAqB;EACrB,2BAA4B;EAC5B,2BAA4B;EAC5B,8BAA+B;EAC/B,gCAAiC;EACjC,qCAAsC;EACtC,8BAA+B;EAC/B,mBAAoB;EACpB,mBAAoB;EACpB,sBAAuB;EACvB,wBAAyB;EACzB,eAAgB;EAChB,eAAgB;EAChB,eAAgB;EAChB,eAAgB;EAChB,oBAAqB;EACrB,wBAAyB;EACzB,yBAA0B;EAC1B,qCAAsC;EACtC,sCAAuC;EACvC,yCAA0C;EAC1C,2CAA4C;EAC5C,iCAAkC;EAClC,iCAAkC;EAClC,gCAAiC;EACjC,mCAAoC;EACpC,iCAAkC;EAClC,kCAAmC;EACnC,kCAAmC;EACnC,sCAAuC;EACvC,8BAA+B;EAC/B,iCAAkC;EAClC,gCAAiC;EACjC,iCAAkC;EAClC,iCAAkC;EAClC,iCAAkC;EAClC,gCAAiC;EACjC,kCAAmC;EACnC,4BAA6B;EAC7B,wBAAyB;EACzB,iCAAkC;EAClC,gCAAiC;EACjC,6BAA8B;EAC9B,6BAA8B;EAC9B,gBAAiB;EACjB,+BAAgC;EAChC,+BAAgC;EAChC,iCAAkC;EAClC,+BAAgC;EAChC,6BAA8B;EAC9B,2BAA4B;EAC5B,6BAA8B;EAC9B,4BAA6B;EAC7B,2BAA4B;EAC5B,0BAA2B;EAC3B,2BAA4B;EAC5B,4BAA6B;EAC7B,0CAA2C;EAC3C,wCAAyC;EACzC,2BAA4B;EAC5B,2BAA4B;EAC5B,8BAA+B;EAC/B,8BAA+B;EAC/B,uBAAwB;EACxB,0BAA2B;EAC3B,4BAA6B;EAC7B,6BAA8B;EAC9B,yBAA0B;EAC1B,0BAA2B;EAC3B,2BAA4B;EAC5B,+BAAgC;EAChC,6BAA8B;EAC9B,gCAAiC;EACjC,0BAA2B;EAC3B,2BAA4B;EAC5B,kCAAmC;EACnC,mCAAoC;EACpC,4BAA6B;EAC7B,mCAAoC;EACpC,gCAAiC;EACjC,iCAAkC;EAClC,4BAA6B;EAC7B,+BAAgC;EAChC,+BAAgC;EAChC,gCAAiC;EACjC,iCAAkC;EAClC,+BAAgC;EAChC,+BAAgC;EAChC,kCAAmC;EACnC,sCAAuC;EACvC,iCAAkC;EAClC,wCAAyC;EACzC,0BAA2B;EAC3B,6BAA8B;EAC9B,gCAAiC;EACjC,gCAAiC;EACjC,mCAAoC;EACpC,4BAA6B;EAC7B,6BAA8B;EAC9B,0BAA2B;EAC3B,8BAA+B;EAC/B,iCAAkC;EAClC,oCAAqC;EACrC,8BAA+B;EAC/B,+BAAgC;EAChC,gCAAiC;EACjC,8BAA+B;EAC/B,iCAAkC;AACnC;AAED;EACE;IACE,wBAAyB;EAC1B;AACF;AAED;EACE;;;;;IAKE,iDAAkD;EACnD;EAED;IACS,uBAAa;IAAC,mCAAW;IAAX,kCAAW;EACjC;EAED;IACS,WAAG;IAAC,iBAAY;IAAyB,sCAAU;IAAlC,6BAAS;IAAC,4BAAa;EAChD;EAED;IACS,uCAAW;IAAC,4BAAa;EACjC;AACF;AAED;EACE;IACS,mBAAO;IAAC,WAAM;IAAC,+BAAS;IAAC,wCAAI;IAAC;MAAA,wCAAO;IAAA;IAAC;MAAA,wCAAO;IAAA;IAAC;MAAA,iBAAkB;IAAA;EACxE;EAED;IACS,uCAAI;IAAC,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAAC;MAAA,uCAAO;IAAA;IAAC;MAAA,mBAAW;IAAA;IAAC;MAAA,mBAAe;IAAA;IAAC;MAAA,8BAAkB;IAAA;IAAC;MAAA,uCAAO;IAAA;EAC/F;EAED;IACS,yBAAO;IAAP,2DAAO;IAAC,6CAAa;IAAb,wCAAa;IAAC,4BAAa;IAAC;MAAA,0BAAW;MAAX,4DAAW;IAAA;IAAC;MAAA,0BAAW;MAAX,4DAAW;IAAA;IAAC;MAAA,yBAAe;IAAA;EACnF;EAED;IACS,aAAI;IAAC,gDAAW;IAAC,6BAAK;IAAC;MAAA,gDAAc;IAAA;IAAC;MAAA,gDAAc;IAAA;IAAC;MAAA,gDAAc;IAAA;EAC3E;EAED;IACS,aAAI;IAAC,gDAAW;IAAC,6BAAK;IAAC;MAAA,gDAAc;IAAA;IAAC;MAAA,gDAAc;IAAA;IAAC;MAAA,gDAAc;IAAA;EAC3E;EAED;IACS,WAAM;IAAC,gBAAe;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,mCAAe;IAAC;MAAA,mCAAoB;IAAA;EACrF;EAED;IACS,aAAI;IAAC,sBAAQ;IAAC,6BAAK;IAAC;MAAA,aAAS;IAAA;EACrC;EAED;IACS,aAAM;IAAC;MAAA,cAAQ;IAAA;EACvB;AACF;AAED;EAEE;IACE,oBAAqB;EACtB;EAED;IACS,yBAAO;IAAP,2DAAO;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;EAC1B;EAED;IACS,yBAAO;IAAP,2DAAO;IAAC;MAAA,2BAAY;MAAZ,6DAAY;IAAA;EAC5B;EAED;IACS,2BAAS;IAAT,6DAAS;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;EACvC;EAED;IACE,6BAA8B;EAC/B;EAED;IACE,iCAAkC;EACnC;EAED;IACE,iCAAkC;EACnC;EAED;IACE,2BAA4B;EAC7B;EAED;IACE,2BAA4B;EAC7B;EAED;IACE,yBAA0B;IAC1B,uCAAwC;EACzC;EAED;IACE,8BAA+B;IAC/B,uCAAwC;EACzC;EAED;IACE,kCAAmC;EACpC;EAED;IACE,qCAAsC;EACvC;EAED;IACE,yCAA0C;EAC3C;EAED;IACE,kCAAmC;EACpC;EAED;IACE,0BAA2B;EAC5B;EAED;IACE,6BAA8B;EAC/B;EAED;IACE,yBAA0B;EAC3B;EAED;IACE,sBAAuB;EACxB;EAED;IACE,sBAAuB;EACxB;EAED;IACE,uBAAwB;EACzB;EAED;IACE,+BAAgC;IAChC,gCAAiC;EAClC;EAED;IACE,8BAA+B;IAC/B,iCAAkC;EACnC;EAED;IACE,kCAAmC;IACnC,mCAAoC;EACrC;EAED;IACE,iCAAkC;IAClC,oCAAqC;EACtC;EAED;IACE,kCAAmC;EACpC;EAED;IACE,iCAAkC;EACnC;EAED;IACE,uCAAwC;EACzC;EAED;IACE,yCAA0C;EAC3C;EAED;IACE,2CAA4C;EAC7C;EAED;IACE,yCAA0C;EAC3C;EAED;IACE,qBAAsB;IACtB,sBAAuB;EACxB;EAED;IACE,qBAAsB;IACtB,sBAAuB;EACxB;EAED;IACE,qBAAsB;IACtB,sBAAuB;EACxB;EAED;IACE,qBAAsB;IACtB,sBAAuB;EACxB;EAED;IACE,iCAAkC;EACnC;EAED;IACE,kCAAmC;EACpC;EAED;IACE,4CAA6C;EAC9C;EAED;IACE,0CAA2C;EAC5C;EAED;IACE,iDAAkD;EACnD;EAED;IACE,iDAAkD;EACnD;EAED;IACE,0CAA2C;EAC5C;EAED;IACE,uCAAwC;EACzC;EAED;IACE,sCAAuC;EACxC;EAED;IACE,0CAA2C;EAC5C;EAED;IACE,sCAAuC;IACvC,wCAAyC;EAC1C;EACD;IACE,2CAA4C;EAC7C;EAED;IACE,oCAAqC;IACrC,qCAAsC;EACvC;EAED;IACE,uCAAwC;IACxC,wBAAyB;EAC1B;EAED;IACE,yCAA0C;IAC1C,wBAAyB;EAC1B;EAED;IACE,+CAAgD;EACjD;EAED;IACE,qCAAsC;EACvC;EAED;IACE,uCAAwC;EACzC;EAED;IACE,yCAA0C;EAC3C;EAED;IACE,uCAAwC;EACzC;EAED;IACE,qCAAsC;EACvC;EAED;IACE,uCAAwC;EACzC;EAED;IACE,2CAA4C;EAC7C;EAED;IACE,kCAAmC;IACnC,mCAAoC;EACrC;EAED;IACE,iCAAkC;EACnC;EAED;IACE,yCAA0C;EAC3C;EAED;IACE,oCAAqC;EACtC;EAED;IACE,sBAAuB;IACvB,uBAAwB;EACzB;EAED;IACE,kBAAmB;IACnB,qCAAsC;IACtC,uCAAwC;IACxC,aAAc;IACd,qCAAsC;IACtC,sCAAuC;IACvC,cAAe;IACf,mBAAoB;IACpB,uBAAwB;IACxB,qBAAsB;IACtB,0DAA2D;IAC3D,yCAA0C;IAC1C,gBAAiB;IACjB,cAAe;IACf,iBAAkB;IAClB,WAAY;IACZ,mBAAoB;EACrB;EAED;IACE,mCAAoC;EACrC;EAED;IACE,iCAAkC;EACnC;EAED;IACE,oCAAqC;IACrC,WAAY;IACZ,sCAAuC;EACxC;EAED;IACE,gFAAiF;EAClF;EAED;IACE,kFAAmF;EACpF;EAED;IACE,mFAAoF;EACrF;EAED;IACE;;;MAGE,eAAgB;IACjB;EACF;EAGD;IACE;MACE,2BAA4B;IAC7B;IACD;MACE,4BAA6B;IAC9B;EACF;EAED;IACE,cAAe;IACf,wEAAyE;IACzE,0BAA2B;IAC3B,qDAAsD;IACtD,kCAAmC;EACpC;EAED;IACE,wEAAyE;IACzE,0BAA2B;EAC5B;EAED;IACE,wEAAyE;IACzE,0BAA2B;EAC5B;EAED;IACE,oBAAqB;EACtB;EAED;IACE,YAAa;IACb,WAAY;EACb;EAED;IACE,YAAa;IACb,UAAW;EACZ;EAED;IACE,yCAA0C;IAC1C,WAAY;EACb;EAED;IACE,aAAc;IACd,WAAY;IACZ,iCAAkC;EACnC;AACF;AAGD;EACE,WAAY;EACZ,aAAc;EACd,kCAAmC;EACnC,yBAA0B;AAC3B;AAED;EACE,qBAAsB;AACvB;AAED;EACE,gCAAiC;AAClC;AAED;EACE,eAAgB;EAChB,gBAAiB;EACjB,iBAAkB;EAClB,cAAe;AAChB;AAED;EACE,cAAe;AAChB;AAED;EACE,yBAA0B;AAC3B;AAED;EACE,cAAe;AAChB;AAED;EACE,oCAAqC;EACrC,kCAAmC;EACnC,4BAA6B;EAC7B,oEAAqE;EACrE,oBAAqB;EACrB,oDAAqD;EACrD;;gBAGe;AAChB;AAED;EACE,8BAA+B;EAC/B,sCAAuC;EACvC,2CAA4C;EAC5C,yBAA0B;EAC1B,6FAA8F;EAC9F,yBAA0B;AAC3B;AAED;EACE,sCAAuC;EACvC,uCAAwC;EACxC,6DAA8D;EAC9D,yBAA0B;AAC3B;AAED;EACE,gBAAiB;EACjB,YAAa;EACb,uCAAwC;EACxC,2CAA4C;EAC5C,iCAAkC;EAClC,6CAA8C;EAC9C,oBAAqB;EACrB,yBAA0B;EAC1B;UAES;AACV;AAED;EACE,kBAAmB;AACpB;AAED;EACE,2CAA4C;EAC5C,iCAAkC;EAClC,6CAA8C;EAC9C,oBAAqB;AACtB;AAED;EACE,mCAAoC;AACrC;AAED;EACE,wCAAyC;EACzC,kCAAmC;EACnC,8CAA+C;EAC/C,8CAA+C;EAC/C,+CAAgD;EAChD,yBAA0B;AAC3B;AAED;EACE,oCAAqC;EACrC,qCAAsC;EACtC,yCAA0C;AAC3C;AAED;EACE,8BAA+B;AAChC;AAED;EACE,WAAY;EACZ,8CAA+C;AAChD;AAED;EACE,iCAAkC;AACnC;AAED;EACE,oCAAqC;EACrC,qCAAsC;EACtC,qDAAsD;AACvD;AAED;EACE,kBAAmB;EACnB,wCAAyC;EACzC,yCAA0C;EAC1C,QAAS;EACT,UAAW;EACX,oBAAqB;AACtB;AAED;EACE,WAAY;EACZ,qCAAsC;EACtC,YAAa;AACd;AAED;EACE,sCAAuC;EACvC,aAAc;AACf;AAED;EACE,gEAAiE;AAClE;AAED;EACE,2FAA4F;AAC7F;AAED;EACE,gBAAiB;EACjB,eAAgB;AACjB;AAED;EACE,iCAAkC;EAClC,kCAAmC;AACpC;AAED;EACE,aAAc;EACd,iCAAkC;EAClC,8EAA+E;EAC/E,8CAA+C;EAC/C,iDAAkD;EAClD,iBAAkB;AACnB;AAED;EACE,iCAAkC;EAClC,iBAAkB;EAClB,oBAAqB;AACtB;AAED;EACE,gCAAiC;EACjC,iCAAkC;AACnC;AAED;EACE,cAAe;EACf,WAAY;EACZ,YAAa;EACb,kBAAmB;EACnB,gBAAiB;EACjB,8CAA+C;EAC/C,wDAAyD;EACzD,UAAW;EACX,uBAAwB;EACxB,+CAAgD;EAChD,4BAA6B;EAC7B,qBAAsB;EACtB,oCAAqC;AACtC;AAED;EACE,UAAW;AACZ;AAED;EACE,uBAAwB;AACzB;AAED;EACE,mBAAoB;EACpB,oBAAqB;AACtB;AAED;EACE,oBAAqB;EACrB,cAAe;EACf,oBAAqB;EACrB,sCAAuC;EACvC,wCAAyC;EACzC,8CAA+C;EAC/C,oBAAqB;EACrB,sBAAuB;AACxB;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,YAAa;EACb,4CAA6C;EAC7C,SAAU;EACV,oBAAqB;EACrB,uBAAwB;EACxB,eAAgB;EAChB,eAAgB;EAChB,gBAAiB;EACjB,iBAAkB;EAClB,iBAAkB;EAClB,2CAA4C;EAC5C,aAAc;EACd,mBAAoB;AACrB;AAED;EACE,oDAAqD;EACrD,gBAAiB;EACjB,WAAY;AACb;AAED;EACE,mBAAoB;AACrB;AAED;EACE,kCAAmC;EACnC,mCAAoC;AACrC;AAED;EACE,WAAY;EACZ,YAAa;AACd;AAED;EACE,aAAc;AACf;AAED;EACE,kBAAmB;EACnB,WAAY;EACZ,uBAAwB;EACxB,wBAAyB;EACzB,oBAAqB;EACrB,yBAA0B;EAC1B,6CAA8C;AAC/C;AAED;EACE,UAAW;EACX,qCAAsC;EACtC,iBAAkB;EAClB,qBAAsB;EACtB,uBAAwB;AACzB;AAED;EACE,kBAAmB;EACnB,aAAc;EACd,kCAAmC;EACnC,mCAAoC;EACpC,mBAAoB;EACpB,uBAAwB;EACxB,4CAA6C;AAC9C;AAED;EACE,qCAAsC;EACtC,sCAAuC;AACxC;AAED;EACE,kBAAmB;EACnB,QAAS;EACT,WAAY;EACZ,YAAa;EACb,iBAAkB;EAClB,oBAAqB;AACtB;AAED;EACE,yBAA0B;EAC1B,8CAA+C;AAChD;AAED;EACE,UAAW;EACX,8BAA+B;EAC/B,eAAgB;AACjB;AAED;EACE,UAAW;EACX,qCAAsC;EACtC,kBAAmB;EACnB,qBAAsB;EACtB,uBAAwB;AACzB;AAED;EACE,cAAe;AAChB;AAED;EACE,UAAW;EACX,WAAY;EACZ,gBAAiB;EACjB,kBAAmB;EACnB,iDAAkD;EAClD,+CAAgD;AACjD;AAED;EACE,cAAe;EACf,WAAY;EACZ,YAAa;EACb,gDAAiD;AAClD;AAED;EACE,kBAAmB;EACnB,oCAAqC;EACrC,qCAAsC;EACtC,gBAAiB;EACjB,yBAA0B;EAC1B,8CAA+C;EAC/C,yBAA0B;EAC1B,yCAA0C;AAC3C;AAED;EACE,kBAAmB;EACnB,UAAW;EACX,2CAA4C;AAC7C;AAED;EACE,kBAAmB;EACnB,kDAAmD;EACnD,QAAS;EACT,SAAU;EACV,OAAQ;EACR,gBAAiB;EACjB,oBAAqB;EACrB,kFAAmF;AACpF;AAED;EACE,cAAe;EACf,WAAY;EACZ,YAAa;AACd;AAED;EACE,uBAAwB;EACxB,wBAAyB;EACzB,2FAA4F;EAC5F,gEAAiE;AAClE;AAED;EACE,kBAAmB;EACnB,qBAAsB;EACtB,SAAU;EACV,UAAW;EACX,aAAc;EACd,eAAgB;EAChB,mBAAoB;EACpB,kBAAmB;EACnB,eAAgB;EAChB,sCAAuC;EACvC,8CAA+C;AAChD;AAED;EACE;IACE,UAAW;IACX,oBAAqB;EACtB;EAED;IACE,UAAW;IACX,oBAAqB;IACrB,8BAA+B;EAChC;AACF;AAED;EACE;;;;;IAKE,eAAgB;EACjB;EAED;IACE,gBAAiB;EAClB;EAED;IACE,aAAc;EACf;AACF;AAED;EACE,qCAAsC;EACtC,sCAAuC;EACvC,+CAAgD;AACjD;AAED;EACE,WAAY;EACZ,sCAAuC;EACvC,8BAA+B;AAChC;AAED;EACE;IACE,sCAAuC;IACvC,qCAAsC;EACvC;AACF;AAGD;EACE,WAAY;EACZ,+BAAgC;EAChC,kCAAmC;EACnC,iDAAkD;EAClD,aAAc;AACf;AAED;EACE,0CAA2C;AAC5C;AAED;EACE,2CAA4C;EAC5C,eAAgB;EAChB,gBAAiB;EACjB,iBAAkB;AACnB;AAGD;;;;;;;;EAQE,wBAAyB;EACzB,2BAA4B;AAC7B;AAED;EACE,0BAA2B;EAC3B,sBAAuB;AACxB;AACD;EACE,qBAAsB;AACvB;AACD;EACE,qBAAsB;AACvB;AACD;EACE;IACE,gBAAiB;IACjB,eAAgB;EACjB;EACD;IACE,aAAc;EACf;EACD;IACE,eAAgB;EACjB;EACD;IACE,0BAA2B;IAC3B,sBAAuB;EACxB;EACD;IACE,uBAAwB;EACzB;EACD;IACE,gBAAiB;EAClB;EACD;IACE,kBAAmB;IACnB,qBAAsB;IACtB,kBAAmB;IACnB,mBAAoB;IACpB,uBAAwB;IACxB,uBAAwB;IACxB,iBAAkB;IAClB,mBAAoB;IACpB,2BAA4B;IAC5B,2BAA4B;IAC5B,6BAA8B;IAC9B,gCAAiC;IACjC,qCAAsC;IACtC,6BAA8B;IAC9B,mBAAoB;IACpB,mBAAoB;IACpB,wBAAyB;IACzB,0BAA2B;IAC3B,4BAA6B;IAC7B,0BAA2B;IAC3B,gCAAiC;IACjC,2BAA4B;IAC5B,4BAA6B;IAC7B,wBAAyB;IACzB,yBAA0B;IAU1B,eAAgB;IAChB,eAAgB;IAChB,eAAgB;IAChB,eAAgB;IAChB,oBAAqB;IACrB,+BAAgC;IAChC,4BAA6B;IAC7B,4BAA6B;IAC7B,2BAA4B;IAC5B,sCAAuC;IACvC,qCAAsC;IACtC,wCAAyC;IACzC,2CAA4C;IAC5C,iCAAkC;IAClC,iCAAkC;IAClC,gCAAiC;IACjC,mCAAoC;IACpC,iCAAkC;IAClC,kCAAmC;IACnC,kCAAmC;IACnC,sCAAuC;IACvC,8BAA+B;IAC/B,iCAAkC;IAClC,gCAAiC;IACjC,iCAAkC;IAClC,iCAAkC;IAClC,iCAAkC;IAClC,gCAAiC;IACjC,kCAAmC;IACnC,4BAA6B;IAC7B,6BAA8B;IAC9B,6BAA8B;IAC9B,gBAAiB;IACjB,+BAAgC;IAChC,+BAAgC;IAChC,iCAAkC;IAClC,2BAA4B;IAC5B,2BAA4B;IAC5B,6BAA8B;IAC9B,8BAA+B;IAC/B,uBAAwB;IACxB,4BAA6B;IAC7B,6BAA8B;IAC9B,yBAA0B;IAC1B,0BAA2B;IAC3B,2BAA4B;IAC5B,+BAAgC;IAChC,6BAA8B;IAC9B,gCAAiC;IACjC,0BAA2B;IAC3B,2BAA4B;IAC5B,kCAAmC;IACnC,kCAAmC;IACnC,4BAA6B;IAC7B,mCAAoC;IACpC,gCAAiC;IACjC,iCAAkC;IAClC,4BAA6B;IAC7B,+BAAgC;IAChC,+BAAgC;IAChC,gCAAiC;IACjC,iCAAkC;IAClC,+BAAgC;IAChC,+BAAgC;IAChC,iCAAkC;IAClC,qCAAsC;IACtC,iCAAkC;IAClC,wCAAyC;IACzC,0BAA2B;IAC3B,4BAA6B;IAC7B,gCAAiC;IACjC,gCAAiC;IACjC,mCAAoC;IACpC,4BAA6B;IAC7B,6BAA8B;IAC9B,yBAA0B;IAC1B,8BAA+B;IAC/B,iCAAkC;IAClC,oCAAqC;IACrC,8BAA+B;IAC/B,8BAA+B;IAC/B,gCAAiC;IACjC,8BAA+B;IAC/B,iCAAkC;EACnC;EACD;IACE,YAAa;EACd;EAED;IACE,eAAgB;IAChB,iBAAkB;EACnB;AACF;AAED;EACE;IACE,kBAAmB;IACnB,qBAAsB;IACtB,kBAAmB;IACnB,mBAAoB;IACpB,uBAAwB;IACxB,uBAAwB;IACxB,iBAAkB;IAClB,iBAAkB;IAClB,eAAgB;IAChB,mBAAoB;IACpB,2BAA4B;IAC5B,2BAA4B;IAC5B,6BAA8B;IAC9B,gCAAiC;IACjC,qCAAsC;IACtC,6BAA8B;IAC9B,mBAAoB;IACpB,kBAAmB;IACnB,0BAA2B;IAC3B,4BAA6B;IAC7B,0BAA2B;IAC3B,eAAgB;IAChB,eAAgB;IAChB,eAAgB;IAChB,eAAgB;IAChB,oBAAqB;IACrB,sCAAuC;IACvC,qCAAsC;IACtC,wCAAyC;IACzC,2CAA4C;IAC5C,gCAAiC;IACjC,gCAAiC;IACjC,gCAAiC;IACjC,mCAAoC;IACpC,iCAAkC;IAClC,kCAAmC;IACnC,sCAAuC;IACvC,8BAA+B;IAC/B,gCAAiC;IACjC,+BAAgC;IAChC,iCAAkC;IAClC,+BAAgC;IAChC,gCAAiC;IACjC,+BAAgC;IAChC,iCAAkC;IAClC,4BAA6B;IAC7B,6BAA8B;IAC9B,6BAA8B;IAC9B,gBAAiB;IACjB,+BAAgC;IAChC,+BAAgC;IAChC,iCAAkC;IAClC,+BAAgC;IAChC,0BAA2B;IAC3B,4BAA6B;IAC7B,2BAA4B;IAC5B,2BAA4B;IAC5B,6BAA8B;IAC9B,8BAA+B;IAC/B,uBAAwB;IACxB,6BAA8B;IAC9B,yBAA0B;IAC1B,0BAA2B;IAC3B,2BAA4B;IAC5B,+BAAgC;IAChC,4BAA6B;IAC7B,gCAAiC;IACjC,0BAA2B;IAC3B,2BAA4B;IAC5B,kCAAmC;IACnC,kCAAmC;IACnC,4BAA6B;IAC7B,mCAAoC;IACpC,+BAAgC;IAChC,gCAAiC;IACjC,4BAA6B;IAC7B,+BAAgC;IAChC,+BAAgC;IAChC,gCAAiC;IACjC,iCAAkC;IAClC,+BAAgC;IAChC,+BAAgC;IAChC,iCAAkC;IAClC,qCAAsC;IACtC,iCAAkC;IAClC,wCAAyC;IACzC,0BAA2B;IAC3B,4BAA6B;IAC7B,gCAAiC;IACjC,gCAAiC;IACjC,mCAAoC;IACpC,4BAA6B;IAC7B,6BAA8B;IAC9B,yBAA0B;IAC1B,8BAA+B;IAC/B,iCAAkC;IAClC,oCAAqC;IACrC,6BAA8B;IAC9B,8BAA+B;IAC/B,gCAAiC;IACjC,8BAA+B;IAC/B,iCAAkC;EACnC;AACF;ADtmBC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,iBAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,iBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,6BAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAhfjB;EACE;IACE,yBAAyB;EADxB;AADW;AAchB;EACE;IACE,YAAY;EADV;AADW;AC5YnB;EACE;IACE,UAAW;EACZ;EACD;IACE,UAAW;EACZ;AACF;AAED;EACE;IACE,mBAAoB;EACrB;EACD;IACE,qBAAsB;EACvB;EACD;IACE,qBAAsB;EACvB;EACD;IACE,sBAAuB;EACxB;EACD;IACE,mBAAoB;EACrB;AACF;AAED;EACE;IACE,aAAc;IACd,sBAAuB;EACxB;EACD;IACE,YAAa;IACb,sBAAuB;EACxB;EACD;IACE,UAAW;IACX,qBAAsB;EACvB;AACF;AAED;EACE;IACE,UAAW;IACX,2BAA4B;EAC7B;EACD;IACE,UAAW;IACX,wBAAyB;EAC1B;AACF;AAaD;EACE;IACE,UAAW;IACX,2BAA4B;EAC7B;EACD;IACE,UAAW;IACX,wBAAyB;EAC1B;AACF;AAaD;EACE;IACE,uBAAwB;EACzB;EACD;IACE,yBAA0B;EAC3B;AACF;AAED;EACE;IACE,yBAA0B;EAC3B;EACD;IACE,yBAA0B;EAC3B;AACF;AAED;EACE;;IAEE,aAAc;IACd,mBAAoB;EACrB;EACD;IACE,aAAc;IACd,sBAAuB;EACxB;AACF;AAED;EACE;IACE,UAAW;IACX,sBAAuB;EACxB;EACD;IACE,UAAW;IACX,mBAAoB;EACrB;AACF;AAED;EACE;;IAEE,aAAc;IACd,sBAAuB;EACxB;EACD;IACE,YAAa;IACb,sBAAuB;EACxB;EACD;IACE,UAAW;IACX,sBAAuB;EACxB;EACD;IACE,YAAa;IACb,sBAAuB;EACxB;AACF;AAED;EACE;;IAEE,qBAAsB;EACvB;EACD;IACE,wBAAyB;EAC1B;AACF;AAED;EACE;IACE,UAAW;IACX,wBAAyB;EAC1B;EACD;IACE,UAAW;IACX,2BAA4B;EAC7B;AACF;AAED;EACE;IACE,UAAW;IACX,wBAAyB;EAC1B;EACD;IACE,UAAW;IACX,4BAA6B;EAC9B;AACF;AD6rBD;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,+BAAmB;MAAnB,yBAAmB;MAAnB,wBAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,+BAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,kBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n      \"Noto Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 none);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 none);\n    --color-neutral-100: oklch(97% 0 none);\n    --color-neutral-200: oklch(92.2% 0 none);\n    --color-neutral-300: oklch(87% 0 none);\n    --color-neutral-400: oklch(70.8% 0 none);\n    --color-neutral-500: oklch(55.6% 0 none);\n    --color-neutral-600: oklch(43.9% 0 none);\n    --color-neutral-700: oklch(37.1% 0 none);\n    --color-neutral-800: oklch(26.9% 0 none);\n    --color-neutral-900: oklch(20.5% 0 none);\n    --color-neutral-950: oklch(14.5% 0 none);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 none);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      -apple-system,\n      BlinkMacSystemFont,\n      \"Segoe UI\",\n      Roboto,\n      \"Helvetica Neue\",\n      \"Noto Sans\",\n      Arial,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring:where(:not(iframe)) {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import 'tailwindcss';\n\n@custom-variant dark (&:where([data-theme=dark], [data-theme=dark] *));\n\n@theme {\n  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-display: 'Inter', sans-serif;\n\n  --color-primary-50: #e6f4ff;\n  --color-primary-100: #bae0ff;\n  --color-primary-200: #91caff;\n  --color-primary-300: #69b1ff;\n  --color-primary-400: #4096ff;\n  --color-primary-500: #1677ff;\n  --color-primary-600: #0958d9;\n  --color-primary-700: #003eb3;\n  --color-primary-800: #002c8c;\n  --color-primary-900: #001d66;\n\n  --color-success: #52c41a;\n  --color-warning: #faad14;\n  --color-error: #ff4d4f;\n  --color-info: #1677ff;\n\n  --color-merchant-action: #056dff;\n  --color-merchant-primary: #2b6cff;\n  --color-merchant-text-primary: #171717;\n  --color-merchant-text-secondary: #525866;\n  --color-merchant-text-placeholder: #9ca3af;\n  --color-merchant-text-tertiary: #707785;\n  --color-merchant-bg-subtle: #f7f7f8;\n  --color-merchant-bg-hover: #eceef2;\n  --color-merchant-bg-unread: #f3f4f6;\n  --color-merchant-border: #e8e9ec;\n  --color-merchant-border-strong: #d8dae0;\n  --color-merchant-success: #16a34a;\n  --color-merchant-notification-badge: #ff3b30;\n\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 16px;\n  --radius-2xl: 24px;\n\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n\n  --breakpoint-sm: 640px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 1024px;\n  --breakpoint-xl: 1280px;\n  --breakpoint-2xl: 1536px;\n  --breakpoint-desktop: 1550px;\n\n  --animate-fade-in: fade-in 0.3s ease-in-out;\n  --animate-slide-up: slide-up 0.3s ease-out;\n  --animate-slide-down: slide-down 0.3s ease-out;\n  --animate-slide-in-right: slide-in-right 0.35s ease-out;\n  --animate-slide-in-left: slide-in-left 0.35s ease-out;\n  --animate-nudge-ai-thumb-spin: nudge-ai-thumb-spin 1.2s linear infinite;\n  --animate-nudge-ai-upload-spin: nudge-ai-upload-spin 0.95s linear infinite;\n  --animate-nudge-ai-upload-pulse: nudge-ai-upload-pulse 2.2s ease-in-out infinite;\n  --animate-nudge-ai-upload-in: nudge-ai-upload-in 0.4s ease-out;\n  --animate-nudge-ai-creating-twinkle: nudge-ai-creating-twinkle 3.8s linear infinite;\n  --animate-nudge-ai-creating-blink: nudge-ai-creating-blink 1.6s ease-in-out infinite;\n  --animate-feed-like-pop: feed-like-pop 0.5s cubic-bezier(0.22, 1, 0.36, 1);\n  --animate-feed-like-burst: feed-like-burst 0.55s ease-out forwards;\n\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes feed-like-pop {\n    0% {\n      transform: scale(1);\n    }\n    20% {\n      transform: scale(0.8);\n    }\n    45% {\n      transform: scale(1.4);\n    }\n    70% {\n      transform: scale(0.95);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  @keyframes feed-like-burst {\n    0% {\n      opacity: 0.55;\n      transform: scale(0.35);\n    }\n    45% {\n      opacity: 0.3;\n      transform: scale(1.55);\n    }\n    100% {\n      opacity: 0;\n      transform: scale(2.1);\n    }\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-down {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-in-right {\n    from {\n      opacity: 0;\n      transform: translateX(32px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slide-in-left {\n    from {\n      opacity: 0;\n      transform: translateX(-24px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes nudge-ai-thumb-spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes nudge-ai-upload-spin {\n    from {\n      transform: rotate(-90deg);\n    }\n    to {\n      transform: rotate(270deg);\n    }\n  }\n\n  @keyframes nudge-ai-upload-pulse {\n    0%,\n    100% {\n      opacity: 0.78;\n      transform: scale(1);\n    }\n    50% {\n      opacity: 0.96;\n      transform: scale(1.04);\n    }\n  }\n\n  @keyframes nudge-ai-upload-in {\n    from {\n      opacity: 0;\n      transform: scale(0.94);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  @keyframes nudge-ai-creating-twinkle {\n    0%,\n    100% {\n      opacity: 0.34;\n      transform: scale(0.96);\n    }\n    36% {\n      opacity: 0.5;\n      transform: scale(0.98);\n    }\n    50% {\n      opacity: 1;\n      transform: scale(1.08);\n    }\n    64% {\n      opacity: 0.5;\n      transform: scale(0.98);\n    }\n  }\n\n  @keyframes nudge-ai-creating-blink {\n    0%,\n    100% {\n      filter: brightness(1);\n    }\n    50% {\n      filter: brightness(1.08);\n    }\n  }\n\n  @keyframes slide-out-right {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(32px);\n    }\n  }\n\n  @keyframes slide-out-left {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-24px);\n    }\n  }\n}\n\n:root {\n  --space-page: 48px;\n  --space-section: 32px;\n  --space-form: 24px;\n  --space-field: 16px;\n  --text-heading-lg: 32px;\n  --text-heading-md: 24px;\n  --text-body: 18px;\n  --text-base: 16px;\n  --text-sm: 14px;\n  --text-caption: 12px;\n  --line-height-caption: 16px;\n  --line-height-body-xs: 20px;\n  --space-business-results: 12px;\n  --space-business-result-row: 4px;\n  --space-business-detail-section: 16px;\n  --space-business-actions: 12px;\n  --radius-field: 8px;\n  --radius-card: 16px;\n  --radius-button: 999px;\n  --radius-control-sm: 4px;\n  --icon-sm: 16px;\n  --icon-md: 20px;\n  --icon-lg: 24px;\n  --icon-xl: 32px;\n  --input-height: 48px;\n  --width-auth-form: 600px;\n  --width-onboarding: 620px;\n  --width-feed-create-select-btn: 195px;\n  --height-feed-create-post-modal: 680px;\n  --width-feed-create-caption-modal: 1240px;\n  --height-feed-create-caption-content: 622px;\n  --width-feed-gallery-modal: 880px;\n  --height-feed-gallery-grid: 657px;\n  --height-feed-cover-stage: 342px;\n  --height-feed-cover-filmstrip: 64px;\n  --width-feed-cover-preview: 200px;\n  --height-feed-cover-preview: 250px;\n  --width-nudge-cover-preview: 300px;\n  --width-feed-aspect-ratio-panel: 205px;\n  --size-feed-overlay-icon: 21px;\n  --radius-feed-caption-modal: 18px;\n  --width-feed-emoji-picker: 320px;\n  --height-feed-emoji-picker: 348px;\n  --width-feed-detail-modal: 1422px;\n  --height-feed-detail-modal: 880px;\n  --width-feed-detail-media: 880px;\n  --width-feed-detail-sidebar: 542px;\n  --size-feed-detail-nav: 48px;\n  --width-otp-group: 278px;\n  --width-dashboard-content: 1120px;\n  --width-business-switcher: 419px;\n  --height-dashboard-logo: 44px;\n  --width-dashboard-logo: 540px;\n  --icon-nav: 18px;\n  --size-notification-badge: 24px;\n  --text-notification-badge: 12px;\n  --offset-notification-badge: -8px;\n  --space-dashboard-section: 16px;\n  --space-dashboard-cards: 12px;\n  --radius-welcome-card: 12px;\n  --radius-dashboard-post: 12px;\n  --padding-welcome-card: 24px;\n  --padding-post-overlay: 5px;\n  --radius-post-overlay: 5px;\n  --width-profile-form: 554px;\n  --height-profile-field: 50px;\n  --duration-restaurant-profile-enter: 0.35s;\n  --duration-restaurant-profile-exit: 0.3s;\n  --width-nudge-ai-btn: 178px;\n  --height-nudge-ai-btn: 40px;\n  --padding-nudge-ai-btn-y: 10px;\n  --padding-nudge-ai-btn-x: 18px;\n  --gap-nudge-ai-btn: 4px;\n  --border-nudge-ai-btn: 2px;\n  --width-nudge-ai-chat: 556px;\n  --padding-nudge-ai-chat: 40px;\n  --gap-nudge-ai-chat: 24px;\n  --gap-nudge-ai-empty: 24px;\n  --size-nudge-ai-close: 32px;\n  --size-nudge-ai-icon-wrap: 72px;\n  --width-nudge-ai-empty: 520px;\n  --height-nudge-ai-composer: 56px;\n  --size-nudge-ai-send: 40px;\n  --size-nudge-ai-thumb: 40px;\n  --padding-nudge-ai-composer-x: 8px;\n  --padding-nudge-ai-composer-y: 12px;\n  --gap-nudge-ai-composer: 8px;\n  --line-height-nudge-ai-prompt: 20px;\n  --radius-nudge-ai-composer: 16px;\n  --radius-nudge-ai-icon-wrap: 16px;\n  --size-nudge-ai-upload: 48px;\n  --size-nudge-ai-upload-lg: 80px;\n  --size-nudge-ai-creating: 280px;\n  --radius-nudge-ai-creating: 24px;\n  --padding-nudge-ai-creating: 20px;\n  --height-nudge-ai-segment: 32px;\n  --padding-nudge-ai-segment: 2px;\n  --padding-nudge-ai-segment-x: 12px;\n  --padding-nudge-ai-media-actions: 10px;\n  --gap-nudge-ai-media-actions: 8px;\n  --padding-nudge-media-ai: 40px 32px 32px;\n  --gap-nudge-media-ai: 16px;\n  --radius-nudge-media-ai: 12px;\n  --size-nudge-media-ai-icon: 48px;\n  --height-nudge-media-start: 44px;\n  --padding-nudge-media-start-x: 20px;\n  --gap-nudge-media-start: 8px;\n  --gap-nudge-media-stack: 24px;\n  --gap-nudge-media-or: 12px;\n  --size-nudge-media-close: 24px;\n  --height-nudge-media-source: 48px;\n  --padding-nudge-media-source-x: 24px;\n  --gap-nudge-media-source: 16px;\n  --gap-nudge-media-sources: 12px;\n  --radius-nudge-media-source: 8px;\n  --size-nudge-ai-launcher: 48px;\n  --size-nudge-ai-launcher-dot: 8px;\n}\n\n@media (min-width: 1024px) {\n  :root {\n    --width-auth-form: 620px;\n  }\n}\n\n@layer base {\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    border-color: var(--color-gray-200, currentColor);\n  }\n\n  html {\n    @apply scroll-smooth antialiased;\n  }\n\n  body {\n    @apply m-0 min-h-screen font-sans text-gray-900 bg-gray-50;\n  }\n\n  [data-theme='dark'] body {\n    @apply bg-gray-900 text-gray-100;\n  }\n}\n\n@layer components {\n  .container-app {\n    @apply mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 2xl:max-w-[1600px];\n  }\n\n  .page-header {\n    @apply mb-4 flex flex-col gap-2 sm:mb-6 sm:flex-row sm:items-center sm:justify-between md:mb-8;\n  }\n\n  .page-title {\n    @apply text-xl font-semibold text-gray-900 sm:text-2xl lg:text-3xl dark:text-white;\n  }\n\n  .card-grid {\n    @apply grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4;\n  }\n\n  .form-grid {\n    @apply grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4;\n  }\n\n  .responsive-table-wrapper {\n    @apply w-full overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700;\n  }\n\n  .mobile-card-view {\n    @apply flex flex-col gap-3 md:hidden;\n  }\n\n  .desktop-table-view {\n    @apply hidden md:block;\n  }\n}\n\n@layer utilities {\n  /* Feed create/view media: required for getFeedAspectFrameStyle (cqw/cqh). */\n  .feed-media-aspect-host {\n    container-type: size;\n  }\n\n  .text-responsive-sm {\n    @apply text-xs sm:text-sm;\n  }\n\n  .text-responsive-base {\n    @apply text-sm sm:text-base;\n  }\n\n  .text-responsive-lg {\n    @apply text-base sm:text-lg lg:text-xl;\n  }\n\n  .spacing-responsive {\n    padding: var(--space-section);\n  }\n\n  .text-heading-lg {\n    font-size: var(--text-heading-lg);\n  }\n\n  .text-heading-md {\n    font-size: var(--text-heading-md);\n  }\n\n  .text-body {\n    font-size: var(--text-body);\n  }\n\n  .text-base {\n    font-size: var(--text-base);\n  }\n\n  .text-sm {\n    font-size: var(--text-sm);\n    line-height: var(--line-height-body-xs);\n  }\n\n  .text-caption {\n    font-size: var(--text-caption);\n    line-height: var(--line-height-caption);\n  }\n\n  .gap-business-results {\n    gap: var(--space-business-results);\n  }\n\n  .gap-business-result-row {\n    gap: var(--space-business-result-row);\n  }\n\n  .gap-business-detail-section {\n    gap: var(--space-business-detail-section);\n  }\n\n  .gap-business-actions {\n    gap: var(--space-business-actions);\n  }\n\n  .p-page {\n    padding: var(--space-page);\n  }\n\n  .p-section {\n    padding: var(--space-section);\n  }\n\n  .gap-section {\n    gap: var(--space-section);\n  }\n\n  .gap-page {\n    gap: var(--space-page);\n  }\n\n  .gap-form {\n    gap: var(--space-form);\n  }\n\n  .gap-field {\n    gap: var(--space-field);\n  }\n\n  .px-page {\n    padding-left: var(--space-page);\n    padding-right: var(--space-page);\n  }\n\n  .py-page {\n    padding-top: var(--space-page);\n    padding-bottom: var(--space-page);\n  }\n\n  .px-section {\n    padding-left: var(--space-section);\n    padding-right: var(--space-section);\n  }\n\n  .py-section {\n    padding-top: var(--space-section);\n    padding-bottom: var(--space-section);\n  }\n\n  .rounded-field {\n    border-radius: var(--radius-field);\n  }\n\n  .rounded-card {\n    border-radius: var(--radius-card);\n  }\n\n  .rounded-control-sm {\n    border-radius: var(--radius-control-sm);\n  }\n\n  .rounded-welcome-card {\n    border-radius: var(--radius-welcome-card);\n  }\n\n  .rounded-dashboard-post {\n    border-radius: var(--radius-dashboard-post);\n  }\n\n  .rounded-post-overlay {\n    border-radius: var(--radius-post-overlay);\n  }\n\n  .icon-sm {\n    width: var(--icon-sm);\n    height: var(--icon-sm);\n  }\n\n  .icon-md {\n    width: var(--icon-md);\n    height: var(--icon-md);\n  }\n\n  .icon-lg {\n    width: var(--icon-lg);\n    height: var(--icon-lg);\n  }\n\n  .icon-xl {\n    width: var(--icon-xl);\n    height: var(--icon-xl);\n  }\n\n  .max-w-auth-form {\n    max-width: var(--width-auth-form);\n  }\n\n  .max-w-onboarding {\n    max-width: var(--width-onboarding);\n  }\n\n  .h-feed-create-post-modal {\n    height: var(--height-feed-create-post-modal);\n  }\n\n  .w-feed-create-select-btn {\n    width: var(--width-feed-create-select-btn);\n  }\n\n  .max-w-feed-create-caption-modal {\n    max-width: var(--width-feed-create-caption-modal);\n  }\n\n  .h-feed-create-caption-content {\n    height: var(--height-feed-create-caption-content);\n  }\n\n  .max-w-feed-gallery-modal {\n    max-width: var(--width-feed-gallery-modal);\n  }\n\n  .h-feed-gallery-grid {\n    height: var(--height-feed-gallery-grid);\n  }\n\n  .h-feed-cover-stage {\n    height: var(--height-feed-cover-stage);\n  }\n\n  .h-feed-cover-filmstrip {\n    height: var(--height-feed-cover-filmstrip);\n  }\n\n  .size-feed-cover-preview {\n    width: var(--width-feed-cover-preview);\n    height: var(--height-feed-cover-preview);\n  }\n  .w-feed-aspect-ratio-panel {\n    width: var(--width-feed-aspect-ratio-panel);\n  }\n\n  .size-feed-overlay-icon {\n    width: var(--size-feed-overlay-icon);\n    height: var(--size-feed-overlay-icon);\n  }\n\n  .animate-feed-like-pop {\n    animation: var(--animate-feed-like-pop);\n    transform-origin: center;\n  }\n\n  .animate-feed-like-burst {\n    animation: var(--animate-feed-like-burst);\n    transform-origin: center;\n  }\n\n  .rounded-feed-caption-modal {\n    border-radius: var(--radius-feed-caption-modal);\n  }\n\n  .w-feed-emoji-picker {\n    width: var(--width-feed-emoji-picker);\n  }\n\n  .h-feed-emoji-picker {\n    height: var(--height-feed-emoji-picker);\n  }\n\n  .max-w-feed-detail-modal {\n    max-width: var(--width-feed-detail-modal);\n  }\n\n  .h-feed-detail-modal {\n    height: var(--height-feed-detail-modal);\n  }\n\n  .w-feed-detail-media {\n    width: var(--width-feed-detail-media);\n  }\n\n  .w-feed-detail-sidebar {\n    width: var(--width-feed-detail-sidebar);\n  }\n\n  .max-w-feed-detail-sidebar {\n    max-width: var(--width-feed-detail-sidebar);\n  }\n\n  .size-feed-detail-nav {\n    width: var(--size-feed-detail-nav);\n    height: var(--size-feed-detail-nav);\n  }\n\n  .max-w-otp-group {\n    max-width: var(--width-otp-group);\n  }\n\n  .max-w-dashboard {\n    max-width: var(--width-dashboard-content);\n  }\n\n  .max-w-profile-form {\n    max-width: var(--width-profile-form);\n  }\n\n  .icon-nav {\n    width: var(--icon-nav);\n    height: var(--icon-nav);\n  }\n\n  .notification-badge {\n    position: absolute;\n    top: var(--offset-notification-badge);\n    right: var(--offset-notification-badge);\n    display: flex;\n    width: var(--size-notification-badge);\n    height: var(--size-notification-badge);\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    border-radius: 9999px;\n    background-color: var(--color-merchant-notification-badge);\n    font-size: var(--text-notification-badge);\n    font-weight: 600;\n    line-height: 1;\n    letter-spacing: 0;\n    color: #fff;\n    white-space: nowrap;\n  }\n\n  .gap-dashboard-section {\n    gap: var(--space-dashboard-section);\n  }\n\n  .gap-dashboard-cards {\n    gap: var(--space-dashboard-cards);\n  }\n\n  .logo-dashboard-header {\n    height: var(--height-dashboard-logo);\n    width: auto;\n    max-width: var(--width-dashboard-logo);\n  }\n\n  .restaurant-profile-enter-panel-only {\n    animation: slide-in-right var(--duration-restaurant-profile-enter) ease-out both;\n  }\n\n  .restaurant-profile-exit-sidebar {\n    animation: slide-out-left var(--duration-restaurant-profile-exit) ease-in forwards;\n  }\n\n  .restaurant-profile-exit-panel {\n    animation: slide-out-right var(--duration-restaurant-profile-exit) ease-in forwards;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .restaurant-profile-enter-panel-only,\n    .restaurant-profile-exit-sidebar,\n    .restaurant-profile-exit-panel {\n      animation: none;\n    }\n  }\n\n  /* Skeleton loaders */\n  @keyframes skeleton-shimmer {\n    0% {\n      background-position: 100% 0;\n    }\n    100% {\n      background-position: -100% 0;\n    }\n  }\n\n  .skeleton {\n    display: block;\n    background: linear-gradient(90deg, #eceef2 0%, #f7f7f8 40%, #eceef2 80%);\n    background-size: 200% 100%;\n    animation: skeleton-shimmer 1.4s ease-in-out infinite;\n    border-radius: var(--radius-field);\n  }\n\n  .skeleton-dark {\n    background: linear-gradient(90deg, #1f1f1f 0%, #474747 40%, #1f1f1f 80%);\n    background-size: 200% 100%;\n  }\n\n  .skeleton-strong {\n    background: linear-gradient(90deg, #d9dce3 0%, #f2f3f6 40%, #d9dce3 80%);\n    background-size: 200% 100%;\n  }\n\n  .skeleton-circle {\n    border-radius: 999px;\n  }\n\n  .skeleton-line {\n    height: 16px;\n    width: 100%;\n  }\n\n  .skeleton-title {\n    height: 28px;\n    width: 60%;\n  }\n\n  .skeleton-field {\n    height: var(--height-profile-field, 50px);\n    width: 100%;\n  }\n\n  .skeleton-card {\n    height: 120px;\n    width: 100%;\n    border-radius: var(--radius-card);\n  }\n}\n\n/* Create nudge Ant Design pickers — match Figma field styling (13/400/18) */\n.nudge-picker.ant-picker {\n  width: 100%;\n  padding: 12px;\n  border-radius: var(--radius-field);\n  background-color: #ffffff;\n}\n\n.nudge-picker.ant-picker:not(.ant-picker-status-error) {\n  border-color: #e8e9ec;\n}\n\n.nudge-picker.ant-picker.ant-picker-status-error {\n  border-color: var(--color-error);\n}\n\n.nudge-picker.ant-picker .ant-picker-input > input {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #171717;\n}\n\n.nudge-picker.ant-picker .ant-picker-input > input::placeholder {\n  color: #c2c6cf;\n}\n\n.nudge-picker.ant-picker.ant-picker-disabled {\n  background-color: #f3f4f6;\n}\n\n.nudge-picker.ant-picker.ant-picker-disabled .ant-picker-input > input {\n  color: #c2c6cf;\n}\n\n.nudge-generate-ai-btn {\n  min-width: var(--width-nudge-ai-btn);\n  height: var(--height-nudge-ai-btn);\n  gap: var(--gap-nudge-ai-btn);\n  padding: var(--padding-nudge-ai-btn-y) var(--padding-nudge-ai-btn-x);\n  border-radius: 999px;\n  border: var(--border-nudge-ai-btn) solid transparent;\n  background:\n    linear-gradient(#fff, #fff) padding-box,\n    linear-gradient(93.03deg, #2b6cff 4.27%, #d8dae0 23.41%, #d8dae0 80.85%, #2b6cff 100%)\n      border-box;\n}\n\n.nudge-media-ai-empty {\n  gap: var(--gap-nudge-media-ai);\n  padding: var(--padding-nudge-media-ai);\n  border-radius: var(--radius-nudge-media-ai);\n  border: 1px solid #e8e9ec;\n  background: linear-gradient(180deg, rgba(43, 108, 255, 0.2) 0%, rgba(236, 238, 242, 0.2) 50%);\n  background-color: #f3f4f6;\n}\n\n.nudge-media-ai-icon {\n  width: var(--size-nudge-media-ai-icon);\n  height: var(--size-nudge-media-ai-icon);\n  background: linear-gradient(180deg, #87b2ff 0%, #2b6cff 100%);\n  border: 1px solid #2b6cff;\n}\n\n.nudge-media-start-btn {\n  overflow: hidden;\n  min-width: 0;\n  height: var(--height-nudge-media-start);\n  min-height: var(--height-nudge-media-start);\n  gap: var(--gap-nudge-media-start);\n  padding: 0 var(--padding-nudge-media-start-x);\n  border-radius: 999px;\n  background-color: #568cff;\n  background-position:\n    0 0,\n    center;\n}\n\n.nudge-media-start-btn.is-hug {\n  width: max-content;\n}\n\n.nudge-media-action-btn {\n  min-height: var(--height-nudge-media-start);\n  gap: var(--gap-nudge-media-start);\n  padding: 0 var(--padding-nudge-media-start-x);\n  border-radius: 999px;\n}\n\n.nudge-media-sources {\n  gap: var(--gap-nudge-media-sources);\n}\n\n.nudge-media-source-btn {\n  height: var(--height-nudge-media-source);\n  gap: var(--gap-nudge-media-source);\n  padding: 0 var(--padding-nudge-media-source-x);\n  border: 1px solid var(--color-merchant-border);\n  border-radius: var(--radius-nudge-media-source);\n  background-color: #f3f4f6;\n}\n\n.nudge-media-close {\n  width: var(--size-nudge-media-close);\n  height: var(--size-nudge-media-close);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);\n}\n\n.nudge-media-or {\n  gap: var(--gap-nudge-media-or);\n}\n\n.nudge-media-or-line {\n  height: 1px;\n  background-color: var(--color-merchant-border);\n}\n\n.nudge-media-stack {\n  gap: var(--gap-nudge-media-stack);\n}\n\n.nudge-ai-chat-launcher {\n  width: var(--size-nudge-ai-launcher);\n  height: var(--size-nudge-ai-launcher);\n  border: 1px solid var(--color-merchant-border-strong);\n}\n\n.nudge-ai-chat-launcher-dot {\n  position: absolute;\n  width: var(--size-nudge-ai-launcher-dot);\n  height: var(--size-nudge-ai-launcher-dot);\n  top: 1px;\n  right: 1px;\n  pointer-events: none;\n}\n\n.nudge-ai-chat-panel {\n  width: 100%;\n  max-width: var(--width-nudge-ai-chat);\n  height: 100%;\n}\n\n.nudge-ai-chat-header {\n  min-height: var(--size-nudge-ai-close);\n  padding: 16px;\n}\n\n.nudge-ai-chat-body {\n  padding: var(--gap-nudge-ai-chat) var(--padding-nudge-ai-chat) 0;\n}\n\n.nudge-ai-composer-wrap {\n  padding: var(--gap-nudge-ai-chat) var(--padding-nudge-ai-chat) var(--padding-nudge-ai-chat);\n}\n\n.nudge-ai-close {\n  min-height: 44px;\n  min-width: 44px;\n}\n\n.nudge-ai-close-icon {\n  width: var(--size-nudge-ai-close);\n  height: var(--size-nudge-ai-close);\n}\n\n.nudge-ai-composer {\n  min-height: 0;\n  gap: var(--gap-nudge-ai-composer);\n  padding: var(--padding-nudge-ai-composer-y) var(--padding-nudge-ai-composer-x);\n  border-radius: var(--radius-nudge-ai-composer);\n  background-color: var(--color-merchant-bg-subtle);\n  overflow: visible;\n}\n\n.nudge-ai-thumbs {\n  gap: var(--gap-nudge-ai-composer);\n  overflow: visible;\n  padding: 4px 4px 2px;\n}\n\n.nudge-ai-send {\n  width: var(--size-nudge-ai-send);\n  height: var(--size-nudge-ai-send);\n}\n\n.nudge-ai-composer-prompt {\n  display: block;\n  width: 100%;\n  resize: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n  min-height: var(--line-height-nudge-ai-prompt);\n  max-height: calc(var(--line-height-nudge-ai-prompt) * 5);\n  padding: 0;\n  padding-inline-end: 6px;\n  line-height: var(--line-height-nudge-ai-prompt);\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n  scrollbar-color: #d8dae0 transparent;\n}\n\n.nudge-ai-composer-prompt::-webkit-scrollbar {\n  width: 4px;\n}\n\n.nudge-ai-composer-prompt::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.nudge-ai-composer-prompt::-webkit-scrollbar-thumb {\n  background: #d8dae0;\n  border-radius: 999px;\n}\n\n.nudge-ai-source-toggle {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: stretch;\n  height: var(--height-nudge-ai-segment);\n  padding: var(--padding-nudge-ai-segment);\n  border: 1px solid var(--color-merchant-border);\n  border-radius: 999px;\n  background-color: #fff;\n}\n\n.nudge-ai-source-option {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  padding: 0 var(--padding-nudge-ai-segment-x);\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--color-merchant-text-secondary);\n  outline: none;\n  white-space: nowrap;\n}\n\n.nudge-ai-source-option.is-active {\n  background-color: var(--color-merchant-text-primary);\n  font-weight: 600;\n  color: #fff;\n}\n\n.nudge-ai-source-option:disabled {\n  cursor: not-allowed;\n}\n\n.nudge-ai-thumb {\n  width: var(--size-nudge-ai-upload);\n  height: var(--size-nudge-ai-upload);\n}\n\n.nudge-ai-thumb-media {\n  width: 100%;\n  height: 100%;\n}\n\n.nudge-ai-thumb-media.is-processing {\n  opacity: 0.65;\n}\n\n.nudge-ai-thumb-ring {\n  position: absolute;\n  inset: -4px;\n  width: calc(100% + 8px);\n  height: calc(100% + 8px);\n  pointer-events: none;\n  transform-origin: 50% 50%;\n  animation: var(--animate-nudge-ai-thumb-spin);\n}\n\n.nudge-ai-thumb-dots {\n  fill: none;\n  stroke: var(--color-merchant-primary);\n  stroke-width: 2.5;\n  stroke-linecap: round;\n  stroke-dasharray: 2 5.8;\n}\n\n.nudge-ai-upload-loader {\n  position: relative;\n  display: flex;\n  width: var(--size-nudge-ai-upload);\n  height: var(--size-nudge-ai-upload);\n  align-items: center;\n  justify-content: center;\n  animation: var(--animate-nudge-ai-upload-in);\n}\n\n.nudge-ai-upload-loader.is-featured {\n  width: var(--size-nudge-ai-upload-lg);\n  height: var(--size-nudge-ai-upload-lg);\n}\n\n.nudge-ai-upload-ring {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  pointer-events: none;\n}\n\n.nudge-ai-upload-ring-spin {\n  transform-origin: 50% 50%;\n  animation: var(--animate-nudge-ai-upload-spin);\n}\n\n.nudge-ai-upload-track {\n  fill: none;\n  stroke: rgb(43 108 255 / 0.14);\n  stroke-width: 2;\n}\n\n.nudge-ai-upload-arc {\n  fill: none;\n  stroke: var(--color-merchant-primary);\n  stroke-width: 2.25;\n  stroke-linecap: round;\n  stroke-dasharray: 36 96;\n}\n\n.ant-empty-image img {\n  margin: 0 auto;\n}\n\n.nudge-ai-upload-media {\n  width: 78%;\n  height: 78%;\n  overflow: hidden;\n  border-radius: 50%;\n  background-color: var(--color-merchant-bg-subtle);\n  animation: var(--animate-nudge-ai-upload-pulse);\n}\n\n.nudge-ai-upload-placeholder {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-merchant-bg-hover);\n}\n\n.nudge-ai-creating-card {\n  position: relative;\n  width: var(--size-nudge-ai-creating);\n  height: var(--size-nudge-ai-creating);\n  overflow: hidden;\n  border: 1px solid #e8e9ec;\n  border-radius: var(--radius-nudge-ai-creating);\n  background-color: #ffffff;\n  padding: var(--padding-nudge-ai-creating);\n}\n\n.nudge-ai-creating-title {\n  position: relative;\n  z-index: 1;\n  color: var(--color-merchant-text-secondary);\n}\n\n.nudge-ai-creating-field {\n  position: absolute;\n  top: calc(var(--padding-nudge-ai-creating) + 22px);\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  pointer-events: none;\n  border-radius: 0 0 var(--radius-nudge-ai-creating) var(--radius-nudge-ai-creating);\n}\n\n.nudge-ai-creating-dots-svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.nudge-ai-creating-dot {\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: var(--animate-nudge-ai-creating-twinkle), var(--animate-nudge-ai-creating-blink);\n  animation-delay: var(--travel-delay, 0s), var(--blink-delay, 0s);\n}\n\n.nudge-ai-media-actions {\n  position: absolute;\n  inset-inline-start: 0;\n  bottom: 0;\n  z-index: 2;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  width: fit-content;\n  max-width: 100%;\n  gap: var(--gap-nudge-ai-media-actions);\n  padding: var(--padding-nudge-ai-media-actions);\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .nudge-ai-media-card:not(:hover):not(:focus-within) .nudge-ai-media-actions {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .nudge-ai-media-actions {\n    opacity: 1;\n    pointer-events: auto;\n    transition: opacity 0.15s ease;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .nudge-ai-thumb-ring,\n  .nudge-ai-upload-loader,\n  .nudge-ai-upload-ring-spin,\n  .nudge-ai-upload-media,\n  .nudge-ai-creating-dot {\n    animation: none;\n  }\n\n  .nudge-ai-media-actions {\n    transition: none;\n  }\n\n  .nudge-ai-upload-media {\n    opacity: 0.88;\n  }\n}\n\n.nudge-ai-icon-wrap {\n  width: var(--size-nudge-ai-icon-wrap);\n  height: var(--size-nudge-ai-icon-wrap);\n  border-radius: var(--radius-nudge-ai-icon-wrap);\n}\n\n.nudge-ai-empty {\n  width: 100%;\n  max-width: var(--width-nudge-ai-empty);\n  gap: var(--gap-nudge-ai-empty);\n}\n\n@media (min-width: 1551px) {\n  .nudge-ai-close {\n    min-height: var(--size-nudge-ai-close);\n    min-width: var(--size-nudge-ai-close);\n  }\n}\n\n/* Business hours Ant Design TimePicker — match merchant field styling */\n.business-hours-time-picker.ant-picker {\n  width: 100%;\n  min-height: var(--input-height);\n  border-radius: var(--radius-field);\n  background-color: var(--color-merchant-bg-subtle);\n  padding: 12px;\n}\n\n.business-hours-time-picker.ant-picker:not(.ant-picker-status-error) {\n  border-color: var(--color-merchant-border);\n}\n\n.business-hours-time-picker.ant-picker .ant-picker-input > input {\n  color: var(--color-merchant-text-secondary);\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 26px;\n}\n\n/* Recharts: hide browser focus ring on chart click */\n.recharts-wrapper,\n.recharts-wrapper:focus,\n.recharts-wrapper:focus-visible,\n.recharts-wrapper *:focus,\n.recharts-wrapper *:focus-visible,\n.recharts-surface,\n.recharts-surface:focus,\n.recharts-surface:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.custom-trigger-class input {\n  font-size: 12px !important;\n  width: 40px !important;\n}\n.custom-trigger-class .ant-picker-range-separator {\n  padding: 0 !important;\n}\n.custom-modal .ant-modal-content {\n  padding: 0 !important;\n}\n@media (max-width: 1550px) {\n  .nudge-ai-close {\n    min-height: 36px;\n    min-width: 36px;\n  }\n  .nudge-ai-chat-header {\n    padding: 12px;\n  }\n  .text-base {\n    font-size: 14px;\n  }\n  .custom-trigger-class input {\n    font-size: 10px !important;\n    width: 35px !important;\n  }\n  .custom-modal {\n    width: 500px !important;\n  }\n  .max-w-dashboard {\n    max-width: 900px;\n  }\n  :root {\n    --space-page: 36px;\n    --space-section: 24px;\n    --space-form: 18px;\n    --space-field: 12px;\n    --text-heading-lg: 24px;\n    --text-heading-md: 18px;\n    --text-body: 14px;\n    --text-caption: 9px;\n    --line-height-caption: 12px;\n    --line-height-body-xs: 15px;\n    --space-business-results: 9px;\n    --space-business-result-row: 3px;\n    --space-business-detail-section: 12px;\n    --space-business-actions: 9px;\n    --radius-field: 6px;\n    --radius-card: 12px;\n    --radius-control-sm: 3px;\n    --radius-welcome-card: 9px;\n    --radius-dashboard-post: 9px;\n    --radius-post-overlay: 4px;\n    --width-business-switcher: 314px;\n    --width-profile-form: 416px;\n    --height-profile-field: 44px;\n    --width-auth-form: 500px;\n    --width-onboarding: 500px;\n    --height-feed-create-post-modal: 510px;\n    --width-feed-create-select-btn: 146px;\n    --width-feed-create-caption-modal: 930px;\n    --height-feed-create-caption-content: 466px;\n    --width-feed-aspect-ratio-panel: 154px;\n    --size-feed-overlay-icon: 16px;\n    --radius-feed-caption-modal: 12px;\n    --width-feed-emoji-picker: 240px;\n    --height-feed-emoji-picker: 261px;\n    --icon-sm: 12px;\n    --icon-md: 15px;\n    --icon-lg: 18px;\n    --icon-xl: 24px;\n    --input-height: 44px;\n    --space-dashboard-section: 12px;\n    --space-dashboard-cards: 9px;\n    --padding-welcome-card: 18px;\n    --padding-post-overlay: 4px;\n    --height-feed-create-post-modal: 510px;\n    --width-feed-create-select-btn: 146px;\n    --width-feed-create-caption-modal: 930px;\n    --height-feed-create-caption-content: 466px;\n    --width-feed-gallery-modal: 660px;\n    --height-feed-gallery-grid: 493px;\n    --height-feed-cover-stage: 256px;\n    --height-feed-cover-filmstrip: 48px;\n    --width-feed-cover-preview: 150px;\n    --height-feed-cover-preview: 188px;\n    --width-nudge-cover-preview: 225px;\n    --width-feed-aspect-ratio-panel: 154px;\n    --size-feed-overlay-icon: 16px;\n    --radius-feed-caption-modal: 12px;\n    --width-feed-emoji-picker: 240px;\n    --height-feed-emoji-picker: 261px;\n    --width-feed-detail-modal: 1066px;\n    --height-feed-detail-modal: 660px;\n    --width-feed-detail-media: 660px;\n    --width-feed-detail-sidebar: 406px;\n    --size-feed-detail-nav: 36px;\n    --height-dashboard-logo: 33px;\n    --width-dashboard-logo: 405px;\n    --icon-nav: 14px;\n    --size-notification-badge: 18px;\n    --text-notification-badge: 10px;\n    --offset-notification-badge: -6px;\n    --width-nudge-ai-btn: 134px;\n    --height-nudge-ai-btn: 44px;\n    --padding-nudge-ai-btn-y: 8px;\n    --padding-nudge-ai-btn-x: 14px;\n    --gap-nudge-ai-btn: 3px;\n    --width-nudge-ai-chat: 402px;\n    --padding-nudge-ai-chat: 30px;\n    --gap-nudge-ai-chat: 18px;\n    --gap-nudge-ai-empty: 18px;\n    --size-nudge-ai-close: 24px;\n    --size-nudge-ai-icon-wrap: 54px;\n    --width-nudge-ai-empty: 390px;\n    --height-nudge-ai-composer: 44px;\n    --size-nudge-ai-send: 32px;\n    --size-nudge-ai-thumb: 32px;\n    --padding-nudge-ai-composer-x: 8px;\n    --padding-nudge-ai-composer-y: 8px;\n    --gap-nudge-ai-composer: 6px;\n    --line-height-nudge-ai-prompt: 16px;\n    --radius-nudge-ai-composer: 12px;\n    --radius-nudge-ai-icon-wrap: 12px;\n    --size-nudge-ai-upload: 44px;\n    --size-nudge-ai-upload-lg: 64px;\n    --size-nudge-ai-creating: 210px;\n    --radius-nudge-ai-creating: 18px;\n    --padding-nudge-ai-creating: 15px;\n    --height-nudge-ai-segment: 28px;\n    --padding-nudge-ai-segment: 2px;\n    --padding-nudge-ai-segment-x: 9px;\n    --padding-nudge-ai-media-actions: 8px;\n    --gap-nudge-ai-media-actions: 6px;\n    --padding-nudge-media-ai: 30px 24px 24px;\n    --gap-nudge-media-ai: 12px;\n    --radius-nudge-media-ai: 8px;\n    --size-nudge-media-ai-icon: 36px;\n    --height-nudge-media-start: 36px;\n    --padding-nudge-media-start-x: 16px;\n    --gap-nudge-media-start: 6px;\n    --gap-nudge-media-stack: 18px;\n    --gap-nudge-media-or: 9px;\n    --size-nudge-media-close: 18px;\n    --height-nudge-media-source: 44px;\n    --padding-nudge-media-source-x: 18px;\n    --gap-nudge-media-source: 12px;\n    --gap-nudge-media-sources: 9px;\n    --radius-nudge-media-source: 6px;\n    --size-nudge-ai-launcher: 32px;\n    --size-nudge-ai-launcher-dot: 5px;\n  }\n  .nudge-picker.ant-picker {\n    padding: 8px;\n  }\n\n  .nudge-ai-source-option {\n    font-size: 12px;\n    line-height: 16px;\n  }\n}\n\n@media (max-width: 767px) {\n  :root {\n    --space-page: 24px;\n    --space-section: 16px;\n    --space-form: 16px;\n    --space-field: 10px;\n    --text-heading-lg: 20px;\n    --text-heading-md: 16px;\n    --text-body: 14px;\n    --text-base: 14px;\n    --text-sm: 10px;\n    --text-caption: 8px;\n    --line-height-caption: 11px;\n    --line-height-body-xs: 14px;\n    --space-business-results: 8px;\n    --space-business-result-row: 2px;\n    --space-business-detail-section: 10px;\n    --space-business-actions: 8px;\n    --radius-field: 4px;\n    --radius-card: 8px;\n    --radius-welcome-card: 6px;\n    --radius-dashboard-post: 6px;\n    --radius-post-overlay: 3px;\n    --icon-sm: 10px;\n    --icon-md: 12px;\n    --icon-lg: 14px;\n    --icon-xl: 18px;\n    --input-height: 44px;\n    --height-feed-create-post-modal: 408px;\n    --width-feed-create-select-btn: 117px;\n    --width-feed-create-caption-modal: 744px;\n    --height-feed-create-caption-content: 373px;\n    --width-feed-gallery-modal: 100%;\n    --height-feed-gallery-grid: 60vh;\n    --height-feed-cover-stage: 220px;\n    --height-feed-cover-filmstrip: 44px;\n    --width-feed-cover-preview: 120px;\n    --height-feed-cover-preview: 150px;\n    --width-feed-aspect-ratio-panel: 123px;\n    --size-feed-overlay-icon: 13px;\n    --radius-feed-caption-modal: 8px;\n    --width-feed-emoji-picker: 100%;\n    --height-feed-emoji-picker: 220px;\n    --width-feed-detail-modal: 100%;\n    --height-feed-detail-modal: auto;\n    --width-feed-detail-media: 100%;\n    --width-feed-detail-sidebar: 100%;\n    --size-feed-detail-nav: 44px;\n    --height-dashboard-logo: 28px;\n    --width-dashboard-logo: 160px;\n    --icon-nav: 12px;\n    --size-notification-badge: 16px;\n    --text-notification-badge: 10px;\n    --offset-notification-badge: -4px;\n    --width-business-switcher: 100%;\n    --width-profile-form: 100%;\n    --height-profile-field: 44px;\n    --width-nudge-ai-btn: 120px;\n    --height-nudge-ai-btn: 44px;\n    --padding-nudge-ai-btn-y: 6px;\n    --padding-nudge-ai-btn-x: 12px;\n    --gap-nudge-ai-btn: 2px;\n    --padding-nudge-ai-chat: 24px;\n    --gap-nudge-ai-chat: 16px;\n    --gap-nudge-ai-empty: 16px;\n    --size-nudge-ai-close: 24px;\n    --size-nudge-ai-icon-wrap: 48px;\n    --width-nudge-ai-empty: 100%;\n    --height-nudge-ai-composer: 44px;\n    --size-nudge-ai-send: 32px;\n    --size-nudge-ai-thumb: 32px;\n    --padding-nudge-ai-composer-x: 8px;\n    --padding-nudge-ai-composer-y: 8px;\n    --gap-nudge-ai-composer: 4px;\n    --line-height-nudge-ai-prompt: 16px;\n    --radius-nudge-ai-composer: 8px;\n    --radius-nudge-ai-icon-wrap: 8px;\n    --size-nudge-ai-upload: 44px;\n    --size-nudge-ai-upload-lg: 56px;\n    --size-nudge-ai-creating: 168px;\n    --radius-nudge-ai-creating: 16px;\n    --padding-nudge-ai-creating: 12px;\n    --height-nudge-ai-segment: 28px;\n    --padding-nudge-ai-segment: 2px;\n    --padding-nudge-ai-segment-x: 8px;\n    --padding-nudge-ai-media-actions: 8px;\n    --gap-nudge-ai-media-actions: 6px;\n    --padding-nudge-media-ai: 24px 16px 16px;\n    --gap-nudge-media-ai: 12px;\n    --radius-nudge-media-ai: 8px;\n    --size-nudge-media-ai-icon: 32px;\n    --height-nudge-media-start: 32px;\n    --padding-nudge-media-start-x: 16px;\n    --gap-nudge-media-start: 6px;\n    --gap-nudge-media-stack: 16px;\n    --gap-nudge-media-or: 8px;\n    --size-nudge-media-close: 18px;\n    --height-nudge-media-source: 44px;\n    --padding-nudge-media-source-x: 12px;\n    --gap-nudge-media-source: 8px;\n    --gap-nudge-media-sources: 8px;\n    --radius-nudge-media-source: 4px;\n    --size-nudge-ai-launcher: 36px;\n    --size-nudge-ai-launcher-dot: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
